(() => {

/*
 * HSCopyMarkup
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ const $478cf65b5d671095$export$70f24959ef00553b = (string)=>{
    return string === "true" ? true : false;
};
const $478cf65b5d671095$export$11a826c585352eb8 = (el, prop, val = "")=>{
    return (window.getComputedStyle(el).getPropertyValue(prop) || val).replace(" ", "");
};
const $478cf65b5d671095$export$315f1f5a8da35a59 = (el, prop, val = "")=>{
    let targetClass = "";
    el.classList.forEach((c)=>{
        if (c.includes(prop)) targetClass = c;
    });
    return targetClass.match(/:(.*)]/) ? targetClass.match(/:(.*)]/)[1] : val;
};
// const getClassPropertyAlt = (
// 	el: HTMLElement,
// 	prop: string,
// 	val: string = '',
// ): string => {
// 	let targetClass = '';
// 	el.classList.forEach((className) => {
// 		if (className.includes(prop)) {
// 			targetClass = className;
// 		}
// 	});
// 	const match = targetClass.match(/:(.*)/);
// 	return match ? match[1] : val;
// };
const $478cf65b5d671095$export$fedb369cb70207f1 = ()=>{
    if (/iPad|iPhone|iPod/.test(navigator.platform)) return true;
    else return navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
};
const $478cf65b5d671095$export$363474031fa64020 = ()=>{
    return navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
};
const $478cf65b5d671095$export$e3db11022a3681e4 = (el, toggle, preferredPosition = "auto", space = 10, wrapper = null)=>{
    const referenceRect = toggle.getBoundingClientRect();
    const wrapperRect = wrapper ? wrapper.getBoundingClientRect() : null;
    const viewportHeight = window.innerHeight;
    const spaceAbove = wrapperRect ? referenceRect.top - wrapperRect.top : referenceRect.top;
    const spaceBelow = (wrapper ? wrapperRect.bottom : viewportHeight) - referenceRect.bottom;
    const minimumSpaceRequired = el.clientHeight + space;
    if (preferredPosition === "bottom") return spaceBelow >= minimumSpaceRequired;
    else if (preferredPosition === "top") return spaceAbove >= minimumSpaceRequired;
    else return spaceAbove >= minimumSpaceRequired || spaceBelow >= minimumSpaceRequired;
};
const $478cf65b5d671095$export$5da71380ac3cd382 = (target)=>{
    return target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement;
};
const $478cf65b5d671095$export$82366544b9d4ab15 = (element)=>{
    if (!element) return false;
    const computedStyle = window.getComputedStyle(element);
    if (computedStyle.display === "none") return true;
    return $478cf65b5d671095$export$82366544b9d4ab15(element.parentElement);
};
const $478cf65b5d671095$export$61fc7d43ac8f84b0 = (func, timeout = 200)=>{
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            func.apply(undefined, args);
        }, timeout);
    };
};
const $478cf65b5d671095$export$635e15bbd66f01ea = (evt, element, payload = null)=>{
    const event = new CustomEvent(evt, {
        detail: {
            payload: payload
        },
        bubbles: true,
        cancelable: true,
        composed: false
    });
    element.dispatchEvent(event);
};
const $478cf65b5d671095$export$24d4b3961cffb4db = (el, callback)=>{
    const handleEvent = ()=>{
        callback();
        el.removeEventListener("transitionend", handleEvent, true);
    };
    const hasTransition = window.getComputedStyle(el, null).getPropertyValue("transition") !== (navigator.userAgent.includes("Firefox") ? "all" : "all 0s ease 0s");
    if (hasTransition) el.addEventListener("transitionend", handleEvent, true);
    else callback();
};
const $478cf65b5d671095$export$c5c738da9ba7f9f = (html)=>{
    const template = document.createElement("template");
    html = html.trim();
    template.innerHTML = html;
    return template.content.firstChild;
};
const $478cf65b5d671095$export$a73398b198c9e798 = (classes, target, splitter = " ", action = "add")=>{
    const classesToArray = classes.split(splitter);
    classesToArray.forEach((cl)=>action === "add" ? target.classList.add(cl) : target.classList.remove(cl));
};
const $478cf65b5d671095$export$23c7272ae11663ba = {
    historyIndex: -1,
    addHistory (index) {
        this.historyIndex = index;
    },
    existsInHistory (index) {
        return index > this.historyIndex;
    },
    clearHistory () {
        this.historyIndex = -1;
    }
};


/*
 * HSBasePlugin
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ class $0288c6577afded82$export$2e2bcd8739ae039 {
    constructor(el, options, events){
        this.el = el;
        this.options = options;
        this.events = events;
        this.el = el;
        this.options = options;
        this.events = {};
    }
    createCollection(collection, element) {
        collection.push({
            id: element?.el?.id || collection.length + 1,
            element: element
        });
    }
    fireEvent(evt, payload = null) {
        if (this.events.hasOwnProperty(evt)) return this.events[evt](payload);
    }
    on(evt, cb) {
        this.events[evt] = cb;
    }
}


class $0c306a747591bace$var$HSCopyMarkup extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-copy-markup");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.targetSelector = concatOptions?.targetSelector || null;
        this.wrapperSelector = concatOptions?.wrapperSelector || null;
        this.limit = concatOptions?.limit || null;
        this.items = [];
        if (this.targetSelector) this.init();
    }
    init() {
        this.createCollection(window.$hsCopyMarkupCollection, this);
        this.setTarget();
        this.setWrapper();
        this.addPredefinedItems();
        this.el.addEventListener("click", ()=>this.copy());
    }
    copy() {
        if (this.limit && this.items.length >= this.limit) return false;
        if (this.el.hasAttribute("disabled")) this.el.setAttribute("disabled", "");
        const copiedElement = this.target.cloneNode(true);
        this.addToItems(copiedElement);
        if (this.limit && this.items.length >= this.limit) this.el.setAttribute("disabled", "disabled");
        this.fireEvent("copy", copiedElement);
        (0, $478cf65b5d671095$export$635e15bbd66f01ea)("copy.hs.copyMarkup", copiedElement, copiedElement);
    }
    addPredefinedItems() {
        Array.from(this.wrapper.children).filter((el)=>!el.classList.contains("[--ignore-for-count]")).forEach((el)=>{
            this.addToItems(el);
        });
    }
    setTarget() {
        const target = typeof this.targetSelector === "string" ? document.querySelector(this.targetSelector).cloneNode(true) : this.targetSelector.cloneNode(true);
        target.removeAttribute("id");
        this.target = target;
    }
    setWrapper() {
        this.wrapper = typeof this.wrapperSelector === "string" ? document.querySelector(this.wrapperSelector) : this.wrapperSelector;
    }
    addToItems(item) {
        const deleteItemButton = item.querySelector("[data-hs-copy-markup-delete-item]");
        if (this.wrapper) this.wrapper.append(item);
        else this.el.before(item);
        if (deleteItemButton) deleteItemButton.addEventListener("click", ()=>this.delete(item));
        this.items.push(item);
    }
    // Public methods
    delete(target) {
        const index = this.items.indexOf(target);
        if (index !== -1) this.items.splice(index, 1);
        target.remove();
        this.fireEvent("delete", target);
        (0, $478cf65b5d671095$export$635e15bbd66f01ea)("delete.hs.copyMarkup", target, target);
    }
    // Static method
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsCopyMarkupCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsCopyMarkupCollection) window.$hsCopyMarkupCollection = [];
        document.querySelectorAll("[data-hs-copy-markup]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsCopyMarkupCollection.find((elC)=>elC?.element?.el === el)) {
                const data = el.getAttribute("data-hs-copy-markup");
                const options = data ? JSON.parse(data) : {};
                new $0c306a747591bace$var$HSCopyMarkup(el, options);
            }
        });
    }
}
window.addEventListener("load", ()=>{
    $0c306a747591bace$var$HSCopyMarkup.autoInit();
// Uncomment for debug
// console.log('Copy markup collection:', window.$hsCopyMarkupCollection);
});
if (typeof window !== "undefined") window.HSCopyMarkup = $0c306a747591bace$var$HSCopyMarkup;
var $0c306a747591bace$export$2e2bcd8739ae039 = $0c306a747591bace$var$HSCopyMarkup;


/*
 * HSAccordion
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 

class $fdf3273b082fdf99$var$HSAccordion extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options, events){
        super(el, options, events);
        this.toggle = this.el.querySelector(".hs-accordion-toggle") || null;
        this.content = this.el.querySelector(".hs-accordion-content") || null;
        this.group = this.el.closest(".hs-accordion-group") || null;
        this.isAlwaysOpened = this.group.hasAttribute("data-hs-accordion-always-open") || false;
        if (this.toggle && this.content) this.init();
    }
    init() {
        this.createCollection(window.$hsAccordionCollection, this);
        this.toggle.addEventListener("click", ()=>{
            if (this.el.classList.contains("active")) this.hide();
            else this.show();
        });
    }
    // Public methods
    show() {
        if (this.group && !this.isAlwaysOpened && this.group.querySelector(".hs-accordion.active") && this.group.querySelector(".hs-accordion.active") !== this.el) {
            const currentlyOpened = window.$hsAccordionCollection.find((el)=>el.element.el === this.group.querySelector(".hs-accordion.active"));
            currentlyOpened.element.hide();
        }
        if (this.el.classList.contains("active")) return false;
        this.el.classList.add("active");
        this.content.style.display = "block";
        this.content.style.height = "0";
        setTimeout(()=>{
            this.content.style.height = `${this.content.scrollHeight}px`;
        });
        (0, $478cf65b5d671095$export$24d4b3961cffb4db)(this.content, ()=>{
            this.content.style.display = "block";
            this.content.style.height = "";
            this.fireEvent("open", this.el);
            (0, $478cf65b5d671095$export$635e15bbd66f01ea)("open.hs.accordion", this.el, this.el);
        });
    }
    hide() {
        if (!this.el.classList.contains("active")) return false;
        this.el.classList.remove("active");
        this.content.style.height = `${this.content.scrollHeight}px`;
        setTimeout(()=>{
            this.content.style.height = "0";
        });
        (0, $478cf65b5d671095$export$24d4b3961cffb4db)(this.content, ()=>{
            this.content.style.display = "";
            this.content.style.height = "0";
            this.fireEvent("close", this.el);
            (0, $478cf65b5d671095$export$635e15bbd66f01ea)("close.hs.accordion", this.el, this.el);
        });
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsAccordionCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element.el : null;
    }
    static show(target) {
        const elInCollection = window.$hsAccordionCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && elInCollection.element.content.style.display !== "block") elInCollection.element.show();
    }
    static hide(target) {
        const elInCollection = window.$hsAccordionCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && elInCollection.element.content.style.display === "block") elInCollection.element.hide();
    }
    static autoInit() {
        if (!window.$hsAccordionCollection) window.$hsAccordionCollection = [];
        document.querySelectorAll(".hs-accordion:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsAccordionCollection.find((elC)=>elC?.element?.el === el)) new $fdf3273b082fdf99$var$HSAccordion(el);
        });
    }
    // Backward compatibility
    static on(evt, target, cb) {
        const elInCollection = window.$hsAccordionCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection) elInCollection.element.events[evt] = cb;
    }
}
window.addEventListener("load", ()=>{
    $fdf3273b082fdf99$var$HSAccordion.autoInit();
// Uncomment for debug
// console.log('Accordion collection:', window.$hsAccordionCollection);
});
if (typeof window !== "undefined") window.HSAccordion = $fdf3273b082fdf99$var$HSAccordion;
var $fdf3273b082fdf99$export$2e2bcd8739ae039 = $fdf3273b082fdf99$var$HSAccordion;


/*
 * HSCarousel
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 
class $21e0b253669cf069$var$HSCarousel extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-carousel");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.currentIndex = concatOptions.currentIndex || 0;
        this.loadingClasses = concatOptions.loadingClasses ? `${concatOptions.loadingClasses}`.split(",") : null;
        this.loadingClassesRemove = this.loadingClasses?.[0] ? this.loadingClasses[0].split(" ") : "opacity-0";
        this.loadingClassesAdd = this.loadingClasses?.[1] ? this.loadingClasses[1].split(" ") : "";
        this.afterLoadingClassesAdd = this.loadingClasses?.[2] ? this.loadingClasses[2].split(" ") : "";
        this.isAutoPlay = typeof concatOptions.isAutoPlay !== "undefined" ? concatOptions.isAutoPlay : false;
        this.speed = concatOptions.speed || 4000;
        this.isInfiniteLoop = typeof concatOptions.isInfiniteLoop !== "undefined" ? concatOptions.isInfiniteLoop : true;
        this.inner = this.el.querySelector(".hs-carousel-body") || null;
        this.slides = this.el.querySelectorAll(".hs-carousel-slide") || [];
        this.prev = this.el.querySelector(".hs-carousel-prev") || null;
        this.next = this.el.querySelector(".hs-carousel-next") || null;
        this.dots = this.el.querySelectorAll(".hs-carousel-pagination > *") || null;
        this.sliderWidth = this.inner.parentElement.clientWidth;
        // Touch events' help variables
        this.touchX = {
            start: 0,
            end: 0
        };
        this.init();
    }
    init() {
        this.createCollection(window.$hsCarouselCollection, this);
        if (this.inner) {
            this.calculateWidth();
            if (this.loadingClassesRemove) {
                if (typeof this.loadingClassesRemove === "string") this.inner.classList.remove(this.loadingClassesRemove);
                else this.inner.classList.remove(...this.loadingClassesRemove);
            }
            if (this.loadingClassesAdd) {
                if (typeof this.loadingClassesAdd === "string") this.inner.classList.add(this.loadingClassesAdd);
                else this.inner.classList.add(...this.loadingClassesAdd);
            }
        }
        if (this.prev) this.prev.addEventListener("click", ()=>{
            this.goToPrev();
            if (this.isAutoPlay) {
                this.resetTimer();
                this.setTimer();
            }
        });
        if (this.next) this.next.addEventListener("click", ()=>{
            this.goToNext();
            if (this.isAutoPlay) {
                this.resetTimer();
                this.setTimer();
            }
        });
        if (this.dots) this.dots.forEach((el, i)=>el.addEventListener("click", ()=>{
                this.goTo(i);
                if (this.isAutoPlay) {
                    this.resetTimer();
                    this.setTimer();
                }
            }));
        if (this.slides.length) {
            this.addCurrentClass();
            if (!this.isInfiniteLoop) this.addDisabledClass();
            if (this.isAutoPlay) this.autoPlay();
        }
        if (this.inner && this.afterLoadingClassesAdd) setTimeout(()=>{
            if (typeof this.afterLoadingClassesAdd === "string") this.inner.classList.add(this.afterLoadingClassesAdd);
            else this.inner.classList.add(...this.afterLoadingClassesAdd);
        });
        this.el.classList.add("init");
        this.el.addEventListener("touchstart", (evt)=>{
            this.touchX.start = evt.changedTouches[0].screenX;
        });
        this.el.addEventListener("touchend", (evt)=>{
            this.touchX.end = evt.changedTouches[0].screenX;
            this.detectDirection();
        });
        this.observeResize();
    }
    observeResize() {
        const resizeObserver = new ResizeObserver(()=>this.recalculateWidth());
        resizeObserver.observe(document.querySelector("body"));
    }
    calculateWidth() {
        // Set slider width
        this.inner.style.width = `${this.sliderWidth * this.slides.length}px`;
        this.inner.style.transform = `translate(-${this.currentIndex * this.sliderWidth}px, 0px)`;
        // Set width to each slide
        this.slides.forEach((el)=>{
            el.style.width = `${this.sliderWidth}px`;
        });
    }
    addCurrentClass() {
        this.slides.forEach((el, i)=>{
            if (i === this.currentIndex) el.classList.add("active");
            else el.classList.remove("active");
        });
        if (this.dots) this.dots.forEach((el, i)=>{
            if (i === this.currentIndex) el.classList.add("active");
            else el.classList.remove("active");
        });
    }
    addDisabledClass() {
        if (!this.prev || !this.next) return false;
        if (this.currentIndex === 0) {
            this.next.classList.remove("disabled");
            this.prev.classList.add("disabled");
        } else if (this.currentIndex === this.slides.length - 1) {
            this.prev.classList.remove("disabled");
            this.next.classList.add("disabled");
        } else {
            this.prev.classList.remove("disabled");
            this.next.classList.remove("disabled");
        }
    }
    autoPlay() {
        this.setTimer();
    }
    setTimer() {
        this.timer = setInterval(()=>{
            if (this.currentIndex === this.slides.length - 1) this.goTo(0);
            else this.goToNext();
        }, this.speed);
    }
    resetTimer() {
        clearInterval(this.timer);
    }
    detectDirection() {
        const { start: start, end: end } = this.touchX;
        if (end < start) this.goToNext();
        if (end > start) this.goToPrev();
    }
    // Public methods
    recalculateWidth() {
        this.sliderWidth = this.inner.parentElement.clientWidth;
        this.calculateWidth();
    }
    goToPrev() {
        if (this.currentIndex === 0 && this.isInfiniteLoop) {
            this.currentIndex = this.slides.length - 1;
            this.inner.style.transform = `translate(-${this.currentIndex * this.sliderWidth}px, 0px)`;
            this.addCurrentClass();
        } else if (this.currentIndex !== 0) {
            this.currentIndex -= 1;
            this.inner.style.transform = `translate(-${this.currentIndex * this.sliderWidth}px, 0px)`;
            this.addCurrentClass();
            this.addDisabledClass();
        }
    }
    goToNext() {
        if (this.currentIndex === this.slides.length - 1 && this.isInfiniteLoop) {
            this.currentIndex = 0;
            this.inner.style.transform = `translate(-${this.currentIndex * this.sliderWidth}px, 0px)`;
            this.addCurrentClass();
        } else if (this.currentIndex < this.slides.length - 1) {
            this.currentIndex += 1;
            this.inner.style.transform = `translate(-${this.currentIndex * this.sliderWidth}px, 0px)`;
            this.addCurrentClass();
            this.addDisabledClass();
        }
    }
    goTo(i) {
        this.currentIndex = i;
        this.inner.style.transform = `translate(-${this.currentIndex * this.sliderWidth}px, 0px)`;
        this.addCurrentClass();
        if (!this.isInfiniteLoop) this.addDisabledClass();
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsCarouselCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsCarouselCollection) window.$hsCarouselCollection = [];
        document.querySelectorAll("[data-hs-carousel]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsCarouselCollection.find((elC)=>elC?.element?.el === el)) new $21e0b253669cf069$var$HSCarousel(el);
        });
    }
}
window.addEventListener("load", ()=>{
    $21e0b253669cf069$var$HSCarousel.autoInit();
// Uncomment for debug
// console.log('Carousel collection:', window.$hsCarouselCollection);
});
window.addEventListener("resize", ()=>{
    if (!window.$hsCarouselCollection) return false;
    window.$hsCarouselCollection.forEach((el)=>{
        el.element.recalculateWidth();
    });
});
if (typeof window !== "undefined") window.HSCarousel = $21e0b253669cf069$var$HSCarousel;
var $21e0b253669cf069$export$2e2bcd8739ae039 = $21e0b253669cf069$var$HSCarousel;


/*
 * HSCollapse
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 

class $c33bd9274652961f$var$HSCollapse extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options, events){
        super(el, options, events);
        this.contentId = this.el.dataset.hsCollapse;
        this.content = document.querySelector(this.contentId);
        this.animationInProcess = false;
        if (this.content) this.init();
    }
    init() {
        this.createCollection(window.$hsCollapseCollection, this);
        this.el.addEventListener("click", ()=>{
            if (this.content.classList.contains("open")) this.hide();
            else this.show();
        });
    }
    hideAllMegaMenuItems() {
        this.content.querySelectorAll(".hs-mega-menu-content.block").forEach((el)=>{
            el.classList.remove("block");
            el.classList.add("hidden");
        });
    }
    // Public methods
    show() {
        if (this.animationInProcess || this.el.classList.contains("open")) return false;
        this.animationInProcess = true;
        this.el.classList.add("open");
        this.content.classList.add("open");
        this.content.classList.remove("hidden");
        this.content.style.height = "0";
        setTimeout(()=>{
            this.content.style.height = `${this.content.scrollHeight}px`;
            this.fireEvent("beforeOpen", this.el);
            (0, $478cf65b5d671095$export$635e15bbd66f01ea)("beforeOpen.hs.collapse", this.el, this.el);
        });
        (0, $478cf65b5d671095$export$24d4b3961cffb4db)(this.content, ()=>{
            this.content.style.height = "";
            this.fireEvent("open", this.el);
            (0, $478cf65b5d671095$export$635e15bbd66f01ea)("open.hs.collapse", this.el, this.el);
            this.animationInProcess = false;
        });
    }
    hide() {
        if (this.animationInProcess || !this.el.classList.contains("open")) return false;
        this.animationInProcess = true;
        this.el.classList.remove("open");
        this.content.style.height = `${this.content.scrollHeight}px`;
        setTimeout(()=>{
            this.content.style.height = "0";
        });
        this.content.classList.remove("open");
        (0, $478cf65b5d671095$export$24d4b3961cffb4db)(this.content, ()=>{
            this.content.classList.add("hidden");
            this.content.style.height = "";
            this.fireEvent("hide", this.el);
            (0, $478cf65b5d671095$export$635e15bbd66f01ea)("hide.hs.collapse", this.el, this.el);
            this.animationInProcess = false;
        });
        if (this.content.querySelectorAll(".hs-mega-menu-content.block").length) this.hideAllMegaMenuItems();
    }
    // Static methods
    static getInstance(target, isInstance = false) {
        const elInCollection = window.$hsCollapseCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element.el : null;
    }
    static autoInit() {
        if (!window.$hsCollapseCollection) window.$hsCollapseCollection = [];
        document.querySelectorAll(".hs-collapse-toggle:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsCollapseCollection.find((elC)=>elC?.element?.el === el)) new $c33bd9274652961f$var$HSCollapse(el);
        });
    }
    static show(target) {
        const elInCollection = window.$hsCollapseCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && elInCollection.element.content.classList.contains("hidden")) elInCollection.element.show();
    }
    static hide(target) {
        const elInCollection = window.$hsCollapseCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && !elInCollection.element.content.classList.contains("hidden")) elInCollection.element.hide();
    }
    // Backward compatibility
    static on(evt, target, cb) {
        const elInCollection = window.$hsCollapseCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection) elInCollection.element.events[evt] = cb;
    }
}
window.addEventListener("load", ()=>{
    $c33bd9274652961f$var$HSCollapse.autoInit();
// Uncomment for debug
// console.log('Collapse collection:', window.$hsCollapseCollection);
});
if (typeof window !== "undefined") window.HSCollapse = $c33bd9274652961f$var$HSCollapse;
var $c33bd9274652961f$export$2e2bcd8739ae039 = $c33bd9274652961f$var$HSCollapse;


/*
 * HSComboBox
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 

const $704e031c65277337$export$1a1f61c9c4dd9df0 = {
    auto: "auto",
    "auto-start": "auto-start",
    "auto-end": "auto-end",
    top: "top",
    "top-left": "top-start",
    "top-right": "top-end",
    bottom: "bottom",
    "bottom-left": "bottom-start",
    "bottom-right": "bottom-end",
    right: "right",
    "right-start": "right-start",
    "right-end": "right-end",
    left: "left",
    "left-start": "left-start",
    "left-end": "left-end"
};
const $704e031c65277337$export$ab14482922808af8 = [
    "Escape",
    "ArrowUp",
    "ArrowDown",
    "Home",
    "End",
    "Enter"
];
const $704e031c65277337$export$d563486924a41abc = [
    "Escape",
    "Tab"
];
const $704e031c65277337$export$8c1058a58d2daf41 = [
    "ArrowUp",
    "ArrowLeft",
    "ArrowDown",
    "ArrowRight",
    "Home",
    "End"
];
const $704e031c65277337$export$717c92bf60493a1c = [
    "ArrowUp",
    "ArrowLeft",
    "ArrowDown",
    "ArrowRight",
    "Home",
    "End",
    "Escape",
    "Enter",
    "Tab"
];
const $704e031c65277337$export$3ea3ef3aa4c9fb07 = [
    "ArrowUp",
    "ArrowLeft",
    "ArrowDown",
    "ArrowRight",
    "Home",
    "End",
    "Escape",
    "Enter"
];
const $704e031c65277337$export$426e07cd0772984d = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    "2xl": 1536
};


class $4dd20d6ee44ededb$var$HSComboBox extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options){
        super(el, options);
        // Data parameters
        const data = el.getAttribute("data-hs-combo-box");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.gap = 5;
        this.viewport = (typeof concatOptions?.viewport === "string" ? document.querySelector(concatOptions?.viewport) : concatOptions?.viewport) ?? null;
        this.preventVisibility = concatOptions?.preventVisibility ?? false;
        this.apiUrl = concatOptions?.apiUrl ?? null;
        this.apiDataPart = concatOptions?.apiDataPart ?? null;
        this.apiQuery = concatOptions?.apiQuery ?? null;
        this.apiSearchQuery = concatOptions?.apiSearchQuery ?? null;
        this.apiHeaders = concatOptions?.apiHeaders ?? {};
        this.apiGroupField = concatOptions?.apiGroupField ?? null;
        this.outputItemTemplate = concatOptions?.outputItemTemplate ?? `<div class="cursor-pointer py-2 px-4 w-full text-sm text-gray-800 hover:bg-gray-100 rounded-lg focus:outline-none focus:bg-gray-100 dark:bg-slate-900 dark:hover:bg-slate-800 dark:text-gray-200 dark:focus:bg-slate-800" data-hs-combo-box-output-item>
			<div class="flex justify-between items-center w-full">
				<span data-hs-combo-box-search-text></span>
				<span class="hidden hs-combo-box-selected:block">
					<svg class="flex-shrink-0 size-3.5 text-blue-600 dark:text-blue-500" xmlns="http:.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
						<polyline points="20 6 9 17 4 12"></polyline>
					</svg>
				</span>
			</div>
		</div>`;
        this.outputEmptyTemplate = concatOptions?.outputEmptyTemplate ?? `<div class="py-2 px-4 w-full text-sm text-gray-800 rounded-lg dark:bg-slate-900 dark:text-gray-200">Nothing found...</div>`;
        this.outputLoaderTemplate = concatOptions?.outputLoaderTemplate ?? `<div class="flex justify-center items-center py-2 px-4 text-sm text-gray-800 rounded-lg bg-white dark:bg-slate-900 dark:text-gray-200">
				<div class="animate-spin inline-block size-6 border-[3px] border-current border-t-transparent text-blue-600 rounded-full dark:text-blue-500" role="status" aria-label="loading">
					<span class="sr-only">Loading...</span>
				</div>
			</div>`;
        this.groupingType = concatOptions?.groupingType ?? null;
        this.groupingTitleTemplate = concatOptions?.groupingTitleTemplate ?? (this.groupingType === "default" ? `<div class="block mb-1 text-xs font-semibold uppercase text-blue-600 dark:text-blue-500"></div>` : `<button type="button" class="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-semibold whitespace-nowrap rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none"></button>`);
        this.tabsWrapperTemplate = concatOptions?.tabsWrapperTemplate ?? `<div class="overflow-x-auto p-4"></div>`;
        this.preventSelection = concatOptions?.preventSelection ?? false;
        this.isOpenOnFocus = concatOptions?.isOpenOnFocus ?? false;
        // Internal parameters
        this.input = this.el.querySelector("[data-hs-combo-box-input]") ?? null;
        this.output = this.el.querySelector("[data-hs-combo-box-output]") ?? null;
        this.itemsWrapper = this.el.querySelector("[data-hs-combo-box-output-items-wrapper]") ?? null;
        this.items = Array.from(this.el.querySelectorAll("[data-hs-combo-box-output-item]")) ?? [];
        this.tabs = [];
        this.toggle = this.el.querySelector("[data-hs-combo-box-toggle]") ?? null;
        this.outputPlaceholder = null;
        this.selected = this.value = this.el.querySelector("[data-hs-combo-box-input]").value ?? "";
        this.isOpened = false;
        this.isCurrent = false;
        this.animationInProcess = false;
        this.selectedGroup = "all";
        this.init();
    }
    init() {
        this.createCollection(window.$hsComboBoxCollection, this);
        this.build();
    }
    build() {
        this.buildInput();
        if (this.groupingType) this.setGroups();
        this.buildItems();
        if (this.preventVisibility) {
            this.isOpened = true;
            this.recalculateDirection();
        }
        if (this.toggle) this.buildToggle();
    }
    setResultAndRender(value = "") {
        this.setResults(value);
        if (this.apiSearchQuery) this.itemsFromJson();
    }
    buildInput() {
        if (this.isOpenOnFocus) this.input.addEventListener("focus", ()=>{
            if (!this.isOpened) {
                this.setResultAndRender();
                this.open();
            }
        });
        this.input.addEventListener("input", (0, $478cf65b5d671095$export$61fc7d43ac8f84b0)((evt)=>{
            this.setResultAndRender(evt.target.value);
            if (!this.isOpened) this.open();
        }));
    }
    buildItems() {
        if (this.apiUrl) this.itemsFromJson();
        else {
            if (this.itemsWrapper) this.itemsWrapper.innerHTML = "";
            else this.output.innerHTML = "";
            this.itemsFromHtml();
        }
    }
    setResults(val) {
        this.value = val;
        this.resultItems();
        if (this.hasVisibleItems()) this.destroyOutputPlaceholder();
        else this.buildOutputPlaceholder();
    }
    isItemExists(obj) {
        return this.items.some((el)=>Array.from(el.querySelectorAll("[data-hs-combo-box-search-text]")).some((elI)=>elI.getAttribute("data-hs-combo-box-search-text") === obj[elI.getAttribute("data-hs-combo-box-output-item-field")]));
    }
    isTextExists(el, val) {
        const lowerCased = val.map((v)=>v.toLowerCase());
        return Array.from(el.querySelectorAll("[data-hs-combo-box-search-text]")).some((elI)=>lowerCased.includes(elI.getAttribute("data-hs-combo-box-search-text").toLowerCase()));
    }
    isTextExistsAny(el, val) {
        return Array.from(el.querySelectorAll("[data-hs-combo-box-search-text]")).some((elI)=>elI.getAttribute("data-hs-combo-box-search-text").toLowerCase().includes(val.toLowerCase()));
    }
    valuesBySelector(el) {
        return Array.from(el.querySelectorAll("[data-hs-combo-box-search-text]")).reduce((acc, cur)=>[
                ...acc,
                cur.getAttribute("data-hs-combo-box-search-text")
            ], []);
    }
    buildOutputLoader() {
        if (this.outputLoader) return false;
        this.outputLoader = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(this.outputLoaderTemplate);
        if (this.items.length || this.outputPlaceholder) {
            this.outputLoader.style.position = "absolute";
            this.outputLoader.style.top = "0";
            this.outputLoader.style.bottom = "0";
            this.outputLoader.style.left = "0";
            this.outputLoader.style.right = "0";
            this.outputLoader.style.zIndex = "2";
        } else {
            this.outputLoader.style.position = "";
            this.outputLoader.style.top = "";
            this.outputLoader.style.bottom = "";
            this.outputLoader.style.left = "";
            this.outputLoader.style.right = "";
            this.outputLoader.style.zIndex = "";
            this.outputLoader.style.height = "30px";
        }
        this.output.append(this.outputLoader);
    }
    destroyOutputLoader() {
        if (this.outputLoader) this.outputLoader.remove();
        this.outputLoader = null;
    }
    async itemsFromJson() {
        this.buildOutputLoader();
        try {
            const query = `${this.apiQuery}`;
            const searchQuery = `${this.apiSearchQuery}=${this.value.toLowerCase()}`;
            let url = this.apiUrl;
            if (this.apiQuery && this.apiSearchQuery) url += `?${searchQuery}&${query}`;
            else if (this.apiQuery) url += `?${query}`;
            else if (this.apiSearchQuery) url += `?${searchQuery}`;
            const res = await fetch(url, this.apiHeaders);
            let items = await res.json();
            if (this.apiDataPart) items = items[this.apiDataPart];
            if (this.apiSearchQuery) this.items = [];
            if (this.itemsWrapper) this.itemsWrapper.innerHTML = "";
            else this.output.innerHTML = "";
            if (this.groupingType === "tabs") {
                this.setApiGroups(items);
                this.groupTabsRender();
                this.jsonItemsRender(items);
            } else if (this.groupingType === "default") {
                this.setApiGroups(items);
                this.groups.forEach((el)=>{
                    const title = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(this.groupingTitleTemplate);
                    title.setAttribute("data-hs-combo-box-group-title", el.name);
                    title.classList.add("--exclude-accessibility");
                    title.innerText = el.title;
                    const newItems = items.filter((i)=>i[this.apiGroupField] === el.name);
                    if (this.itemsWrapper) this.itemsWrapper.append(title);
                    else this.output.append(title);
                    this.jsonItemsRender(newItems);
                });
            } else this.jsonItemsRender(items);
            this.setResults(this.input.value);
        } catch (err) {
            console.error(err);
        }
        this.destroyOutputLoader();
    }
    jsonItemsRender(items) {
        items.forEach((item, index)=>{
            if (this.isItemExists(item)) return false;
            const newItem = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(this.outputItemTemplate);
            newItem.querySelectorAll("[data-hs-combo-box-search-text]").forEach((el)=>{
                el.textContent = item[el.getAttribute("data-hs-combo-box-output-item-field")] ?? "";
                el.setAttribute("data-hs-combo-box-search-text", item[el.getAttribute("data-hs-combo-box-output-item-field")] ?? "");
            });
            newItem.querySelectorAll("[data-hs-combo-box-output-item-attr]").forEach((el)=>{
                const attributes = JSON.parse(el.getAttribute("data-hs-combo-box-output-item-attr"));
                attributes.forEach((attr)=>{
                    el.setAttribute(attr.attr, item[attr.valueFrom]);
                });
            });
            newItem.setAttribute("tabIndex", `${index}`);
            if (this.groupingType === "tabs" || this.groupingType === "default") newItem.setAttribute("data-hs-combo-box-output-item", `{"group": {"name": "${item[this.apiGroupField]}", "title": "${item[this.apiGroupField]}"}}`);
            this.items = [
                ...this.items,
                newItem
            ];
            if (!this.preventSelection) newItem.addEventListener("click", ()=>{
                this.close(newItem.querySelector("[data-hs-combo-box-value]").getAttribute("data-hs-combo-box-search-text"));
                this.setSelectedByValue(this.valuesBySelector(newItem));
            });
            this.appendItemsToWrapper(newItem);
        });
    }
    setGroups() {
        const groups = [];
        this.items.forEach((item)=>{
            const { group: group } = JSON.parse(item.getAttribute("data-hs-combo-box-output-item"));
            if (!groups.some((el)=>el?.name === group.name)) groups.push(group);
        });
        this.groups = groups;
    }
    setCurrent() {
        if (window.$hsComboBoxCollection.length) {
            window.$hsComboBoxCollection.map((el)=>el.element.isCurrent = false);
            this.isCurrent = true;
        }
    }
    setApiGroups(items) {
        const groups = [];
        items.forEach((item)=>{
            const group = item[this.apiGroupField];
            if (!groups.some((el)=>el.name === group)) groups.push({
                name: group,
                title: group
            });
        });
        this.groups = groups;
    }
    sortItems() {
        const compareFn = (i1, i2)=>{
            const a = i1.querySelector("[data-hs-combo-box-value]").getAttribute("data-hs-combo-box-search-text");
            const b = i2.querySelector("[data-hs-combo-box-value]").getAttribute("data-hs-combo-box-search-text");
            if (a < b) return -1;
            else if (a > b) return 1;
            return 0;
        };
        return this.items.sort(compareFn);
    }
    itemRender(item) {
        const val = item.querySelector("[data-hs-combo-box-value]").getAttribute("data-hs-combo-box-search-text");
        if (this.itemsWrapper) this.itemsWrapper.append(item);
        else this.output.append(item);
        if (!this.preventSelection) item.addEventListener("click", ()=>{
            this.close(val);
            this.setSelectedByValue(this.valuesBySelector(item));
        });
    }
    plainRender(items) {
        items.forEach((item)=>{
            this.itemRender(item);
        });
    }
    groupTabsRender() {
        const tabsScroll = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(this.tabsWrapperTemplate);
        const tabsWrapper = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(`<div class="flex flex-nowrap gap-x-2"></div>`);
        tabsScroll.append(tabsWrapper);
        this.output.insertBefore(tabsScroll, this.output.firstChild);
        const tabDef = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(this.groupingTitleTemplate);
        tabDef.setAttribute("data-hs-combo-box-group-title", "all");
        tabDef.classList.add("--exclude-accessibility", "active");
        tabDef.innerText = "All";
        this.tabs = [
            ...this.tabs,
            tabDef
        ];
        tabsWrapper.append(tabDef);
        tabDef.addEventListener("click", ()=>{
            this.selectedGroup = "all";
            const selectedTab = this.tabs.find((elI)=>elI.getAttribute("data-hs-combo-box-group-title") === this.selectedGroup);
            this.tabs.forEach((el)=>el.classList.remove("active"));
            selectedTab.classList.add("active");
            this.setItemsVisibility();
        });
        this.groups.forEach((el)=>{
            const tab = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(this.groupingTitleTemplate);
            tab.setAttribute("data-hs-combo-box-group-title", el.name);
            tab.classList.add("--exclude-accessibility");
            tab.innerText = el.title;
            this.tabs = [
                ...this.tabs,
                tab
            ];
            tabsWrapper.append(tab);
            tab.addEventListener("click", ()=>{
                this.selectedGroup = el.name;
                const selectedTab = this.tabs.find((elI)=>elI.getAttribute("data-hs-combo-box-group-title") === this.selectedGroup);
                this.tabs.forEach((el)=>el.classList.remove("active"));
                selectedTab.classList.add("active");
                this.setItemsVisibility();
            });
        });
    }
    groupDefaultRender() {
        this.groups.forEach((el)=>{
            const title = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(this.groupingTitleTemplate);
            title.setAttribute("data-hs-combo-box-group-title", el.name);
            title.classList.add("--exclude-accessibility");
            title.innerText = el.title;
            if (this.itemsWrapper) this.itemsWrapper.append(title);
            else this.output.append(title);
            const items = this.sortItems().filter((f)=>{
                const { group: group } = JSON.parse(f.getAttribute("data-hs-combo-box-output-item"));
                return group.name === el.name;
            });
            this.plainRender(items);
        });
    }
    itemsFromHtml() {
        if (this.groupingType === "default") this.groupDefaultRender();
        else if (this.groupingType === "tabs") {
            const items = this.sortItems();
            this.groupTabsRender();
            this.plainRender(items);
        } else {
            const items = this.sortItems();
            this.plainRender(items);
        }
        this.setResults(this.input.value);
    }
    buildToggle() {
        this.toggle.addEventListener("click", ()=>{
            if (this.isOpened) this.close();
            else this.open(this.toggle.getAttribute("data-hs-combo-box-toggle"));
        });
    }
    setSelectedByValue(val) {
        this.items.forEach((el)=>{
            if (this.isTextExists(el, val)) el.classList.add("selected");
            else el.classList.remove("selected");
        });
    }
    setValue(val) {
        this.selected = val;
        this.value = val;
        this.input.value = val;
    }
    setItemsVisibility() {
        if (this.groupingType === "tabs" && this.selectedGroup !== "all") this.items.forEach((item)=>{
            item.style.display = "none";
        });
        const items = this.groupingType === "tabs" ? this.selectedGroup === "all" ? this.items : this.items.filter((f)=>{
            const { group: group } = JSON.parse(f.getAttribute("data-hs-combo-box-output-item"));
            return group.name === this.selectedGroup;
        }) : this.items;
        if (this.groupingType === "tabs" && this.selectedGroup !== "all") items.forEach((item)=>{
            item.style.display = "block";
        });
        items.forEach((item)=>{
            if (!this.isTextExistsAny(item, this.value)) item.style.display = "none";
            else item.style.display = "block";
        });
        if (this.groupingType === "default") this.output.querySelectorAll("[data-hs-combo-box-group-title]").forEach((el)=>{
            const g = el.getAttribute("data-hs-combo-box-group-title");
            const items = this.items.filter((f)=>{
                const { group: group } = JSON.parse(f.getAttribute("data-hs-combo-box-output-item"));
                return group.name === g && f.style.display === "block";
            });
            if (items.length) el.style.display = "block";
            else el.style.display = "none";
        });
    }
    hasVisibleItems() {
        return this.items.length ? this.items.some((el)=>el.style.display === "block") : false;
    }
    appendItemsToWrapper(item) {
        if (this.itemsWrapper) this.itemsWrapper.append(item);
        else this.output.append(item);
    }
    buildOutputPlaceholder() {
        if (!this.outputPlaceholder) this.outputPlaceholder = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(this.outputEmptyTemplate);
        this.appendItemsToWrapper(this.outputPlaceholder);
    }
    destroyOutputPlaceholder() {
        if (this.outputPlaceholder) this.outputPlaceholder.remove();
        this.outputPlaceholder = null;
    }
    resultItems() {
        if (!this.items.length) return false;
        this.setItemsVisibility();
        this.setSelectedByValue([
            this.selected
        ]);
    }
    // Public methods
    setValueAndOpen(val) {
        this.value = val;
        if (this.items.length) this.setItemsVisibility();
    }
    open(val) {
        if (this.animationInProcess) return false;
        if (typeof val !== "undefined") this.setValueAndOpen(val);
        if (this.preventVisibility) return false;
        this.animationInProcess = true;
        this.output.style.display = "block";
        this.recalculateDirection();
        setTimeout(()=>{
            this.el.classList.add("active");
            this.animationInProcess = false;
        });
        this.isOpened = true;
    }
    setValueAndClear(val) {
        if (val) this.setValue(val);
        else this.setValue(this.selected);
        if (this.outputPlaceholder) this.destroyOutputPlaceholder();
    }
    close(val) {
        if (this.animationInProcess) return false;
        if (this.preventVisibility) {
            this.setValueAndClear(val);
            return false;
        }
        this.animationInProcess = true;
        this.el.classList.remove("active");
        this.output.classList.remove("bottom-full", "top-full");
        this.output.style.marginTop = "";
        this.output.style.marginBottom = "";
        (0, $478cf65b5d671095$export$24d4b3961cffb4db)(this.output, ()=>{
            this.output.style.display = "none";
            this.setValueAndClear(val);
            this.animationInProcess = false;
        });
        this.isOpened = false;
    }
    recalculateDirection() {
        if ((0, $478cf65b5d671095$export$e3db11022a3681e4)(this.output, this.input, "bottom", this.gap, this.viewport)) {
            this.output.classList.remove("bottom-full");
            this.output.style.marginBottom = "";
            this.output.classList.add("top-full");
            this.output.style.marginTop = `${this.gap}px`;
        } else {
            this.output.classList.remove("top-full");
            this.output.style.marginTop = "";
            this.output.classList.add("bottom-full");
            this.output.style.marginBottom = `${this.gap}px`;
        }
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsComboBoxCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsComboBoxCollection) window.$hsComboBoxCollection = [];
        document.querySelectorAll("[data-hs-combo-box]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsComboBoxCollection.find((elC)=>elC?.element?.el === el)) {
                const data = el.getAttribute("data-hs-combo-box");
                const options = data ? JSON.parse(data) : {};
                new $4dd20d6ee44ededb$var$HSComboBox(el, options);
            }
        });
        if (window.$hsComboBoxCollection) {
            window.addEventListener("click", (evt)=>{
                const evtTarget = evt.target;
                $4dd20d6ee44ededb$var$HSComboBox.closeCurrentlyOpened(evtTarget);
            });
            document.addEventListener("keydown", (evt)=>$4dd20d6ee44ededb$var$HSComboBox.accessibility(evt));
        }
    }
    static close(target) {
        const elInCollection = window.$hsComboBoxCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && elInCollection.element.isOpened) elInCollection.element.close();
    }
    static closeCurrentlyOpened(evtTarget = null) {
        if (!evtTarget.closest("[data-hs-combo-box].active")) {
            const currentlyOpened = window.$hsComboBoxCollection.filter((el)=>el.element.isOpened) || null;
            if (currentlyOpened) currentlyOpened.forEach((el)=>{
                el.element.close();
            });
        }
    }
    // Accessibility methods
    static getPreparedItems(isReversed = false, output) {
        if (!output) return null;
        const preparedItems = isReversed ? Array.from(output.querySelectorAll(":scope > *:not(.--exclude-accessibility)")).filter((el)=>el.style.display !== "none").reverse() : Array.from(output.querySelectorAll(":scope > *:not(.--exclude-accessibility)")).filter((el)=>el.style.display !== "none");
        const items = preparedItems.filter((el)=>!el.classList.contains("disabled"));
        return items;
    }
    static setHighlighted(prev, current, input) {
        current.focus();
        input.value = current.querySelector("[data-hs-combo-box-value]").getAttribute("data-hs-combo-box-search-text");
        if (prev) prev.classList.remove("hs-combo-box-output-item-highlighted");
        current.classList.add("hs-combo-box-output-item-highlighted");
    }
    static accessibility(evt) {
        const target = window.$hsComboBoxCollection.find((el)=>el.element.isOpened);
        if (target && (0, $704e031c65277337$export$3ea3ef3aa4c9fb07).includes(evt.code) && !evt.metaKey) switch(evt.code){
            case "Escape":
                evt.preventDefault();
                this.onEscape();
                break;
            case "ArrowUp":
                evt.preventDefault();
                this.onArrow();
                break;
            case "ArrowDown":
                evt.preventDefault();
                this.onArrow(false);
                break;
            case "Home":
                evt.preventDefault();
                this.onStartEnd();
                break;
            case "End":
                evt.preventDefault();
                this.onStartEnd(false);
                break;
            case "Enter":
                evt.preventDefault();
                this.onEnter(evt);
                break;
            default:
                break;
        }
    }
    static onEscape() {
        const target = window.$hsComboBoxCollection.find((el)=>!el.element.preventVisibility && el.element.isOpened);
        if (target) {
            target.element.close();
            target.element.input.blur();
        }
    }
    static onArrow(isArrowUp = true) {
        const target = window.$hsComboBoxCollection.find((el)=>el.element.preventVisibility ? el.element.isCurrent : el.element.isOpened);
        if (target) {
            const output = target.element.itemsWrapper ?? target.element.output;
            if (!output) return false;
            const items = $4dd20d6ee44ededb$var$HSComboBox.getPreparedItems(isArrowUp, output);
            const current = output.querySelector(".hs-combo-box-output-item-highlighted");
            let currentItem = null;
            if (!current) items[0].classList.add("hs-combo-box-output-item-highlighted");
            let currentInd = items.findIndex((el)=>el === current);
            if (currentInd + 1 < items.length) currentInd++;
            currentItem = items[currentInd];
            $4dd20d6ee44ededb$var$HSComboBox.setHighlighted(current, currentItem, target.element.input);
        }
    }
    static onStartEnd(isStart = true) {
        const target = window.$hsComboBoxCollection.find((el)=>el.element.preventVisibility ? el.element.isCurrent : el.element.isOpened);
        if (target) {
            const output = target.element.itemsWrapper ?? target.element.output;
            if (!output) return false;
            const items = $4dd20d6ee44ededb$var$HSComboBox.getPreparedItems(isStart, output);
            const current = output.querySelector(".hs-combo-box-output-item-highlighted");
            if (items.length) $4dd20d6ee44ededb$var$HSComboBox.setHighlighted(current, items[0], target.element.input);
        }
    }
    static onEnter(evt) {
        const target = evt.target;
        const opened = window.$hsComboBoxCollection.find(// ::TEST !el.element.preventVisibility && el.element.isOpened
        (el)=>!(0, $478cf65b5d671095$export$82366544b9d4ab15)(el.element.el) && el.element.isOpened);
        const link = opened.element.el.querySelector("a");
        if (target.hasAttribute("data-hs-combo-box-input")) {
            opened.element.close();
            target.blur();
        } else {
            if (!opened.element.preventSelection) opened.element.setSelectedByValue(opened.element.valuesBySelector(evt.target));
            if (opened.element.preventSelection && link) window.location.assign(link.getAttribute("href"));
            opened.element.close(!opened.element.preventSelection ? evt.target.querySelector("[data-hs-combo-box-value]").getAttribute("data-hs-combo-box-search-text") : null);
        }
    }
}
window.addEventListener("load", ()=>{
    $4dd20d6ee44ededb$var$HSComboBox.autoInit();
// Uncomment for debug
// console.log('ComboBox collection:', window.$hsComboBoxCollection);
});
document.addEventListener("scroll", ()=>{
    if (!window.$hsComboBoxCollection) return false;
    const target = window.$hsComboBoxCollection.find((el)=>el.element.isOpened);
    if (target) target.element.recalculateDirection();
});
if (typeof window !== "undefined") window.HSComboBox = $4dd20d6ee44ededb$var$HSComboBox;
var $4dd20d6ee44ededb$export$2e2bcd8739ae039 = $4dd20d6ee44ededb$var$HSComboBox;


/*
 * HSDropdown
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 
function $df9341392e6ed7b1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $d98cb23738a6d9d0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $d98cb23738a6d9d0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $d98cb23738a6d9d0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $7e23bad950468b82$export$8960430cfd85939f = Math.max;
var $7e23bad950468b82$export$96ec731ed4dcb222 = Math.min;
var $7e23bad950468b82$export$2077e0241d6afd3c = Math.round;



function $90ccbd5892233dd2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $993d40d65cc118cd$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
}


function $84019ab652aa921b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $993d40d65cc118cd$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $68a584be1dc90596$export$2e2bcd8739ae039(node) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $9102221f9e13ae54$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ca14c6927ef497ac$export$2e2bcd8739ae039(node) {
    if (node === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node) || !(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node)) return (0, $68a584be1dc90596$export$2e2bcd8739ae039)(node);
    else return (0, $9102221f9e13ae54$export$2e2bcd8739ae039)(node);
}


function $4f30cf0ce50e075e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $433af39bc2fae35d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $943aee5c7065ad53$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $84019ab652aa921b$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)).left + (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $41cae7042543c5d5$export$2e2bcd8739ae039(element) {
    return (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $18583dfdff147fd4$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $34abf65a06d63352$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $34abf65a06d63352$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent) && $34abf65a06d63352$var$isElementScaled(offsetParent);
    var documentElement = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ca14c6927ef497ac$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $30ced62b744c6cfe$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $17f6a21d28fc02f5$export$2e2bcd8739ae039(element) {
    if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $3eb5703c925e0e5d$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node) && (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(node)) return node;
    return $3eb5703c925e0e5d$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(node));
}





function $a621d360f1a81b88$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3eb5703c925e0e5d$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a621d360f1a81b88$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(target)));
}







function $6829c22fb01dde5a$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) >= 0;
}




function $a56b734280245ffb$var$getTrueOffsetParent(element) {
    if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a56b734280245ffb$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    if (isIE && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element);
    if ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a56b734280245ffb$export$2e2bcd8739ae039(element) {
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6829c22fb01dde5a$export$2e2bcd8739ae039)(offsetParent) && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $a56b734280245ffb$var$getContainingBlock(element) || window;
}


var $f5c54167a3c62105$export$1e95b668f3b82d = "top";
var $f5c54167a3c62105$export$40e543e69a8b3fbb = "bottom";
var $f5c54167a3c62105$export$79ffe56a765070d2 = "right";
var $f5c54167a3c62105$export$eabcd2c8791e7bf4 = "left";
var $f5c54167a3c62105$export$dfb5619354ba860 = "auto";
var $f5c54167a3c62105$export$aec2ce47c367b8c3 = [
    $f5c54167a3c62105$export$1e95b668f3b82d,
    $f5c54167a3c62105$export$40e543e69a8b3fbb,
    $f5c54167a3c62105$export$79ffe56a765070d2,
    $f5c54167a3c62105$export$eabcd2c8791e7bf4
];
var $f5c54167a3c62105$export$b3571188c770cc5a = "start";
var $f5c54167a3c62105$export$bd5df0f255a350f8 = "end";
var $f5c54167a3c62105$export$390fd549c5303b4d = "clippingParents";
var $f5c54167a3c62105$export$d7b7311ec04a3e8f = "viewport";
var $f5c54167a3c62105$export$ae5ab1c730825774 = "popper";
var $f5c54167a3c62105$export$ca50aac9f3ba507f = "reference";
var $f5c54167a3c62105$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f5c54167a3c62105$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []);
var $f5c54167a3c62105$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f5c54167a3c62105$export$aec2ce47c367b8c3, [
    $f5c54167a3c62105$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f5c54167a3c62105$export$421679a7c3d56e = "beforeRead";
var $f5c54167a3c62105$export$aafa59e2e03f2942 = "read";
var $f5c54167a3c62105$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $f5c54167a3c62105$export$c65e99957a05207c = "beforeMain";
var $f5c54167a3c62105$export$f22da7240b7add18 = "main";
var $f5c54167a3c62105$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f5c54167a3c62105$export$8d4d2d70e7d46032 = "beforeWrite";
var $f5c54167a3c62105$export$68d8715fc104d294 = "write";
var $f5c54167a3c62105$export$70a6e5159acce2e6 = "afterWrite";
var $f5c54167a3c62105$export$d087d3878fdf71d5 = [
    $f5c54167a3c62105$export$421679a7c3d56e,
    $f5c54167a3c62105$export$aafa59e2e03f2942,
    $f5c54167a3c62105$export$6964f6c886723980,
    $f5c54167a3c62105$export$c65e99957a05207c,
    $f5c54167a3c62105$export$f22da7240b7add18,
    $f5c54167a3c62105$export$bab79516f2d662fe,
    $f5c54167a3c62105$export$8d4d2d70e7d46032,
    $f5c54167a3c62105$export$68d8715fc104d294,
    $f5c54167a3c62105$export$70a6e5159acce2e6
];


function $0baf5472b5ad4a5a$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0baf5472b5ad4a5a$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0baf5472b5ad4a5a$var$order(modifiers); // order based on phase
    return (0, $f5c54167a3c62105$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b65b878009bf47f$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $46d929ffbbd3136a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b3c2fd6800546b4b$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $b3c2fd6800546b4b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $b3c2fd6800546b4b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b3c2fd6800546b4b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $b3c2fd6800546b4b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(reference) ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $0baf5472b5ad4a5a$export$2e2bcd8739ae039)((0, $46d929ffbbd3136a$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $34abf65a06d63352$export$2e2bcd8739ae039)(reference, (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b65b878009bf47f$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b3c2fd6800546b4b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b3c2fd6800546b4b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $ff355aafd082b0cd$var$passive = {
    passive: true
};
function $ff355aafd082b0cd$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $ff355aafd082b0cd$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $ff355aafd082b0cd$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $ff355aafd082b0cd$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $ff355aafd082b0cd$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ff355aafd082b0cd$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $ff355aafd082b0cd$var$effect,
    data: {}
};



function $afe288682115fde3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $7b08f0526e425773$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $b518c35b71cf930f$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $03cba2f7a1498b5f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $f5c54167a3c62105$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $f5c54167a3c62105$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $f5c54167a3c62105$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $f5c54167a3c62105$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $f5c54167a3c62105$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $f5c54167a3c62105$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $e92fb10df1450f31$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e92fb10df1450f31$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $e92fb10df1450f31$var$popperOffsets,
    data: {}
};










var $c8f8eadcf7685dc5$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c8f8eadcf7685dc5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $c8f8eadcf7685dc5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var sideY = (0, $f5c54167a3c62105$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(popper);
            if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || placement === (0, $f5c54167a3c62105$export$79ffe56a765070d2)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideY = (0, $f5c54167a3c62105$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || placement === (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideX = (0, $f5c54167a3c62105$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c8f8eadcf7685dc5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c8f8eadcf7685dc5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $c8f8eadcf7685dc5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c8f8eadcf7685dc5$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $c8f8eadcf7685dc5$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $83c1fc4c4e58d7dd$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $83c1fc4c4e58d7dd$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $83c1fc4c4e58d7dd$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $83c1fc4c4e58d7dd$var$applyStyles,
    effect: $83c1fc4c4e58d7dd$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $7c04da2e958a3fe8$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $f5c54167a3c62105$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7c04da2e958a3fe8$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $7c04da2e958a3fe8$var$offset
};


var $825ae98fe4f5d029$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $825ae98fe4f5d029$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $825ae98fe4f5d029$var$hash[matched];
    });
}



var $76c023b5f4bd6339$var$hash = {
    start: "end",
    end: "start"
};
function $76c023b5f4bd6339$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $76c023b5f4bd6339$var$hash[matched];
    });
}







function $7b0a0ce1fa68929f$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $993d40d65cc118cd$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $3e70615fb3e74824$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $7e23bad950468b82$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $d63950b756706495$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $b0d5f0927fb8bf5c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $631049efb60e96c6$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) ? (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $7b0a0ce1fa68929f$export$2e2bcd8739ae039)(element, strategy)) : (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) ? $631049efb60e96c6$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $3e70615fb3e74824$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $631049efb60e96c6$var$getClippingParents(element) {
    var clippingParents = (0, $a621d360f1a81b88$export$2e2bcd8739ae039)((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) ? (0, $a56b734280245ffb$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) && (0, $d63950b756706495$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $631049efb60e96c6$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $631049efb60e96c6$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $631049efb60e96c6$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $683c5e26d5f8bfe5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $387b887da02b7e69$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)(), paddingObject);
}


function $4d11a6decde23bf9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $f765731200b57f98$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $f5c54167a3c62105$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $f5c54167a3c62105$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? (0, $f5c54167a3c62105$export$ca50aac9f3ba507f) : (0, $f5c54167a3c62105$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $631049efb60e96c6$export$2e2bcd8739ae039)((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $f5c54167a3c62105$export$79ffe56a765070d2),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $f5c54167a3c62105$export$1e95b668f3b82d),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dbd70d4ba9902caa$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $f5c54167a3c62105$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $f5c54167a3c62105$export$368f9a87e87fa4e1) : (0, $f5c54167a3c62105$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $f5c54167a3c62105$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $afe288682115fde3$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $b1f32a1d9525a032$var$getExpandedFallbackPlacements(placement) {
    if ((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(placement);
    return [
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $b1f32a1d9525a032$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $b1f32a1d9525a032$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860) ? (0, $dbd70d4ba9902caa$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$b3571188c770cc5a);
        var isVertical = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $f5c54167a3c62105$export$79ffe56a765070d2) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b1f32a1d9525a032$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $b1f32a1d9525a032$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $d8b68132b61080af$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max) {
    return (0, $7e23bad950468b82$export$8960430cfd85939f)(min, (0, $7e23bad950468b82$export$96ec731ed4dcb222)(value, max));
}
function $b6f0b0266e764faa$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $3295dac8746ffe59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $d8b68132b61080af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $a56b734280245ffb$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? (0, $7e23bad950468b82$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $7e23bad950468b82$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $b6f0b0266e764faa$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3295dac8746ffe59$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $3295dac8746ffe59$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $1992f2d714808ab6$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
};
function $1992f2d714808ab6$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $1992f2d714808ab6$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $1992f2d714808ab6$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $d63950b756706495$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $1992f2d714808ab6$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $1992f2d714808ab6$var$arrow,
    effect: $1992f2d714808ab6$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $174d14927bb4f43b$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $174d14927bb4f43b$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $f5c54167a3c62105$export$1e95b668f3b82d),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2),
        (0, $f5c54167a3c62105$export$40e543e69a8b3fbb),
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $174d14927bb4f43b$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $174d14927bb4f43b$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $174d14927bb4f43b$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $174d14927bb4f43b$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $174d14927bb4f43b$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $174d14927bb4f43b$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $174d14927bb4f43b$var$hide
};




var $1bf0bf541303046d$export$d34966752335dd47 = [
    (0, $ff355aafd082b0cd$export$2e2bcd8739ae039),
    (0, $e92fb10df1450f31$export$2e2bcd8739ae039),
    (0, $c8f8eadcf7685dc5$export$2e2bcd8739ae039),
    (0, $83c1fc4c4e58d7dd$export$2e2bcd8739ae039),
    (0, $7c04da2e958a3fe8$export$2e2bcd8739ae039),
    (0, $b1f32a1d9525a032$export$2e2bcd8739ae039),
    (0, $3295dac8746ffe59$export$2e2bcd8739ae039),
    (0, $1992f2d714808ab6$export$2e2bcd8739ae039),
    (0, $174d14927bb4f43b$export$2e2bcd8739ae039)
];
var $1bf0bf541303046d$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b3c2fd6800546b4b$export$ed5e13716264f202)({
    defaultModifiers: $1bf0bf541303046d$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




class $3165a178822236d6$var$HSDropdown extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options, events){
        super(el, options, events);
        this.toggle = this.el.querySelector(":scope > .hs-dropdown-toggle") || this.el.children[0];
        this.menu = this.el.querySelector(":scope > .hs-dropdown-menu");
        this.eventMode = (0, $478cf65b5d671095$export$11a826c585352eb8)(this.el, "--trigger", "click");
        this.closeMode = (0, $478cf65b5d671095$export$11a826c585352eb8)(this.el, "--auto-close", "true");
        this.animationInProcess = false;
        if (this.toggle && this.menu) this.init();
    }
    init() {
        this.createCollection(window.$hsDropdownCollection, this);
        if (this.toggle.disabled) return false;
        this.toggle.addEventListener("click", ()=>this.onClickHandler());
        if (!(0, $478cf65b5d671095$export$fedb369cb70207f1)() && !(0, $478cf65b5d671095$export$363474031fa64020)()) {
            this.el.addEventListener("mouseenter", ()=>this.onMouseEnterHandler());
            this.el.addEventListener("mouseleave", ()=>this.onMouseLeaveHandler());
        }
    }
    resizeHandler() {
        this.eventMode = (0, $478cf65b5d671095$export$11a826c585352eb8)(this.el, "--trigger", "click");
    }
    onClickHandler() {
        if (this.el.classList.contains("open") && !this.menu.classList.contains("hidden")) this.close();
        else this.open();
    }
    onMouseEnterHandler() {
        if (this.eventMode !== "hover") return false;
        if (this.el._popper) this.forceClearState();
        if (!this.el.classList.contains("open") && this.menu.classList.contains("hidden")) this.open();
    }
    onMouseLeaveHandler() {
        if (this.eventMode !== "hover") return false;
        if (this.el.classList.contains("open") && !this.menu.classList.contains("hidden")) this.close();
    }
    destroyPopper() {
        this.menu.classList.remove("block");
        this.menu.classList.add("hidden");
        this.menu.style.inset = null;
        this.menu.style.position = null;
        if (this.el && this.el._popper) this.el._popper.destroy();
        this.animationInProcess = false;
    }
    absoluteStrategyModifiers() {
        return [
            {
                name: "applyStyles",
                fn: (data)=>{
                    const strategy = (window.getComputedStyle(this.el).getPropertyValue("--strategy") || "absolute").replace(" ", "");
                    const adaptive = (window.getComputedStyle(this.el).getPropertyValue("--adaptive") || "adaptive").replace(" ", "");
                    data.state.elements.popper.style.position = strategy;
                    data.state.elements.popper.style.transform = adaptive === "adaptive" ? data.state.styles.popper.transform : null;
                    data.state.elements.popper.style.top = null;
                    data.state.elements.popper.style.bottom = null;
                    data.state.elements.popper.style.left = null;
                    data.state.elements.popper.style.right = null;
                    data.state.elements.popper.style.margin = 0;
                }
            },
            {
                name: "computeStyles",
                options: {
                    adaptive: false
                }
            }
        ];
    }
    // Public methods
    open() {
        if (this.el.classList.contains("open")) return false;
        if (this.animationInProcess) return false;
        this.animationInProcess = true;
        const placement = (window.getComputedStyle(this.el).getPropertyValue("--placement") || "").replace(" ", "");
        const flip = (window.getComputedStyle(this.el).getPropertyValue("--flip") || "true").replace(" ", "");
        const strategy = (window.getComputedStyle(this.el).getPropertyValue("--strategy") || "fixed").replace(" ", "");
        const offset = parseInt((window.getComputedStyle(this.el).getPropertyValue("--offset") || "10").replace(" ", ""));
        if (strategy !== "static") this.el._popper = (0, $1bf0bf541303046d$export$8f7491d57c8f97a9)(this.el, this.menu, {
            placement: (0, $704e031c65277337$export$1a1f61c9c4dd9df0)[placement] || "bottom-start",
            strategy: strategy,
            modifiers: [
                ...strategy !== "fixed" ? this.absoluteStrategyModifiers() : [],
                {
                    name: "flip",
                    enabled: flip === "true"
                },
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            offset
                        ]
                    }
                }
            ]
        });
        this.menu.style.margin = null;
        this.menu.classList.remove("hidden");
        this.menu.classList.add("block");
        setTimeout(()=>{
            this.el.classList.add("open");
            this.animationInProcess = false;
        });
        this.fireEvent("open", this.el);
        (0, $478cf65b5d671095$export$635e15bbd66f01ea)("open.hs.dropdown", this.el, this.el);
    }
    close(isAnimated = true) {
        if (this.animationInProcess || !this.el.classList.contains("open")) return false;
        this.animationInProcess = true;
        if (isAnimated) {
            const el = this.el.querySelector("[data-hs-dropdown-transition]") || this.menu;
            (0, $478cf65b5d671095$export$24d4b3961cffb4db)(el, ()=>this.destroyPopper());
        } else this.destroyPopper();
        this.menu.style.margin = null;
        this.el.classList.remove("open");
        this.fireEvent("close", this.el);
        (0, $478cf65b5d671095$export$635e15bbd66f01ea)("close.hs.dropdown", this.el, this.el);
    }
    forceClearState() {
        this.destroyPopper();
        this.menu.style.margin = null;
        this.el.classList.remove("open");
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsDropdownCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element.el : null;
    }
    static autoInit() {
        if (!window.$hsDropdownCollection) window.$hsDropdownCollection = [];
        document.querySelectorAll(".hs-dropdown:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsDropdownCollection.find((elC)=>elC?.element?.el === el)) new $3165a178822236d6$var$HSDropdown(el);
        });
        if (window.$hsDropdownCollection) {
            document.addEventListener("keydown", (evt)=>$3165a178822236d6$var$HSDropdown.accessibility(evt));
            window.addEventListener("click", (evt)=>{
                const evtTarget = evt.target;
                $3165a178822236d6$var$HSDropdown.closeCurrentlyOpened(evtTarget);
            });
            let prevWidth = window.innerWidth;
            window.addEventListener("resize", ()=>{
                if (window.innerWidth !== prevWidth) {
                    prevWidth = innerWidth;
                    $3165a178822236d6$var$HSDropdown.closeCurrentlyOpened(null, false);
                }
            });
        }
    }
    static open(target) {
        const elInCollection = window.$hsDropdownCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && elInCollection.element.menu.classList.contains("hidden")) elInCollection.element.open();
    }
    static close(target) {
        const elInCollection = window.$hsDropdownCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && !elInCollection.element.menu.classList.contains("hidden")) elInCollection.element.close();
    }
    // Accessibility methods
    static accessibility(evt) {
        this.history = (0, $478cf65b5d671095$export$23c7272ae11663ba);
        const target = window.$hsDropdownCollection.find((el)=>el.element.el.classList.contains("open"));
        if (target && ((0, $704e031c65277337$export$ab14482922808af8).includes(evt.code) || evt.code.length === 4 && evt.code[evt.code.length - 1].match(/^[A-Z]*$/)) && !evt.metaKey && !target.element.menu.querySelector("input:focus")) switch(evt.code){
            case "Escape":
                if (!target.element.menu.querySelector(".hs-select.active")) {
                    evt.preventDefault();
                    this.onEscape(evt);
                }
                break;
            case "Enter":
                if (!target.element.menu.querySelector(".hs-select button:focus") && !target.element.menu.querySelector(".hs-collapse-toggle:focus")) this.onEnter(evt);
                break;
            case "ArrowUp":
                evt.preventDefault();
                this.onArrow();
                break;
            case "ArrowDown":
                evt.preventDefault();
                this.onArrow(false);
                break;
            case "Home":
                evt.preventDefault();
                this.onStartEnd();
                break;
            case "End":
                evt.preventDefault();
                this.onStartEnd(false);
                break;
            default:
                evt.preventDefault();
                this.onFirstLetter(evt.key);
                break;
        }
    }
    static onEscape(evt) {
        const dropdown = evt.target.closest(".hs-dropdown.open");
        if (window.$hsDropdownCollection.find((el)=>el.element.el === dropdown)) {
            const target = window.$hsDropdownCollection.find((el)=>el.element.el === dropdown);
            if (target) {
                target.element.close();
                target.element.toggle.focus();
            }
        } else this.closeCurrentlyOpened();
    }
    static onEnter(evt) {
        const dropdown = evt.target.parentElement;
        if (window.$hsDropdownCollection.find((el)=>el.element.el === dropdown)) {
            evt.preventDefault();
            const target = window.$hsDropdownCollection.find((el)=>el.element.el === dropdown);
            if (target) target.element.open();
        }
    }
    static onArrow(isArrowUp = true) {
        const target = window.$hsDropdownCollection.find((el)=>el.element.el.classList.contains("open"));
        if (target) {
            const menu = target.element.menu;
            if (!menu) return false;
            const preparedLinks = isArrowUp ? Array.from(menu.querySelectorAll("a:not([hidden]), .hs-dropdown > button:not([hidden])")).reverse() : Array.from(menu.querySelectorAll("a:not([hidden]), .hs-dropdown > button:not([hidden])"));
            const links = preparedLinks.filter((el)=>!el.classList.contains("disabled"));
            const current = menu.querySelector("a:focus, button:focus");
            let currentInd = links.findIndex((el)=>el === current);
            if (currentInd + 1 < links.length) currentInd++;
            links[currentInd].focus();
        }
    }
    static onStartEnd(isStart = true) {
        const target = window.$hsDropdownCollection.find((el)=>el.element.el.classList.contains("open"));
        if (target) {
            const menu = target.element.menu;
            if (!menu) return false;
            const preparedLinks = isStart ? Array.from(menu.querySelectorAll("a")) : Array.from(menu.querySelectorAll("a")).reverse();
            const links = preparedLinks.filter((el)=>!el.classList.contains("disabled"));
            if (links.length) links[0].focus();
        }
    }
    static onFirstLetter(code) {
        const target = window.$hsDropdownCollection.find((el)=>el.element.el.classList.contains("open"));
        if (target) {
            const menu = target.element.menu;
            if (!menu) return false;
            const links = Array.from(menu.querySelectorAll("a"));
            const getCurrentInd = ()=>links.findIndex((el, i)=>el.innerText.toLowerCase().charAt(0) === code.toLowerCase() && this.history.existsInHistory(i));
            let currentInd = getCurrentInd();
            if (currentInd === -1) {
                this.history.clearHistory();
                currentInd = getCurrentInd();
            }
            if (currentInd !== -1) {
                links[currentInd].focus();
                this.history.addHistory(currentInd);
            }
        }
    }
    static closeCurrentlyOpened(evtTarget = null, isAnimated = true) {
        const parent = evtTarget && evtTarget.closest(".hs-dropdown") && evtTarget.closest(".hs-dropdown").parentElement.closest(".hs-dropdown") ? evtTarget.closest(".hs-dropdown").parentElement.closest(".hs-dropdown") : null;
        let currentlyOpened = parent ? window.$hsDropdownCollection.filter((el)=>el.element.el.classList.contains("open") && el.element.menu.closest(".hs-dropdown").parentElement.closest(".hs-dropdown") === parent) : window.$hsDropdownCollection.filter((el)=>el.element.el.classList.contains("open"));
        if (evtTarget && evtTarget.closest(".hs-dropdown") && (0, $478cf65b5d671095$export$315f1f5a8da35a59)(evtTarget.closest(".hs-dropdown"), "--auto-close") === "inside") currentlyOpened = currentlyOpened.filter((el)=>el.element.el !== evtTarget.closest(".hs-dropdown"));
        if (currentlyOpened) currentlyOpened.forEach((el)=>{
            if (el.element.closeMode === "false" || el.element.closeMode === "outside") return false;
            el.element.close(isAnimated);
        });
    }
    // Backward compatibility
    static on(evt, target, cb) {
        const elInCollection = window.$hsDropdownCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection) elInCollection.element.events[evt] = cb;
    }
}
window.addEventListener("load", ()=>{
    $3165a178822236d6$var$HSDropdown.autoInit();
// Uncomment for debug
// console.log('Dropdown collection:', window.$hsDropdownCollection);
});
window.addEventListener("resize", ()=>{
    if (!window.$hsDropdownCollection) window.$hsDropdownCollection = [];
    window.$hsDropdownCollection.forEach((el)=>el.element.resizeHandler());
});
if (typeof window !== "undefined") window.HSDropdown = $3165a178822236d6$var$HSDropdown;
var $3165a178822236d6$export$2e2bcd8739ae039 = $3165a178822236d6$var$HSDropdown;


/*
 * HSInputNumber
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 

class $278cd9d7635fbaf2$var$HSInputNumber extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options){
        super(el, options);
        this.input = this.el.querySelector("[data-hs-input-number-input]") || null;
        this.increment = this.el.querySelector("[data-hs-input-number-increment]") || null;
        this.decrement = this.el.querySelector("[data-hs-input-number-decrement]") || null;
        if (this.input) this.inputValue = !isNaN(parseInt(this.input.value)) ? parseInt(this.input.value) : 0;
        const data = this.el.dataset.hsInputNumber;
        const dataOptions = data ? JSON.parse(data) : {
            step: 1
        };
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.minInputValue = "min" in concatOptions ? concatOptions.min : 0;
        this.maxInputValue = "max" in concatOptions ? concatOptions.max : null;
        this.step = "step" in concatOptions && concatOptions.step > 0 ? concatOptions.step : 1;
        this.init();
    }
    init() {
        this.createCollection(window.$hsInputNumberCollection, this);
        if (this.input && this.increment) this.build();
    }
    build() {
        if (this.input) this.buildInput();
        if (this.increment) this.buildIncrement();
        if (this.decrement) this.buildDecrement();
        if (this.inputValue <= 0 && this.minInputValue === 0) {
            this.inputValue = 0;
            this.input.value = "0";
        }
        if (this.inputValue <= 0 || this.minInputValue < 0) this.changeValue();
        if (this.input.hasAttribute("disabled")) this.disableButtons();
    }
    buildInput() {
        this.input.addEventListener("input", ()=>this.changeValue());
    }
    buildIncrement() {
        this.increment.addEventListener("click", ()=>{
            this.changeValue("increment");
        });
    }
    buildDecrement() {
        this.decrement.addEventListener("click", ()=>{
            this.changeValue("decrement");
        });
    }
    changeValue(event = "none") {
        const payload = {
            inputValue: this.inputValue
        };
        const minInputValue = this.minInputValue ?? Number.MIN_SAFE_INTEGER;
        const maxInputValue = this.maxInputValue ?? Number.MAX_SAFE_INTEGER;
        this.inputValue = isNaN(this.inputValue) ? 0 : this.inputValue;
        switch(event){
            case "increment":
                const incrementedResult = this.inputValue + this.step;
                this.inputValue = incrementedResult >= minInputValue && incrementedResult <= maxInputValue ? incrementedResult : maxInputValue;
                this.input.value = this.inputValue.toString();
                break;
            case "decrement":
                const decrementedResult = this.inputValue - this.step;
                this.inputValue = decrementedResult >= minInputValue && decrementedResult <= maxInputValue ? decrementedResult : minInputValue;
                this.input.value = this.inputValue.toString();
                break;
            default:
                const defaultResult = isNaN(parseInt(this.input.value)) ? 0 : parseInt(this.input.value);
                this.inputValue = defaultResult >= maxInputValue ? maxInputValue : defaultResult <= minInputValue ? minInputValue : defaultResult;
                if (this.inputValue <= minInputValue) this.input.value = this.inputValue.toString();
                break;
        }
        payload.inputValue = this.inputValue;
        if (this.inputValue === minInputValue) {
            this.el.classList.add("disabled");
            if (this.decrement) this.disableButtons("decrement");
        } else {
            this.el.classList.remove("disabled");
            if (this.decrement) this.enableButtons("decrement");
        }
        if (this.inputValue === maxInputValue) {
            this.el.classList.add("disabled");
            if (this.increment) this.disableButtons("increment");
        } else {
            this.el.classList.remove("disabled");
            if (this.increment) this.enableButtons("increment");
        }
        this.fireEvent("change", payload);
        (0, $478cf65b5d671095$export$635e15bbd66f01ea)("change.hs.inputNumber", this.el, payload);
    }
    disableButtons(mode = "all") {
        if (mode === "all") {
            if (this.increment.tagName === "BUTTON" || this.increment.tagName === "INPUT") this.increment.setAttribute("disabled", "disabled");
            if (this.decrement.tagName === "BUTTON" || this.decrement.tagName === "INPUT") this.decrement.setAttribute("disabled", "disabled");
        } else if (mode === "increment") {
            if (this.increment.tagName === "BUTTON" || this.increment.tagName === "INPUT") this.increment.setAttribute("disabled", "disabled");
        } else if (mode === "decrement") {
            if (this.decrement.tagName === "BUTTON" || this.decrement.tagName === "INPUT") this.decrement.setAttribute("disabled", "disabled");
        }
    }
    enableButtons(mode = "all") {
        if (mode === "all") {
            if (this.increment.tagName === "BUTTON" || this.increment.tagName === "INPUT") this.increment.removeAttribute("disabled");
            if (this.decrement.tagName === "BUTTON" || this.decrement.tagName === "INPUT") this.decrement.removeAttribute("disabled");
        } else if (mode === "increment") {
            if (this.increment.tagName === "BUTTON" || this.increment.tagName === "INPUT") this.increment.removeAttribute("disabled");
        } else if (mode === "decrement") {
            if (this.decrement.tagName === "BUTTON" || this.decrement.tagName === "INPUT") this.decrement.removeAttribute("disabled");
        }
    }
    // Global method
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsInputNumberCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsInputNumberCollection) window.$hsInputNumberCollection = [];
        document.querySelectorAll("[data-hs-input-number]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsInputNumberCollection.find((elC)=>elC?.element?.el === el)) new $278cd9d7635fbaf2$var$HSInputNumber(el);
        });
    }
}
window.addEventListener("load", ()=>{
    $278cd9d7635fbaf2$var$HSInputNumber.autoInit();
// Uncomment for debug
// console.log('Input number collection:', window.$hsInputNumberCollection);
});
if (typeof window !== "undefined") window.HSInputNumber = $278cd9d7635fbaf2$var$HSInputNumber;
var $278cd9d7635fbaf2$export$2e2bcd8739ae039 = $278cd9d7635fbaf2$var$HSInputNumber;


/*
 * HSOverlay
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 


class $8f2f97605797e558$var$HSOverlay extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options, events){
        super(el, options, events);
        const data = el.getAttribute("data-hs-overlay-options");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.hiddenClass = concatOptions?.hiddenClass || "hidden";
        this.isClosePrev = concatOptions?.isClosePrev ?? true;
        this.backdropClasses = concatOptions?.backdropClasses ?? "transition duration fixed inset-0 bg-gray-900 bg-opacity-50 dark:bg-opacity-80 hs-overlay-backdrop";
        this.openNextOverlay = false;
        this.autoHide = null;
        this.overlayId = this.el.getAttribute("data-hs-overlay");
        this.overlay = document.querySelector(this.overlayId);
        if (this.overlay) {
            this.isCloseWhenClickInside = (0, $478cf65b5d671095$export$70f24959ef00553b)((0, $478cf65b5d671095$export$11a826c585352eb8)(this.overlay, "--close-when-click-inside", "false") || "false");
            this.isTabAccessibilityLimited = (0, $478cf65b5d671095$export$70f24959ef00553b)((0, $478cf65b5d671095$export$11a826c585352eb8)(this.overlay, "--tab-accessibility-limited", "true") || "true");
            this.isLayoutAffect = (0, $478cf65b5d671095$export$70f24959ef00553b)((0, $478cf65b5d671095$export$11a826c585352eb8)(this.overlay, "--is-layout-affect", "false") || "false");
            this.hasAutofocus = (0, $478cf65b5d671095$export$70f24959ef00553b)((0, $478cf65b5d671095$export$11a826c585352eb8)(this.overlay, "--has-autofocus", "true") || "true");
            this.hasAbilityToCloseOnBackdropClick = (0, $478cf65b5d671095$export$70f24959ef00553b)(this.overlay.getAttribute("data-hs-overlay-keyboard") || "true");
            const autoCloseBreakpoint = (0, $478cf65b5d671095$export$11a826c585352eb8)(this.overlay, "--auto-close");
            this.autoClose = !isNaN(+autoCloseBreakpoint) && isFinite(+autoCloseBreakpoint) ? +autoCloseBreakpoint : (0, $704e031c65277337$export$426e07cd0772984d)[autoCloseBreakpoint] || null;
            const openedBreakpoint = (0, $478cf65b5d671095$export$11a826c585352eb8)(this.overlay, "--opened");
            this.openedBreakpoint = (!isNaN(+openedBreakpoint) && isFinite(+openedBreakpoint) ? +openedBreakpoint : (0, $704e031c65277337$export$426e07cd0772984d)[openedBreakpoint]) || null;
        }
        if (this.overlay) this.init();
    }
    init() {
        this.createCollection(window.$hsOverlayCollection, this);
        if (this.isLayoutAffect && this.openedBreakpoint) {
            const instance = $8f2f97605797e558$var$HSOverlay.getInstance(this.el, true);
            $8f2f97605797e558$var$HSOverlay.setOpened(this.openedBreakpoint, instance);
        }
        this.el.addEventListener("click", ()=>{
            if (this.overlay.classList.contains("opened")) this.close();
            else this.open();
        });
        this.overlay.addEventListener("click", (evt)=>{
            if (evt.target.id && `#${evt.target.id}` === this.overlayId && this.isCloseWhenClickInside && this.hasAbilityToCloseOnBackdropClick) this.close();
        });
    }
    hideAuto() {
        const time = parseInt((0, $478cf65b5d671095$export$11a826c585352eb8)(this.overlay, "--auto-hide", "0"));
        if (time) this.autoHide = setTimeout(()=>{
            this.close();
        }, time);
    }
    checkTimer() {
        if (this.autoHide) {
            clearTimeout(this.autoHide);
            this.autoHide = null;
        }
    }
    buildBackdrop() {
        const overlayClasses = this.overlay.classList.value.split(" ");
        const overlayZIndex = parseInt(window.getComputedStyle(this.overlay).getPropertyValue("z-index"));
        const backdropId = this.overlay.getAttribute("data-hs-overlay-backdrop-container") || false;
        let backdrop = document.createElement("div");
        let backdropClasses = this.backdropClasses;
        const closeOnBackdrop = (0, $478cf65b5d671095$export$11a826c585352eb8)(this.overlay, "--overlay-backdrop", "true") !== "static";
        const disableBackdrop = (0, $478cf65b5d671095$export$11a826c585352eb8)(this.overlay, "--overlay-backdrop", "true") === "false";
        backdrop.id = `${this.overlay.id}-backdrop`;
        if ("style" in backdrop) backdrop.style.zIndex = `${overlayZIndex - 1}`;
        for (const value of overlayClasses)if (value.startsWith("hs-overlay-backdrop-open:") || value.includes(":hs-overlay-backdrop-open:")) backdropClasses += ` ${value}`;
        if (disableBackdrop) return;
        if (backdropId) {
            backdrop = document.querySelector(backdropId).cloneNode(true);
            backdrop.classList.remove("hidden");
            backdropClasses = `${backdrop.classList.toString()}`;
            backdrop.classList.value = "";
        }
        if (closeOnBackdrop) backdrop.addEventListener("click", ()=>this.close(), true);
        backdrop.setAttribute("data-hs-overlay-backdrop-template", "");
        document.body.appendChild(backdrop);
        setTimeout(()=>{
            backdrop.classList.value = backdropClasses;
        });
    }
    destroyBackdrop() {
        const backdrop = document.querySelector(`#${this.overlay.id}-backdrop`);
        if (!backdrop) return;
        if (this.openNextOverlay) backdrop.style.transitionDuration = `${parseFloat(window.getComputedStyle(backdrop).transitionDuration.replace(/[^\d.-]/g, "")) * 1.8}s`;
        backdrop.classList.add("opacity-0");
        (0, $478cf65b5d671095$export$24d4b3961cffb4db)(backdrop, ()=>{
            backdrop.remove();
        });
    }
    focusElement() {
        const input = this.overlay.querySelector("[autofocus]");
        if (!input) return false;
        else input.focus();
    }
    // Public methods
    open() {
        if (!this.overlay) return false;
        const currentlyOpened = window.$hsOverlayCollection.find((el)=>el.element.overlay === document.querySelector(".hs-overlay.open") && !el.element.isLayoutAffect);
        const disabledScroll = (0, $478cf65b5d671095$export$11a826c585352eb8)(this.overlay, "--body-scroll", "false") !== "true";
        if (this.isClosePrev && currentlyOpened) {
            this.openNextOverlay = true;
            return currentlyOpened.element.close().then(()=>{
                this.open();
                this.openNextOverlay = false;
            });
        }
        if (disabledScroll) document.body.style.overflow = "hidden";
        this.buildBackdrop();
        this.checkTimer();
        this.hideAuto();
        this.overlay.classList.remove(this.hiddenClass);
        this.overlay.setAttribute("aria-overlay", "true");
        this.overlay.setAttribute("tabindex", "-1");
        setTimeout(()=>{
            if (this.overlay.classList.contains("opened")) return false;
            this.overlay.classList.add("open", "opened");
            if (this.isLayoutAffect) document.body.classList.add("hs-overlay-body-open");
            this.fireEvent("open", this.el);
            (0, $478cf65b5d671095$export$635e15bbd66f01ea)("open.hs.overlay", this.el, this.el);
            if (this.hasAutofocus) this.focusElement();
        }, 50);
    }
    close(forceClose = false) {
        if (this.isLayoutAffect) document.body.classList.remove("hs-overlay-body-open");
        const closeFn = (cb)=>{
            if (this.overlay.classList.contains("open")) return false;
            this.overlay.classList.add(this.hiddenClass);
            this.destroyBackdrop();
            this.fireEvent("close", this.el);
            (0, $478cf65b5d671095$export$635e15bbd66f01ea)("close.hs.overlay", this.el, this.el);
            if (!document.querySelector(".hs-overlay.opened")) document.body.style.overflow = "";
            cb(this.overlay);
        };
        return new Promise((resolve)=>{
            if (!this.overlay) return false;
            this.overlay.classList.remove("open", "opened");
            this.overlay.removeAttribute("aria-overlay");
            this.overlay.removeAttribute("tabindex");
            if (forceClose) closeFn(resolve);
            else (0, $478cf65b5d671095$export$24d4b3961cffb4db)(this.overlay, ()=>{
                closeFn(resolve);
            });
        });
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsOverlayCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target) || el.element.overlay === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element.el : null;
    }
    static autoInit() {
        if (!window.$hsOverlayCollection) window.$hsOverlayCollection = [];
        document.querySelectorAll("[data-hs-overlay]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsOverlayCollection.find((elC)=>elC?.element?.el === el)) new $8f2f97605797e558$var$HSOverlay(el);
        });
        if (window.$hsOverlayCollection) document.addEventListener("keydown", (evt)=>$8f2f97605797e558$var$HSOverlay.accessibility(evt));
    }
    static open(target) {
        const elInCollection = window.$hsOverlayCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target) || el.element.overlay === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && elInCollection.element.overlay.classList.contains(elInCollection.element.hiddenClass)) elInCollection.element.open();
    }
    static close(target) {
        const elInCollection = window.$hsOverlayCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target) || el.element.overlay === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && !elInCollection.element.overlay.classList.contains(elInCollection.element.hiddenClass)) elInCollection.element.close();
    }
    static setOpened(breakpoint, el) {
        if (document.body.clientWidth >= breakpoint) {
            document.body.classList.add("hs-overlay-body-open");
            el.element.overlay.classList.add("opened");
        } else el.element.close(true);
    }
    // Accessibility methods
    static accessibility(evt) {
        const targets = window.$hsOverlayCollection.filter((el)=>el.element.overlay.classList.contains("open"));
        const target = targets[targets.length - 1];
        const focusableElements = target?.element?.overlay?.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const notHiddenFocusableElements = [];
        if (focusableElements?.length) focusableElements.forEach((el)=>{
            if (!(0, $478cf65b5d671095$export$82366544b9d4ab15)(el)) notHiddenFocusableElements.push(el);
        });
        const basicCheck = target && !evt.metaKey;
        if (basicCheck && !target.element.isTabAccessibilityLimited && evt.code === "Tab") return false;
        if (basicCheck && notHiddenFocusableElements.length && evt.code === "Tab") {
            evt.preventDefault();
            this.onTab(target, notHiddenFocusableElements);
        }
        if (basicCheck && evt.code === "Escape") {
            evt.preventDefault();
            this.onEscape(target);
        }
    }
    static onEscape(target) {
        if (target && target.element.hasAbilityToCloseOnBackdropClick) target.element.close();
    }
    static onTab(target, focusableElements) {
        if (!focusableElements.length) return false;
        const focused = target.element.overlay.querySelector(":focus");
        const focusedIndex = Array.from(focusableElements).indexOf(focused);
        if (focusedIndex > -1) {
            const nextIndex = (focusedIndex + 1) % focusableElements.length;
            focusableElements[nextIndex].focus();
        } else focusableElements[0].focus();
    }
    // Backward compatibility
    static on(evt, target, cb) {
        const elInCollection = window.$hsOverlayCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target) || el.element.overlay === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection) elInCollection.element.events[evt] = cb;
    }
}
const $8f2f97605797e558$var$autoCloseResizeFn = ()=>{
    if (!window.$hsOverlayCollection.length || !window.$hsOverlayCollection.find((el)=>el.element.autoClose)) return false;
    const overlays = window.$hsOverlayCollection.filter((el)=>el.element.autoClose);
    overlays.forEach((overlay)=>{
        if (document.body.clientWidth >= overlay.element.autoClose) overlay.element.close(true);
    });
};
const $8f2f97605797e558$var$setOpenedResizeFn = ()=>{
    if (!window.$hsOverlayCollection.length || !window.$hsOverlayCollection.find((el)=>el.element.openedBreakpoint)) return false;
    const overlays = window.$hsOverlayCollection.filter((el)=>el.element.openedBreakpoint);
    overlays.forEach((overlay)=>{
        $8f2f97605797e558$var$HSOverlay.setOpened(overlay.element.openedBreakpoint, overlay);
    });
};
window.addEventListener("load", ()=>{
    $8f2f97605797e558$var$HSOverlay.autoInit();
// Uncomment for debug
// console.log('Overlay collection:', window.$hsOverlayCollection);
});
window.addEventListener("resize", ()=>{
    $8f2f97605797e558$var$autoCloseResizeFn();
    $8f2f97605797e558$var$setOpenedResizeFn();
});
if (typeof window !== "undefined") window.HSOverlay = $8f2f97605797e558$var$HSOverlay;
var $8f2f97605797e558$export$2e2bcd8739ae039 = $8f2f97605797e558$var$HSOverlay;


/*
 * HSPinInput
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 

class $4a788dc9d3bacdfa$var$HSPinInput extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-pin-input");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.items = this.el.querySelectorAll("[data-hs-pin-input-item]");
        this.currentItem = null;
        this.currentValue = new Array(this.items.length).fill("");
        this.placeholders = [];
        this.availableCharsRE = new RegExp(concatOptions?.availableCharsRE || "^[a-zA-Z0-9]+$"); // '^[0-9]+$'
        this.init();
    }
    init() {
        this.createCollection(window.$hsPinInputCollection, this);
        if (this.items.length) this.build();
    }
    build() {
        this.buildInputItems();
    }
    buildInputItems() {
        this.items.forEach((el, index)=>{
            this.placeholders.push(el.getAttribute("placeholder") || "");
            if (el.hasAttribute("autofocus")) this.onFocusIn(index);
            el.addEventListener("input", (evt)=>this.onInput(evt, index));
            el.addEventListener("paste", (evt)=>this.onPaste(evt));
            el.addEventListener("keydown", (evt)=>this.onKeydown(evt, index));
            el.addEventListener("focusin", ()=>this.onFocusIn(index));
            el.addEventListener("focusout", ()=>this.onFocusOut(index));
        });
    }
    checkIfNumber(value) {
        return value.match(this.availableCharsRE);
    }
    autoFillAll(text) {
        Array.from(text).forEach((n, i)=>{
            if (!this?.items[i]) return false;
            this.items[i].value = n;
            this.items[i].dispatchEvent(new Event("input", {
                bubbles: true
            }));
        });
    }
    setCurrentValue() {
        this.currentValue = Array.from(this.items).map((el)=>el.value);
    }
    toggleCompleted() {
        if (!this.currentValue.includes("")) this.el.classList.add("active");
        else this.el.classList.remove("active");
    }
    onInput(evt, index) {
        const originalValue = evt.target.value;
        this.currentItem = evt.target;
        this.currentItem.value = "";
        this.currentItem.value = originalValue[originalValue.length - 1];
        if (!this.checkIfNumber(this.currentItem.value)) {
            this.currentItem.value = this.currentValue[index] || "";
            return false;
        }
        this.setCurrentValue();
        if (this.currentItem.value) {
            if (index < this.items.length - 1) this.items[index + 1].focus();
            if (!this.currentValue.includes("")) {
                const payload = {
                    currentValue: this.currentValue
                };
                this.fireEvent("completed", payload);
                (0, $478cf65b5d671095$export$635e15bbd66f01ea)("completed.hs.pinInput", this.el, payload);
            }
            this.toggleCompleted();
        } else if (index > 0) this.items[index - 1].focus();
    }
    onKeydown(evt, index) {
        if (evt.key === "Backspace" && index > 0) {
            if (this.items[index].value === "") {
                this.items[index - 1].value = "";
                this.items[index - 1].focus();
            } else this.items[index].value = "";
        }
        this.setCurrentValue();
        this.toggleCompleted();
    }
    onFocusIn(index) {
        this.items[index].setAttribute("placeholder", "");
    }
    onFocusOut(index) {
        this.items[index].setAttribute("placeholder", this.placeholders[index]);
    }
    onPaste(evt) {
        evt.preventDefault();
        this.items.forEach((el)=>{
            if (document.activeElement === el) this.autoFillAll(evt.clipboardData.getData("text"));
        });
    }
    // Static method
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsPinInputCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsPinInputCollection) window.$hsPinInputCollection = [];
        document.querySelectorAll("[data-hs-pin-input]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsPinInputCollection.find((elC)=>elC?.element?.el === el)) new $4a788dc9d3bacdfa$var$HSPinInput(el);
        });
    }
}
window.addEventListener("load", ()=>{
    $4a788dc9d3bacdfa$var$HSPinInput.autoInit();
// Uncomment for debug
// console.log('PIN input collection:', window.$hsPinInputCollection);
});
if (typeof window !== "undefined") window.HSPinInput = $4a788dc9d3bacdfa$var$HSPinInput;
var $4a788dc9d3bacdfa$export$2e2bcd8739ae039 = $4a788dc9d3bacdfa$var$HSPinInput;


/*
 * HSRemoveElement
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 

class $308f48fd3b91efe3$var$HSRemoveElement extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-remove-element-options");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.removeTargetId = this.el.getAttribute("data-hs-remove-element");
        this.removeTarget = document.querySelector(this.removeTargetId);
        this.removeTargetAnimationClass = concatOptions?.removeTargetAnimationClass || "hs-removing";
        if (this.removeTarget) this.init();
    }
    init() {
        this.createCollection(window.$hsRemoveElementCollection, this);
        this.el.addEventListener("click", ()=>this.remove());
    }
    remove() {
        if (!this.removeTarget) return false;
        this.removeTarget.classList.add(this.removeTargetAnimationClass);
        (0, $478cf65b5d671095$export$24d4b3961cffb4db)(this.removeTarget, ()=>{
            this.removeTarget.remove();
        });
    }
    // Static method
    static autoInit() {
        if (!window.$hsRemoveElementCollection) window.$hsRemoveElementCollection = [];
        document.querySelectorAll("[data-hs-remove-element]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsRemoveElementCollection.find((elC)=>elC?.element?.el === el)) new $308f48fd3b91efe3$var$HSRemoveElement(el);
        });
    }
}
window.addEventListener("load", ()=>{
    $308f48fd3b91efe3$var$HSRemoveElement.autoInit();
// Uncomment for debug
// console.log('Remove element collection:', window.$hsRemoveElementCollection);
});
if (typeof window !== "undefined") window.HSRemoveElement = $308f48fd3b91efe3$var$HSRemoveElement;
var $308f48fd3b91efe3$export$2e2bcd8739ae039 = $308f48fd3b91efe3$var$HSRemoveElement;


/*
 * HSTogglePassword
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 

class $c565ecc8f2fb83e2$var$HSSearchByJson extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-search-by-json");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.jsonUrl = concatOptions.jsonUrl;
        this.minChars = concatOptions.minChars || 3;
        this.dropdownTemplate = concatOptions.dropdownTemplate || "<div></div>";
        this.dropdownClasses = concatOptions.dropdownClasses || "absolute top-full z-[1] w-full bg-white border border-gray-200 rounded-md hidden mt-2";
        this.dropdownItemTemplate = concatOptions.dropdownItemTemplate || "<div></div>";
        this.dropdownItemTemplatesByType = concatOptions.dropdownItemTemplatesByType || null;
        this.dropdownItemClasses = concatOptions.dropdownItemClasses || "py-2 px-4 w-full cursor-pointer text-sm hover:bg-gray-300 hover:text-black";
        this.highlightedTextTagName = concatOptions.highlightedTextTagName || "u";
        this.highlightedTextClasses = concatOptions.highlightedTextClasses || "bg-green-200";
        if (this.jsonUrl) this.fetchData().then(()=>this.init());
    }
    init() {
        this.createCollection(window.$hsSearchByJsonCollection, this);
        this.buildDropdown();
        this.el.addEventListener("input", (0, $478cf65b5d671095$export$61fc7d43ac8f84b0)((evt)=>{
            this.val = evt.target.value;
            if (this.val.length > this.minChars) this.searchData(this.val);
            else this.result = [];
            if (this.result.length) this.dropdown.classList.remove("hidden");
            else this.dropdown.classList.add("hidden");
            this.buildItems();
        }));
    }
    async fetchData() {
        await fetch(this.jsonUrl).then((data)=>data.json()).then((data)=>this.json = data);
    }
    searchData(val) {
        this.result = this.json.filter((el)=>{
            const value = val.toLowerCase();
            const title = el.title.toLowerCase();
            const description = el.description.toLowerCase();
            return title.includes(value) || description.includes(value);
        });
    }
    buildDropdown() {
        this.dropdown = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(this.dropdownTemplate);
        if (this.dropdownClasses) (0, $478cf65b5d671095$export$a73398b198c9e798)(this.dropdownClasses, this.dropdown);
        this.el.after(this.dropdown);
    }
    buildItems() {
        this.dropdown.innerHTML = "";
        this.result.forEach((el)=>{
            const link = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(`<a class="block" href="${el.url}" target="_blank"></a>`);
            link.append(this.itemTemplate(el));
            this.dropdown.append(link);
        });
    }
    itemTemplate(el) {
        const re = new RegExp(this.val, "gi");
        const newTitle = el.title.replace(re, `<${this.highlightedTextTagName} class="inline-block ${this.highlightedTextClasses}">${this.val}</${this.highlightedTextTagName}>`);
        const newDescription = el.description.replace(re, `<${this.highlightedTextTagName} class="inline-block ${this.highlightedTextClasses}">${this.val}</${this.highlightedTextTagName}>`);
        const templateByType = this.dropdownItemTemplatesByType ? this.dropdownItemTemplatesByType.find((template)=>template.type === el.type) : null;
        const template = templateByType ? (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(templateByType.markup) : (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(this.dropdownItemTemplate);
        if (this.dropdownItemClasses) (0, $478cf65b5d671095$export$a73398b198c9e798)(this.dropdownItemClasses, template);
        const title = template.querySelector("[data-title]");
        if (title) title.append((0, $478cf65b5d671095$export$c5c738da9ba7f9f)(`<span>${newTitle}</span>`));
        else template.append((0, $478cf65b5d671095$export$c5c738da9ba7f9f)(`<span>${newTitle}</span>`));
        const description = template.querySelector("[data-description]");
        if (description) description.append((0, $478cf65b5d671095$export$c5c738da9ba7f9f)(`<span>${newDescription}</span>`));
        else if (!templateByType) {
            const br = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)("<br>");
            template.append(br);
            template.append((0, $478cf65b5d671095$export$c5c738da9ba7f9f)(`<span>${newDescription}</span>`));
        }
        return template;
    }
    // Static method
    static getInstance(target) {
        const elInCollection = window.$hsSearchByJsonCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsSearchByJsonCollection) window.$hsSearchByJsonCollection = [];
        document.querySelectorAll("[data-hs-search-by-json]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsSearchByJsonCollection.find((elC)=>elC?.element?.el === el)) new $c565ecc8f2fb83e2$var$HSSearchByJson(el);
        });
    }
}
window.addEventListener("load", ()=>{
    $c565ecc8f2fb83e2$var$HSSearchByJson.autoInit();
// Uncomment for debug
// console.log('Search by JSON collection:', window.$hsSearchByJsonCollection);
});
if (typeof window !== "undefined") window.HSSearchByJson = $c565ecc8f2fb83e2$var$HSSearchByJson;
var $c565ecc8f2fb83e2$export$2e2bcd8739ae039 = $c565ecc8f2fb83e2$var$HSSearchByJson;


/*
 * HSScrollspy
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 

class $123fc6210ee090d1$var$HSScrollspy extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options = {}){
        super(el, options);
        this.activeSection = null;
        this.contentId = this.el.getAttribute("data-hs-scrollspy");
        this.content = document.querySelector(this.contentId);
        this.links = this.el.querySelectorAll("[href]");
        // this.sections = this.content.children;
        this.sections = [];
        this.scrollableId = this.el.getAttribute("data-hs-scrollspy-scrollable-parent");
        this.scrollable = this.scrollableId ? document.querySelector(this.scrollableId) : document;
        this.init();
    }
    init() {
        this.createCollection(window.$hsScrollspyCollection, this);
        this.links.forEach((el)=>{
            this.sections.push(this.scrollable.querySelector(el.getAttribute("href")));
        });
        Array.from(this.sections).forEach((section)=>{
            if (!section.getAttribute("id")) return false;
            this.scrollable.addEventListener("scroll", (evt)=>this.update(evt, section));
        });
        this.links.forEach((el)=>{
            el.addEventListener("click", (evt)=>{
                evt.preventDefault();
                if (el.getAttribute("href") === "javascript:;") return false;
                this.scrollTo(el);
            });
        });
    }
    update(evt, section) {
        const globalOffset = parseInt((0, $478cf65b5d671095$export$11a826c585352eb8)(this.el, "--scrollspy-offset", "0"));
        const userOffset = parseInt((0, $478cf65b5d671095$export$11a826c585352eb8)(section, "--scrollspy-offset")) || globalOffset;
        const scrollableParentOffset = evt.target === document ? 0 : parseInt(String(evt.target.getBoundingClientRect().top));
        const topOffset = parseInt(String(section.getBoundingClientRect().top)) - userOffset - scrollableParentOffset;
        const height = section.offsetHeight;
        if (topOffset <= 0 && topOffset + height > 0) {
            if (this.activeSection === section) return false;
            this.links.forEach((el)=>{
                el.classList.remove("active");
            });
            const current = this.el.querySelector(`[href="#${section.getAttribute("id")}"]`);
            if (current) {
                current.classList.add("active");
                const group = current.closest("[data-hs-scrollspy-group]");
                if (group) {
                    const parentLink = group.querySelector("[href]");
                    if (parentLink) parentLink.classList.add("active");
                }
            }
            this.activeSection = section;
        }
    }
    scrollTo(link) {
        const targetId = link.getAttribute("href");
        const target = document.querySelector(targetId);
        const globalOffset = parseInt((0, $478cf65b5d671095$export$11a826c585352eb8)(this.el, "--scrollspy-offset", "0"));
        const userOffset = parseInt((0, $478cf65b5d671095$export$11a826c585352eb8)(target, "--scrollspy-offset")) || globalOffset;
        const scrollableParentOffset = this.scrollable === document ? 0 : this.scrollable.offsetTop;
        const topOffset = target.offsetTop - userOffset - scrollableParentOffset;
        const view = this.scrollable === document ? window : this.scrollable;
        const scrollFn = ()=>{
            window.history.replaceState(null, null, link.getAttribute("href"));
            if ("scrollTo" in view) view.scrollTo({
                top: topOffset,
                left: 0,
                behavior: "smooth"
            });
        };
        const beforeScroll = this.fireEvent("beforeScroll", this.el);
        (0, $478cf65b5d671095$export$635e15bbd66f01ea)("beforeScroll.hs.scrollspy", this.el, this.el);
        if (beforeScroll instanceof Promise) beforeScroll.then(()=>scrollFn());
        else scrollFn();
    }
    // Static methods
    static getInstance(target, isInstance = false) {
        const elInCollection = window.$hsScrollspyCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element.el : null;
    }
    static autoInit() {
        if (!window.$hsScrollspyCollection) window.$hsScrollspyCollection = [];
        document.querySelectorAll("[data-hs-scrollspy]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsScrollspyCollection.find((elC)=>elC?.element?.el === el)) new $123fc6210ee090d1$var$HSScrollspy(el);
        });
    }
}
window.addEventListener("load", ()=>{
    $123fc6210ee090d1$var$HSScrollspy.autoInit();
// Uncomment for debug
// console.log('Scrollspy collection:', window.$hsScrollspyCollection);
});
if (typeof window !== "undefined") window.HSScrollspy = $123fc6210ee090d1$var$HSScrollspy;
var $123fc6210ee090d1$export$2e2bcd8739ae039 = $123fc6210ee090d1$var$HSScrollspy;


/*
 * HSSelect
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 


class $45555ee5ed0eeb66$var$HSSelect extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-select");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.value = concatOptions?.value || this.el.value || null;
        this.placeholder = concatOptions?.placeholder || "Select...";
        this.hasSearch = concatOptions?.hasSearch || false;
        this.preventSearchFocus = concatOptions?.preventSearchFocus || false;
        this.mode = concatOptions?.mode || "default";
        this.viewport = typeof concatOptions?.viewport !== "undefined" ? document.querySelector(concatOptions?.viewport) : null;
        this.isOpened = Boolean(concatOptions?.isOpened) || false;
        this.isMultiple = this.el.hasAttribute("multiple") || false;
        this.isDisabled = this.el.hasAttribute("disabled") || false;
        this.selectedItems = [];
        this.wrapperClasses = concatOptions?.wrapperClasses || null;
        this.toggleTag = concatOptions?.toggleTag || null;
        this.toggleClasses = concatOptions?.toggleClasses || null;
        this.toggleCountText = concatOptions?.toggleCountText || null;
        this.toggleCountTextMinItems = concatOptions?.toggleCountTextMinItems || 1;
        this.tagsItemTemplate = concatOptions?.tagsItemTemplate || null;
        this.tagsItemClasses = concatOptions?.tagsItemClasses || null;
        this.tagsInputClasses = concatOptions?.tagsInputClasses || null;
        this.dropdownTag = concatOptions?.dropdownTag || null;
        this.dropdownClasses = concatOptions?.dropdownClasses || null;
        this.dropdownDirectionClasses = concatOptions?.dropdownDirectionClasses || null;
        this.dropdownSpace = concatOptions?.dropdownSpace || 10;
        this.searchWrapperTemplate = concatOptions?.searchWrapperTemplate || null;
        this.searchWrapperClasses = concatOptions?.searchWrapperClasses || "bg-white p-2 sticky top-0";
        this.searchClasses = concatOptions?.searchClasses || "block w-[calc(100%-2rem)] text-sm border-gray-200 rounded-md focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 py-2 px-3 my-2 mx-4";
        this.searchPlaceholder = concatOptions?.searchPlaceholder || "Search...";
        this.searchNoResultText = concatOptions?.searchNoResultText || "No options found...";
        this.searchNoResultClasses = concatOptions?.searchNoResultClasses || "px-4 text-sm";
        this.optionTemplate = concatOptions?.optionTemplate || null;
        this.optionTag = concatOptions?.optionTag || null;
        this.optionClasses = concatOptions?.optionClasses || null;
        this.extraMarkup = concatOptions?.extraMarkup || null;
        this.descriptionClasses = concatOptions?.descriptionClasses || null;
        this.iconClasses = concatOptions?.iconClasses || null;
        this.isAddTagOnEnter = concatOptions?.isAddTagOnEnter ?? true;
        this.animationInProcess = false;
        this.selectOptions = [];
        this.tagsInputHelper = null;
        this.init();
    }
    init() {
        this.createCollection(window.$hsSelectCollection, this);
        this.build();
    }
    build() {
        this.el.style.display = "none";
        if (this.el.children) Array.from(this.el.children).filter((el)=>el.value && el.value !== "").forEach((el)=>{
            const data = el.getAttribute("data-hs-select-option");
            this.selectOptions = [
                ...this.selectOptions,
                {
                    title: el.textContent,
                    val: el.value,
                    options: data !== "undefined" ? JSON.parse(data) : null
                }
            ];
        });
        if (this.isMultiple) {
            const selectedOptions = Array.from(this.el.options).filter((el)=>el.selected);
            if (selectedOptions) {
                const values = [];
                selectedOptions.forEach((el)=>{
                    values.push(el.value);
                });
                this.value = values;
            }
        }
        this.buildWrapper();
        if (this.mode === "tags") this.buildTags();
        else this.buildToggle();
        this.buildDropdown();
        if (this.extraMarkup) this.buildExtraMarkup();
    }
    buildWrapper() {
        this.wrapper = document.createElement("div");
        this.wrapper.classList.add("hs-select", "relative");
        if (this.mode === "tags") this.wrapper.addEventListener("click", (evt)=>{
            if (!evt.target.closest("[data-hs-select-dropdown]") && !evt.target.closest("[data-tag-value]")) this.tagsInput.focus();
        });
        if (this.wrapperClasses) (0, $478cf65b5d671095$export$a73398b198c9e798)(this.wrapperClasses, this.wrapper);
        this.el.before(this.wrapper);
        this.wrapper.append(this.el);
    }
    buildExtraMarkup() {
        const appendMarkup = (markup)=>{
            this.wrapper.append((0, $478cf65b5d671095$export$c5c738da9ba7f9f)(markup));
        };
        if (Array.isArray(this.extraMarkup)) this.extraMarkup.forEach((el)=>appendMarkup(el));
        else appendMarkup(this.extraMarkup);
    }
    buildToggle() {
        let icon, title;
        this.toggleTextWrapper = document.createElement("span");
        this.toggleTextWrapper.classList.add("truncate");
        this.toggle = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(this.toggleTag || "<div></div>");
        icon = this.toggle.querySelector("[data-icon]");
        title = this.toggle.querySelector("[data-title]");
        if (!this.isMultiple && icon) this.setToggleIcon();
        if (!this.isMultiple && title) this.setToggleTitle();
        if (this.isMultiple) this.toggleTextWrapper.innerHTML = this.value.length ? this.stringFromValue() : this.placeholder;
        else this.toggleTextWrapper.innerHTML = this.getItemByValue(this.value)?.title || this.placeholder;
        if (!title) this.toggle.append(this.toggleTextWrapper);
        if (this.toggleClasses) (0, $478cf65b5d671095$export$a73398b198c9e798)(this.toggleClasses, this.toggle);
        if (this.isDisabled) this.toggle.classList.add("disabled");
        if (this.wrapper) this.wrapper.append(this.toggle);
        this.toggle.addEventListener("click", ()=>{
            if (this.isDisabled) return false;
            if (this.isOpened) this.close();
            else this.open();
        });
    }
    setToggleIcon() {
        const icon = this.toggle.querySelector("[data-icon]");
        icon.innerHTML = "";
        if (icon) {
            const img = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(this.getItemByValue(this.value)?.options?.icon || "");
            icon.append(img);
            if (!img) icon.classList.add("hidden");
            else icon.classList.remove("hidden");
        }
    }
    setToggleTitle() {
        const title = this.toggle.querySelector("[data-title]");
        title.classList.add("truncate");
        title.innerHTML = "";
        if (title) {
            const titleText = this.getItemByValue(this.value)?.title || this.placeholder;
            title.innerHTML = titleText;
            this.toggle.append(title);
        }
    }
    buildTags() {
        this.buildTagsInput();
        this.setTagsItems();
    }
    reassignTagsInputPlaceholder(placeholder) {
        this.tagsInput.placeholder = placeholder;
        this.tagsInputHelper.innerHTML = placeholder;
        this.calculateInputWidth();
    }
    buildTagsItem(val) {
        const item = this.getItemByValue(val);
        let template, title, remove, icon;
        const newItem = document.createElement("div");
        newItem.setAttribute("data-tag-value", val);
        if (this.tagsItemClasses) (0, $478cf65b5d671095$export$a73398b198c9e798)(this.tagsItemClasses, newItem);
        if (this.tagsItemTemplate) {
            template = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(this.tagsItemTemplate);
            newItem.append(template);
        }
        // Icon
        if (item?.options?.icon) {
            const img = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(item?.options?.icon);
            icon = template ? template.querySelector("[data-icon]") : document.createElement("span");
            icon.append(img);
            if (!template) newItem.append(icon);
        }
        if (template && template.querySelector("[data-icon]") && !item?.options?.icon) template.querySelector("[data-icon]").classList.add("hidden");
        // Title
        title = template ? template.querySelector("[data-title]") : document.createElement("span");
        title.textContent = item.title || "";
        if (!template) newItem.append(title);
        // Remove
        if (template) remove = template.querySelector("[data-remove]");
        else {
            remove = document.createElement("span");
            remove.textContent = "X";
            newItem.append(remove);
        }
        remove.addEventListener("click", ()=>{
            this.value = this.value.filter((el)=>el !== val);
            this.selectedItems = this.selectedItems.filter((el)=>el !== val);
            if (!this.value.length) this.reassignTagsInputPlaceholder(this.placeholder);
            this.unselectMultipleItems();
            this.selectMultipleItems();
            newItem.remove();
        });
        this.wrapper.append(newItem);
    }
    getItemByValue(val) {
        return this.selectOptions.find((el)=>el.val === val);
    }
    setTagsItems() {
        if (this.value) this.value.forEach((val)=>{
            if (!this.selectedItems.includes(val)) this.buildTagsItem(val);
            this.selectedItems = !this.selectedItems.includes(val) ? [
                ...this.selectedItems,
                val
            ] : this.selectedItems;
        });
    }
    buildTagsInput() {
        this.tagsInput = document.createElement("input");
        if (this.tagsInputClasses) (0, $478cf65b5d671095$export$a73398b198c9e798)(this.tagsInputClasses, this.tagsInput);
        this.tagsInput.addEventListener("focus", ()=>this.open());
        this.tagsInput.addEventListener("input", ()=>this.calculateInputWidth());
        this.tagsInput.addEventListener("input", (0, $478cf65b5d671095$export$61fc7d43ac8f84b0)((evt)=>this.searchOptions(evt.target.value)));
        this.tagsInput.addEventListener("keydown", (evt)=>{
            if (evt.key === "Enter" && this.isAddTagOnEnter) {
                const val = evt.target.value;
                if (this.selectOptions.find((el)=>el.val === val)) return false;
                this.addSelectOption(val, val);
                this.buildOption(val, val);
                this.dropdown.querySelector(`[data-value="${val}"]`).click();
                this.resetTagsInputField();
            // this.close();
            }
        });
        this.wrapper.append(this.tagsInput);
        setTimeout(()=>{
            this.adjustInputWidth();
            this.reassignTagsInputPlaceholder(this.value.length ? "" : this.placeholder);
        });
    }
    buildDropdown() {
        this.dropdown = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(this.dropdownTag || "<div></div>");
        this.dropdown.setAttribute("data-hs-select-dropdown", "");
        this.dropdown.classList.add("absolute", "top-full");
        if (!this.isOpened) this.dropdown.classList.add("hidden");
        if (this.dropdownClasses) (0, $478cf65b5d671095$export$a73398b198c9e798)(this.dropdownClasses, this.dropdown);
        if (this.wrapper) this.wrapper.append(this.dropdown);
        if (this.dropdown && this.hasSearch) this.buildSearch();
        if (this.selectOptions) this.selectOptions.forEach((props, i)=>this.buildOption(props.title, props.val, props.options, `${i}`));
    }
    buildSearch() {
        let input;
        this.searchWrapper = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(this.searchWrapperTemplate || "<div></div>");
        if (this.searchWrapperClasses) (0, $478cf65b5d671095$export$a73398b198c9e798)(this.searchWrapperClasses, this.searchWrapper);
        input = this.searchWrapper.querySelector("[data-input]");
        this.search = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)('<input type="text" />');
        this.search.placeholder = this.searchPlaceholder;
        if (this.searchClasses) (0, $478cf65b5d671095$export$a73398b198c9e798)(this.searchClasses, this.search);
        this.search.addEventListener("input", (0, $478cf65b5d671095$export$61fc7d43ac8f84b0)((evt)=>this.searchOptions(evt.target.value)));
        if (input) input.append(this.search);
        else this.searchWrapper.append(this.search);
        this.dropdown.append(this.searchWrapper);
    }
    buildOption(title, val, options, index = "1") {
        let template = null;
        let titleWrapper = null;
        let iconWrapper = null;
        let descriptionWrapper = null;
        const option = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(this.optionTag || "<div></div>");
        option.setAttribute("data-value", val);
        option.setAttribute("data-title-value", title);
        option.setAttribute("tabIndex", index);
        option.classList.add("cursor-pointer");
        if (this.optionTemplate) {
            template = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(this.optionTemplate);
            option.append(template);
        }
        if (template) {
            titleWrapper = template.querySelector("[data-title]");
            titleWrapper.textContent = title || "";
        } else option.textContent = title || "";
        if (options) {
            if (options.icon) {
                const img = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)(options.icon);
                img.classList.add("mw-full");
                if (template) {
                    iconWrapper = template.querySelector("[data-icon]");
                    iconWrapper.append(img);
                } else {
                    const icon = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)("<div></div>");
                    if (this.iconClasses) (0, $478cf65b5d671095$export$a73398b198c9e798)(this.iconClasses, icon);
                    icon.append(img);
                    option.append(icon);
                }
            }
            if (options.description) {
                if (template) {
                    descriptionWrapper = template.querySelector("[data-description]");
                    descriptionWrapper.append(options.description);
                } else {
                    const description = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)("<div></div>");
                    description.textContent = options.description;
                    if (this.descriptionClasses) (0, $478cf65b5d671095$export$a73398b198c9e798)(this.descriptionClasses, description);
                    option.append(description);
                }
            }
        }
        if (template && template.querySelector("[data-icon]") && !options && !options?.icon) template.querySelector("[data-icon]").classList.add("hidden");
        if (this.value && (this.isMultiple ? this.value.includes(val) : this.value === val)) option.classList.add("selected");
        option.addEventListener("click", ()=>this.onSelectOption(val));
        if (this.optionClasses) (0, $478cf65b5d671095$export$a73398b198c9e798)(this.optionClasses, option);
        if (this.dropdown) this.dropdown.append(option);
    }
    destroyOption(val) {
        const option = this.dropdown.querySelector(`[data-value="${val}"]`);
        if (!option) return false;
        option.remove();
    }
    buildOriginalOption(title, val, options) {
        const option = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)("<option></option>");
        option.setAttribute("value", val);
        option.setAttribute("data-hs-select-option", JSON.stringify(options));
        option.innerText = title;
        this.el.append(option);
    }
    destroyOriginalOption(val) {
        const option = this.el.querySelector(`[value="${val}"]`);
        if (!option) return false;
        option.remove();
    }
    buildTagsInputHelper() {
        this.tagsInputHelper = document.createElement("span");
        this.tagsInputHelper.style.fontSize = window.getComputedStyle(this.tagsInput).fontSize;
        this.tagsInputHelper.style.fontFamily = window.getComputedStyle(this.tagsInput).fontFamily;
        this.tagsInputHelper.style.fontWeight = window.getComputedStyle(this.tagsInput).fontWeight;
        this.tagsInputHelper.style.letterSpacing = window.getComputedStyle(this.tagsInput).letterSpacing;
        this.tagsInputHelper.style.visibility = "hidden";
        this.tagsInputHelper.style.whiteSpace = "pre";
        this.tagsInputHelper.style.position = "absolute";
        this.wrapper.appendChild(this.tagsInputHelper);
    }
    calculateInputWidth() {
        this.tagsInputHelper.textContent = this.tagsInput.value || this.tagsInput.placeholder;
        const inputPadding = parseInt(window.getComputedStyle(this.tagsInput).paddingLeft) + parseInt(window.getComputedStyle(this.tagsInput).paddingRight);
        const inputBorder = parseInt(window.getComputedStyle(this.tagsInput).borderLeftWidth) + parseInt(window.getComputedStyle(this.tagsInput).borderRightWidth);
        const newWidth = this.tagsInputHelper.offsetWidth + inputPadding + inputBorder;
        const maxWidth = this.wrapper.offsetWidth - (parseInt(window.getComputedStyle(this.wrapper).paddingLeft) + parseInt(window.getComputedStyle(this.wrapper).paddingRight));
        this.tagsInput.style.width = `${Math.min(newWidth, maxWidth) + 2}px`;
    }
    adjustInputWidth() {
        this.buildTagsInputHelper();
        this.calculateInputWidth();
    }
    onSelectOption(val) {
        this.clearSelections();
        if (this.isMultiple) {
            this.value = this.value.includes(val) ? Array.from(this.value).filter((el)=>el !== val) : [
                ...Array.from(this.value),
                val
            ];
            this.selectMultipleItems();
            this.setNewValue();
        } else {
            this.value = val;
            this.selectSingleItem();
            this.setNewValue();
        }
        this.fireEvent("change", this.value);
        (0, $478cf65b5d671095$export$635e15bbd66f01ea)("change.hs.select", this.el, this.value);
        if (this.mode === "tags") {
            const intersection = this.selectedItems.filter((x)=>!this.value.includes(x));
            if (intersection.length) intersection.forEach((el)=>{
                this.selectedItems = this.selectedItems.filter((elI)=>elI !== el);
                this.wrapper.querySelector(`[data-tag-value="${el}"]`).remove();
            });
            this.resetTagsInputField();
        }
        if (!this.isMultiple) {
            if (this.toggle.querySelector("[data-icon]")) this.setToggleIcon();
            if (this.toggle.querySelector("[data-title]")) this.setToggleTitle();
            this.close();
        }
        if (!this.value.length && this.mode === "tags") this.reassignTagsInputPlaceholder(this.placeholder);
        if (this.isOpened && this.mode === "tags" && this.tagsInput) this.tagsInput.focus();
    }
    addSelectOption(title, val, options) {
        this.selectOptions = [
            ...this.selectOptions,
            {
                title: title,
                val: val,
                options: options
            }
        ];
    }
    removeSelectOption(val) {
        const hasOption = !!this.selectOptions.some((el)=>el.val === val);
        if (!hasOption) return false;
        this.selectOptions = this.selectOptions.filter((el)=>el.val !== val);
    }
    resetTagsInputField() {
        this.tagsInput.value = "";
        this.reassignTagsInputPlaceholder("");
        this.searchOptions("");
    }
    clearSelections() {
        Array.from(this.dropdown.children).forEach((el)=>{
            if (el.classList.contains("selected")) el.classList.remove("selected");
        });
        Array.from(this.el.children).forEach((el)=>{
            if (el.selected) el.selected = false;
        });
    }
    setNewValue() {
        if (this.mode === "tags") this.setTagsItems();
        else if (this.value.length) this.toggleTextWrapper.innerHTML = this.stringFromValue();
        else this.toggleTextWrapper.innerHTML = this.placeholder;
    }
    stringFromValue() {
        const value = [];
        this.selectOptions.forEach((el)=>{
            if (this.isMultiple) {
                if (this.value.includes(el.val)) value.push(el.title);
            } else if (this.value === el.val) value.push(el.title);
        });
        return this.toggleCountText && this.toggleCountText !== "" && value.length >= this.toggleCountTextMinItems ? `${value.length} ${this.toggleCountText}` : value.join(", ");
    }
    selectSingleItem() {
        const selectedOption = Array.from(this.el.children).find((el)=>this.value === el.value);
        selectedOption.selected = true;
        const selectedItem = Array.from(this.dropdown.children).find((el)=>this.value === el.getAttribute("data-value"));
        selectedItem.classList.add("selected");
    }
    selectMultipleItems() {
        Array.from(this.dropdown.children).filter((el)=>this.value.includes(el.getAttribute("data-value"))).forEach((el)=>el.classList.add("selected"));
        Array.from(this.el.children).filter((el)=>this.value.includes(el.value)).forEach((el)=>el.selected = true);
    }
    unselectMultipleItems() {
        Array.from(this.dropdown.children).forEach((el)=>el.classList.remove("selected"));
        Array.from(this.el.children).forEach((el)=>el.selected = false);
    }
    searchOptions(val) {
        if (this.searchNoResult) {
            this.searchNoResult.remove();
            this.searchNoResult = null;
        }
        this.searchNoResult = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)("<span></span>");
        this.searchNoResult.innerText = this.searchNoResultText;
        (0, $478cf65b5d671095$export$a73398b198c9e798)(this.searchNoResultClasses, this.searchNoResult);
        const options = this.dropdown.querySelectorAll("[data-value]");
        let hasItems = false;
        options.forEach((el)=>{
            const optionVal = el.getAttribute("data-title-value").toLocaleLowerCase();
            if (!optionVal.includes(val.toLocaleLowerCase())) el.classList.add("hidden");
            else {
                el.classList.remove("hidden");
                hasItems = true;
            }
        });
        if (!hasItems) this.dropdown.append(this.searchNoResult);
    }
    eraseToggleIcon() {
        const icon = this.toggle.querySelector("[data-icon]");
        if (icon) {
            icon.innerHTML = null;
            icon.classList.add("hidden");
        }
    }
    eraseToggleTitle() {
        const title = this.toggle.querySelector("[data-title]");
        if (title) title.innerHTML = this.placeholder;
        else this.toggleTextWrapper.innerHTML = this.placeholder;
    }
    // Public methods
    destroy() {
        const parent = this.el.parentElement.parentElement;
        this.el.classList.remove("hidden");
        this.el.style.display = "";
        parent.prepend(this.el);
        parent.querySelector(".hs-select").remove();
        this.wrapper = null;
    }
    open() {
        if (this.animationInProcess) return false;
        this.animationInProcess = true;
        this.dropdown.classList.remove("hidden");
        this.recalculateDirection();
        setTimeout(()=>{
            this.wrapper.classList.add("active");
            this.dropdown.classList.add("opened");
            if (this.hasSearch && !this.preventSearchFocus) this.search.focus();
            this.animationInProcess = false;
        });
        this.isOpened = true;
    }
    close() {
        if (this.animationInProcess) return false;
        this.animationInProcess = true;
        this.wrapper.classList.remove("active");
        this.dropdown.classList.remove("opened", "bottom-full", "top-full");
        if (this.dropdownDirectionClasses?.bottom) this.dropdown.classList.remove(this.dropdownDirectionClasses.bottom);
        if (this.dropdownDirectionClasses?.top) this.dropdown.classList.remove(this.dropdownDirectionClasses.top);
        this.dropdown.style.marginTop = "";
        this.dropdown.style.marginBottom = "";
        (0, $478cf65b5d671095$export$24d4b3961cffb4db)(this.dropdown, ()=>{
            this.dropdown.classList.add("hidden");
            if (this.hasSearch) {
                this.search.value = "";
                this.search.dispatchEvent(new Event("input", {
                    bubbles: true
                }));
                this.search.blur();
            }
            this.animationInProcess = false;
        });
        this.dropdown.querySelector(".hs-select-option-highlighted")?.classList.remove("hs-select-option-highlighted");
        this.isOpened = false;
    }
    addOption(items) {
        let i = `${this.selectOptions.length}`;
        const addOption = (option)=>{
            const { title: title, val: val, options: options } = option;
            const hasOption = !!this.selectOptions.some((el)=>el.val === val);
            if (!hasOption) {
                this.addSelectOption(title, val, options);
                this.buildOption(title, val, options, i);
                this.buildOriginalOption(title, val, options);
            }
        };
        if (Array.isArray(items)) items.forEach((option)=>{
            addOption(option);
        });
        else addOption(items);
    }
    removeOption(values) {
        const removeOption = (val)=>{
            const hasOption = !!this.selectOptions.some((el)=>el.val === val);
            if (hasOption) {
                this.removeSelectOption(val);
                this.destroyOption(val);
                this.destroyOriginalOption(val);
                if (this.value === val) {
                    this.value = null;
                    this.eraseToggleTitle();
                    this.eraseToggleIcon();
                }
            }
        };
        if (Array.isArray(values)) values.forEach((val)=>{
            removeOption(val);
        });
        else removeOption(values);
    }
    recalculateDirection() {
        if ((0, $478cf65b5d671095$export$e3db11022a3681e4)(this.dropdown, this.toggle || this.tagsInput, "bottom", this.dropdownSpace, this.viewport)) {
            this.dropdown.classList.remove("bottom-full");
            if (this.dropdownDirectionClasses?.bottom) this.dropdown.classList.remove(this.dropdownDirectionClasses.bottom);
            this.dropdown.style.marginBottom = "";
            this.dropdown.classList.add("top-full");
            if (this.dropdownDirectionClasses?.top) this.dropdown.classList.add(this.dropdownDirectionClasses.top);
            this.dropdown.style.marginTop = `${this.dropdownSpace}px`;
        } else {
            this.dropdown.classList.remove("top-full");
            if (this.dropdownDirectionClasses?.top) this.dropdown.classList.remove(this.dropdownDirectionClasses.top);
            this.dropdown.style.marginTop = "";
            this.dropdown.classList.add("bottom-full");
            if (this.dropdownDirectionClasses?.bottom) this.dropdown.classList.add(this.dropdownDirectionClasses.bottom);
            this.dropdown.style.marginBottom = `${this.dropdownSpace}px`;
        }
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsSelectCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsSelectCollection) window.$hsSelectCollection = [];
        document.querySelectorAll("[data-hs-select]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsSelectCollection.find((elC)=>elC?.element?.el === el)) {
                const data = el.getAttribute("data-hs-select");
                const options = data ? JSON.parse(data) : {};
                new $45555ee5ed0eeb66$var$HSSelect(el, options);
            }
        });
        if (window.$hsSelectCollection) {
            window.addEventListener("click", (evt)=>{
                const evtTarget = evt.target;
                $45555ee5ed0eeb66$var$HSSelect.closeCurrentlyOpened(evtTarget);
            });
            document.addEventListener("keydown", (evt)=>$45555ee5ed0eeb66$var$HSSelect.accessibility(evt));
        }
    }
    static close(target) {
        const elInCollection = window.$hsSelectCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection && elInCollection.element.isOpened) elInCollection.element.close();
    }
    static closeCurrentlyOpened(evtTarget = null) {
        if (!evtTarget.closest(".hs-select.active")) {
            const currentlyOpened = window.$hsSelectCollection.filter((el)=>el.element.isOpened) || null;
            if (currentlyOpened) currentlyOpened.forEach((el)=>{
                el.element.close();
            });
        }
    }
    // Accessibility methods
    static accessibility(evt) {
        const target = window.$hsSelectCollection.find((el)=>el.element.isOpened);
        if (target && (0, $704e031c65277337$export$717c92bf60493a1c).includes(evt.code) && !evt.metaKey) switch(evt.code){
            case "Escape":
                evt.preventDefault();
                this.onEscape();
                break;
            case "ArrowUp":
                evt.preventDefault();
                this.onArrow();
                break;
            case "ArrowDown":
                evt.preventDefault();
                this.onArrow(false);
                break;
            case "Tab":
                evt.preventDefault();
                this.onTab(evt.shiftKey);
                break;
            case "Home":
                evt.preventDefault();
                this.onStartEnd();
                break;
            case "End":
                evt.preventDefault();
                this.onStartEnd(false);
                break;
            case "Enter":
                evt.preventDefault();
                this.onEnter(evt);
                break;
            default:
                break;
        }
    }
    static onEscape() {
        const target = window.$hsSelectCollection.find((el)=>el.element.isOpened);
        if (target) target.element.close();
    }
    static onArrow(isArrowUp = true) {
        const target = window.$hsSelectCollection.find((el)=>el.element.isOpened);
        if (target) {
            const dropdown = target.element.dropdown;
            if (!dropdown) return false;
            const preparedOptions = isArrowUp ? Array.from(dropdown.querySelectorAll(":scope > *:not(.hidden)")).reverse() : Array.from(dropdown.querySelectorAll(":scope > *:not(.hidden)"));
            const options = preparedOptions.filter((el)=>!el.classList.contains("disabled"));
            const current = dropdown.querySelector(".hs-select-option-highlighted");
            if (!current) options[0].classList.add("hs-select-option-highlighted");
            let currentInd = options.findIndex((el)=>el === current);
            if (currentInd + 1 < options.length) currentInd++;
            options[currentInd].focus();
            if (current) current.classList.remove("hs-select-option-highlighted");
            options[currentInd].classList.add("hs-select-option-highlighted");
        }
    }
    static onTab(isArrowUp = true) {
        const target = window.$hsSelectCollection.find((el)=>el.element.isOpened);
        if (target) {
            const dropdown = target.element.dropdown;
            if (!dropdown) return false;
            const preparedOptions = isArrowUp ? Array.from(dropdown.querySelectorAll(":scope >  *:not(.hidden)")).reverse() : Array.from(dropdown.querySelectorAll(":scope >  *:not(.hidden)"));
            const options = preparedOptions.filter((el)=>!el.classList.contains("disabled"));
            const current = dropdown.querySelector(".hs-select-option-highlighted");
            if (!current) options[0].classList.add("hs-select-option-highlighted");
            let currentInd = options.findIndex((el)=>el === current);
            if (currentInd + 1 < options.length) currentInd++;
            else {
                if (current) current.classList.remove("hs-select-option-highlighted");
                target.element.close();
                target.element.toggle.focus();
                return false;
            }
            options[currentInd].focus();
            if (current) current.classList.remove("hs-select-option-highlighted");
            options[currentInd].classList.add("hs-select-option-highlighted");
        }
    }
    static onStartEnd(isStart = true) {
        const target = window.$hsSelectCollection.find((el)=>el.element.isOpened);
        if (target) {
            const dropdown = target.element.dropdown;
            if (!dropdown) return false;
            const preparedOptions = isStart ? Array.from(dropdown.querySelectorAll(":scope >  *:not(.hidden)")) : Array.from(dropdown.querySelectorAll(":scope >  *:not(.hidden)")).reverse();
            const options = preparedOptions.filter((el)=>!el.classList.contains("disabled"));
            const current = dropdown.querySelector(".hs-select-option-highlighted");
            if (options.length) {
                options[0].focus();
                if (current) current.classList.remove("hs-select-option-highlighted");
                options[0].classList.add("hs-select-option-highlighted");
            }
        }
    }
    static onEnter(evt) {
        const select = evt.target.previousSibling;
        if (window.$hsSelectCollection.find((el)=>el.element.el === select)) {
            const opened = window.$hsSelectCollection.find((el)=>el.element.isOpened);
            const target = window.$hsSelectCollection.find((el)=>el.element.el === select);
            opened.element.close();
            target.element.open();
        } else {
            const target = window.$hsSelectCollection.find((el)=>el.element.isOpened);
            if (target) target.element.onSelectOption(evt.target.dataset.value || "");
        }
    }
}
window.addEventListener("load", ()=>{
    $45555ee5ed0eeb66$var$HSSelect.autoInit();
// Uncomment for debug
// console.log('Select collection:', window.$hsSelectCollection);
});
document.addEventListener("scroll", ()=>{
    if (!window.$hsSelectCollection) return false;
    const target = window.$hsSelectCollection.find((el)=>el.element.isOpened);
    if (target) target.element.recalculateDirection();
});
if (typeof window !== "undefined") window.HSSelect = $45555ee5ed0eeb66$var$HSSelect;
var $45555ee5ed0eeb66$export$2e2bcd8739ae039 = $45555ee5ed0eeb66$var$HSSelect;


/*
 * HSStepper
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 

class $337d9a5ed351f458$var$HSStepper extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-stepper");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.currentIndex = concatOptions?.currentIndex || 1;
        this.mode = concatOptions?.mode || "linear";
        this.isCompleted = typeof concatOptions?.isCompleted !== "undefined" ? concatOptions?.isCompleted : false;
        this.totalSteps = 1;
        this.navItems = [];
        this.contentItems = [];
        this.init();
    }
    init() {
        this.createCollection(window.$hsStepperCollection, this);
        this.buildNav();
        this.buildContent();
        this.buildButtons();
        this.setTotalSteps();
    }
    getUncompletedSteps(inIncludedSkipped = false) {
        return this.navItems.filter(({ isCompleted: isCompleted, isSkip: isSkip })=>inIncludedSkipped ? !isCompleted || isSkip : !isCompleted && !isSkip);
    }
    setTotalSteps() {
        this.navItems.forEach((item)=>{
            const { index: index } = item;
            if (index > this.totalSteps) this.totalSteps = index;
        });
    }
    // Nav
    buildNav() {
        this.el.querySelectorAll("[data-hs-stepper-nav-item]").forEach((el)=>this.addNavItem(el));
        this.navItems.forEach((item)=>this.buildNavItem(item));
    }
    buildNavItem(item) {
        const { index: index, isDisabled: isDisabled, el: el } = item;
        if (index === this.currentIndex) this.setCurrentNavItem();
        if (this.mode !== "linear" || isDisabled) el.addEventListener("click", ()=>this.handleNavItemClick(item));
    }
    addNavItem(el) {
        const { index: index, isFinal: isFinal = false, isCompleted: isCompleted = false, isSkip: isSkip = false, isOptional: isOptional = false, isDisabled: isDisabled = false, isProcessed: isProcessed = false, hasError: hasError = false } = JSON.parse(el.getAttribute("data-hs-stepper-nav-item"));
        if (isCompleted) el.classList.add("success");
        if (isSkip) el.classList.add("skipped");
        if (isDisabled) {
            if (el.tagName === "BUTTON" || el.tagName === "INPUT") el.setAttribute("disabled", "disabled");
            el.classList.add("disabled");
        }
        if (hasError) el.classList.add("error");
        this.navItems.push({
            index: index,
            isFinal: isFinal,
            isCompleted: isCompleted,
            isSkip: isSkip,
            isOptional: isOptional,
            isDisabled: isDisabled,
            isProcessed: isProcessed,
            hasError: hasError,
            el: el
        });
    }
    setCurrentNavItem() {
        this.navItems.forEach((item)=>{
            const { index: index, el: el } = item;
            if (index === this.currentIndex) this.setCurrentNavItemActions(el);
            else this.unsetCurrentNavItemActions(el);
        });
    }
    setCurrentNavItemActions(el) {
        el.classList.add("active");
        this.fireEvent("active", this.currentIndex);
        (0, $478cf65b5d671095$export$635e15bbd66f01ea)("active.hs.stepper", this.el, this.currentIndex);
    }
    getNavItem(n = this.currentIndex) {
        return this.navItems.find(({ index: index })=>index === n);
    }
    setProcessedNavItemActions(item) {
        item.isProcessed = true;
        item.el.classList.add("processed");
    }
    setErrorNavItemActions(item) {
        item.hasError = true;
        item.el.classList.add("error");
    }
    unsetCurrentNavItemActions(el) {
        el.classList.remove("active");
    }
    handleNavItemClick(item) {
        const { index: index } = item;
        this.currentIndex = index;
        this.setCurrentNavItem();
        this.setCurrentContentItem();
        this.checkForTheFirstStep();
    }
    // Content
    buildContent() {
        this.el.querySelectorAll("[data-hs-stepper-content-item]").forEach((el)=>this.addContentItem(el));
        this.navItems.forEach((item)=>this.buildContentItem(item));
    }
    buildContentItem(item) {
        const { index: index } = item;
        if (index === this.currentIndex) this.setCurrentContentItem();
    }
    addContentItem(el) {
        const { index: index, isFinal: isFinal = false, isCompleted: isCompleted = false, isSkip: isSkip = false } = JSON.parse(el.getAttribute("data-hs-stepper-content-item"));
        if (isCompleted) el.classList.add("success");
        if (isSkip) el.classList.add("skipped");
        this.contentItems.push({
            index: index,
            isFinal: isFinal,
            isCompleted: isCompleted,
            isSkip: isSkip,
            el: el
        });
    }
    setCurrentContentItem() {
        if (this.isCompleted) {
            const finalContentItem = this.contentItems.find(({ isFinal: isFinal })=>isFinal);
            const otherContentItems = this.contentItems.filter(({ isFinal: isFinal })=>!isFinal);
            finalContentItem.el.style.display = "";
            otherContentItems.forEach(({ el: el })=>el.style.display = "none");
            return false;
        }
        this.contentItems.forEach((item)=>{
            const { index: index, el: el } = item;
            if (index === this.currentIndex) this.setCurrentContentItemActions(el);
            else this.unsetCurrentContentItemActions(el);
        });
    }
    hideAllContentItems() {
        this.contentItems.forEach(({ el: el })=>el.style.display = "none");
    }
    setCurrentContentItemActions(el) {
        el.style.display = "";
    }
    unsetCurrentContentItemActions(el) {
        el.style.display = "none";
    }
    disableAll() {
        const currentNavItem = this.getNavItem(this.currentIndex);
        currentNavItem.hasError = false;
        currentNavItem.isCompleted = false;
        currentNavItem.isDisabled = false;
        currentNavItem.el.classList.remove("error", "success");
        this.disableButtons();
    }
    disableNavItemActions(item) {
        item.isDisabled = true;
        item.el.classList.add("disabled");
    }
    enableNavItemActions(item) {
        item.isDisabled = false;
        item.el.classList.remove("disabled");
    }
    // Buttons
    buildButtons() {
        this.backBtn = this.el.querySelector("[data-hs-stepper-back-btn]");
        this.nextBtn = this.el.querySelector("[data-hs-stepper-next-btn]");
        this.skipBtn = this.el.querySelector("[data-hs-stepper-skip-btn]");
        this.completeStepBtn = this.el.querySelector("[data-hs-stepper-complete-step-btn]");
        this.finishBtn = this.el.querySelector("[data-hs-stepper-finish-btn]");
        this.resetBtn = this.el.querySelector("[data-hs-stepper-reset-btn]");
        this.buildBackButton();
        this.buildNextButton();
        this.buildSkipButton();
        this.buildCompleteStepButton();
        this.buildFinishButton();
        this.buildResetButton();
    }
    // back
    buildBackButton() {
        if (!this.backBtn) return;
        this.checkForTheFirstStep();
        this.backBtn.addEventListener("click", ()=>{
            this.handleBackButtonClick();
            if (this.mode === "linear") {
                const currentNavItem = this.navItems.find(({ index: index })=>index === this.currentIndex);
                const currentContentItem = this.contentItems.find(({ index: index })=>index === this.currentIndex);
                if (!currentNavItem || !currentContentItem) return;
                if (currentNavItem.isCompleted) {
                    currentNavItem.isCompleted = false;
                    currentNavItem.isSkip = false;
                    currentNavItem.el.classList.remove("success", "skipped");
                }
                if (currentContentItem.isCompleted) {
                    currentContentItem.isCompleted = false;
                    currentContentItem.isSkip = false;
                    currentContentItem.el.classList.remove("success", "skipped");
                }
                if (this.mode === "linear" && this.currentIndex !== this.totalSteps) {
                    if (this.nextBtn) this.nextBtn.style.display = "";
                    if (this.completeStepBtn) this.completeStepBtn.style.display = "";
                }
                this.showSkipButton();
                this.showFinishButton();
                this.showCompleteStepButton();
            }
        });
    }
    handleBackButtonClick() {
        if (this.currentIndex === 1) return;
        if (this.mode === "linear") this.removeOptionalClasses();
        this.currentIndex--;
        if (this.mode === "linear") this.removeOptionalClasses();
        this.setCurrentNavItem();
        this.setCurrentContentItem();
        this.checkForTheFirstStep();
        if (this.completeStepBtn) this.changeTextAndDisableCompleteButtonIfStepCompleted();
        this.fireEvent("back", this.currentIndex);
        (0, $478cf65b5d671095$export$635e15bbd66f01ea)("back.hs.stepper", this.el, this.currentIndex);
    }
    checkForTheFirstStep() {
        if (this.currentIndex === 1) this.setToDisabled(this.backBtn);
        else this.setToNonDisabled(this.backBtn);
    }
    setToDisabled(el) {
        if (el.tagName === "BUTTON" || el.tagName === "INPUT") el.setAttribute("disabled", "disabled");
        el.classList.add("disabled");
    }
    setToNonDisabled(el) {
        if (el.tagName === "BUTTON" || el.tagName === "INPUT") el.removeAttribute("disabled");
        el.classList.remove("disabled");
    }
    // next
    buildNextButton() {
        if (!this.nextBtn) return;
        this.nextBtn.addEventListener("click", ()=>{
            this.fireEvent("beforeNext", this.currentIndex);
            (0, $478cf65b5d671095$export$635e15bbd66f01ea)("beforeNext.hs.stepper", this.el, this.currentIndex);
            if (this.getNavItem(this.currentIndex)?.isProcessed) {
                this.disableAll();
                return false;
            }
            this.goToNext();
        });
    }
    unsetProcessedNavItemActions(item) {
        item.isProcessed = false;
        item.el.classList.remove("processed");
    }
    handleNextButtonClick(infinite = true) {
        if (infinite) {
            if (this.currentIndex === this.totalSteps) this.currentIndex = 1;
            else this.currentIndex++;
        } else {
            const nonCompletedSteps = this.getUncompletedSteps();
            if (nonCompletedSteps.length === 1) {
                const { index: index } = nonCompletedSteps[0];
                this.currentIndex = index;
            } else {
                if (this.currentIndex === this.totalSteps) return;
                this.currentIndex++;
            }
        }
        if (this.mode === "linear") this.removeOptionalClasses();
        this.setCurrentNavItem();
        this.setCurrentContentItem();
        this.checkForTheFirstStep();
        if (this.completeStepBtn) this.changeTextAndDisableCompleteButtonIfStepCompleted();
        this.showSkipButton();
        this.showFinishButton();
        this.showCompleteStepButton();
        this.fireEvent("next", this.currentIndex);
        (0, $478cf65b5d671095$export$635e15bbd66f01ea)("next.hs.stepper", this.el, this.currentIndex);
    }
    removeOptionalClasses() {
        const currentNavItem = this.navItems.find(({ index: index })=>index === this.currentIndex);
        const currentContentItem = this.contentItems.find(({ index: index })=>index === this.currentIndex);
        currentNavItem.isSkip = false;
        currentNavItem.hasError = false;
        currentNavItem.isDisabled = false;
        currentContentItem.isSkip = false;
        currentNavItem.el.classList.remove("skipped", "success", "error");
        currentContentItem.el.classList.remove("skipped", "success", "error");
    }
    // skip
    buildSkipButton() {
        if (!this.skipBtn) return;
        this.showSkipButton();
        this.skipBtn.addEventListener("click", ()=>{
            this.handleSkipButtonClick();
            if (this.mode === "linear" && this.currentIndex === this.totalSteps) {
                if (this.nextBtn) this.nextBtn.style.display = "none";
                if (this.completeStepBtn) this.completeStepBtn.style.display = "none";
                if (this.finishBtn) this.finishBtn.style.display = "";
            }
        });
    }
    setSkipItem(n) {
        const targetNavItem = this.navItems.find(({ index: index })=>index === (n || this.currentIndex));
        const targetContentItem = this.contentItems.find(({ index: index })=>index === (n || this.currentIndex));
        if (!targetNavItem || !targetContentItem) return;
        this.setSkipItemActions(targetNavItem);
        this.setSkipItemActions(targetContentItem);
    }
    setSkipItemActions(item) {
        item.isSkip = true;
        item.el.classList.add("skipped");
    }
    showSkipButton() {
        if (!this.skipBtn) return;
        const { isOptional: isOptional } = this.navItems.find(({ index: index })=>index === this.currentIndex);
        if (isOptional) this.skipBtn.style.display = "";
        else this.skipBtn.style.display = "none";
    }
    handleSkipButtonClick() {
        this.setSkipItem();
        this.handleNextButtonClick();
        this.fireEvent("skip", this.currentIndex);
        (0, $478cf65b5d671095$export$635e15bbd66f01ea)("skip.hs.stepper", this.el, this.currentIndex);
    }
    // complete
    buildCompleteStepButton() {
        if (!this.completeStepBtn) return;
        this.completeStepBtnDefaultText = this.completeStepBtn.innerText;
        this.completeStepBtn.addEventListener("click", ()=>this.handleCompleteStepButtonClick());
    }
    changeTextAndDisableCompleteButtonIfStepCompleted() {
        const currentNavItem = this.navItems.find(({ index: index })=>index === this.currentIndex);
        const { completedText: completedText } = JSON.parse(this.completeStepBtn.getAttribute("data-hs-stepper-complete-step-btn"));
        if (!currentNavItem) return;
        if (currentNavItem.isCompleted) {
            this.completeStepBtn.innerText = completedText || this.completeStepBtnDefaultText;
            this.completeStepBtn.setAttribute("disabled", "disabled");
            this.completeStepBtn.classList.add("disabled");
        } else {
            this.completeStepBtn.innerText = this.completeStepBtnDefaultText;
            this.completeStepBtn.removeAttribute("disabled");
            this.completeStepBtn.classList.remove("disabled");
        }
    }
    setCompleteItem(n) {
        const targetNavItem = this.navItems.find(({ index: index })=>index === (n || this.currentIndex));
        const targetContentItem = this.contentItems.find(({ index: index })=>index === (n || this.currentIndex));
        if (!targetNavItem || !targetContentItem) return;
        this.setCompleteItemActions(targetNavItem);
        this.setCompleteItemActions(targetContentItem);
    }
    setCompleteItemActions(item) {
        item.isCompleted = true;
        item.el.classList.add("success");
    }
    showCompleteStepButton() {
        if (!this.completeStepBtn) return;
        const nonCompletedSteps = this.getUncompletedSteps();
        if (nonCompletedSteps.length === 1) this.completeStepBtn.style.display = "none";
        else this.completeStepBtn.style.display = "";
    }
    handleCompleteStepButtonClick() {
        this.setCompleteItem();
        this.fireEvent("complete", this.currentIndex);
        (0, $478cf65b5d671095$export$635e15bbd66f01ea)("complete.hs.stepper", this.el, this.currentIndex);
        this.handleNextButtonClick(false);
        this.showFinishButton();
        this.showCompleteStepButton();
        this.checkForTheFirstStep();
        if (this.completeStepBtn) this.changeTextAndDisableCompleteButtonIfStepCompleted();
        this.showSkipButton();
    }
    // finish
    buildFinishButton() {
        if (!this.finishBtn) return;
        if (this.isCompleted) this.setCompleted();
        this.finishBtn.addEventListener("click", ()=>this.handleFinishButtonClick());
    }
    setCompleted() {
        this.el.classList.add("completed");
    }
    unsetCompleted() {
        this.el.classList.remove("completed");
    }
    showFinishButton() {
        if (!this.finishBtn) return;
        const nonCompletedSteps = this.getUncompletedSteps();
        if (nonCompletedSteps.length === 1) this.finishBtn.style.display = "";
        else this.finishBtn.style.display = "none";
    }
    handleFinishButtonClick() {
        const uncompletedSteps = this.getUncompletedSteps();
        const uncompletedOrSkipSteps = this.getUncompletedSteps(true);
        const { el: el } = this.contentItems.find(({ isFinal: isFinal })=>isFinal);
        if (uncompletedSteps.length) uncompletedSteps.forEach(({ index: index })=>this.setCompleteItem(index));
        this.currentIndex = this.totalSteps;
        this.setCurrentNavItem();
        this.hideAllContentItems();
        const currentNavItem = this.navItems.find(({ index: index })=>index === this.currentIndex);
        const currentNavItemEl = currentNavItem ? currentNavItem.el : null;
        currentNavItemEl.classList.remove("active");
        el.style.display = "block";
        if (this.backBtn) this.backBtn.style.display = "none";
        if (this.nextBtn) this.nextBtn.style.display = "none";
        if (this.skipBtn) this.skipBtn.style.display = "none";
        if (this.completeStepBtn) this.completeStepBtn.style.display = "none";
        if (this.finishBtn) this.finishBtn.style.display = "none";
        if (this.resetBtn) this.resetBtn.style.display = "";
        if (uncompletedOrSkipSteps.length <= 1) {
            this.isCompleted = true;
            this.setCompleted();
        }
        this.fireEvent("finish", this.currentIndex);
        (0, $478cf65b5d671095$export$635e15bbd66f01ea)("finish.hs.stepper", this.el, this.currentIndex);
    }
    // reset
    buildResetButton() {
        if (!this.resetBtn) return;
        this.resetBtn.addEventListener("click", ()=>this.handleResetButtonClick());
    }
    handleResetButtonClick() {
        if (this.backBtn) this.backBtn.style.display = "";
        if (this.nextBtn) this.nextBtn.style.display = "";
        if (this.completeStepBtn) {
            this.completeStepBtn.style.display = "";
            this.completeStepBtn.innerText = this.completeStepBtnDefaultText;
            this.completeStepBtn.removeAttribute("disabled");
            this.completeStepBtn.classList.remove("disabled");
        }
        if (this.resetBtn) this.resetBtn.style.display = "none";
        this.navItems.forEach((item)=>{
            const { el: el } = item;
            item.isSkip = false;
            item.isCompleted = false;
            this.unsetCurrentNavItemActions(el);
            el.classList.remove("success", "skipped");
        });
        this.contentItems.forEach((item)=>{
            const { el: el } = item;
            item.isSkip = false;
            item.isCompleted = false;
            this.unsetCurrentContentItemActions(el);
            el.classList.remove("success", "skipped");
        });
        this.currentIndex = 1;
        this.setCurrentNavItem();
        this.setCurrentContentItem();
        this.showFinishButton();
        this.showCompleteStepButton();
        this.checkForTheFirstStep();
        this.unsetCompleted();
        this.isCompleted = false;
        this.fireEvent("reset", this.currentIndex);
        (0, $478cf65b5d671095$export$635e15bbd66f01ea)("reset.hs.stepper", this.el, this.currentIndex);
    }
    // Public methods
    setProcessedNavItem(n) {
        const targetNavItem = this.getNavItem(n);
        if (!targetNavItem) return;
        this.setProcessedNavItemActions(targetNavItem);
    }
    unsetProcessedNavItem(n) {
        const targetNavItem = this.getNavItem(n);
        if (!targetNavItem) return;
        this.unsetProcessedNavItemActions(targetNavItem);
    }
    goToNext() {
        if (this.mode === "linear") this.setCompleteItem();
        this.handleNextButtonClick(this.mode !== "linear");
        if (this.mode === "linear" && this.currentIndex === this.totalSteps) {
            if (this.nextBtn) this.nextBtn.style.display = "none";
            if (this.completeStepBtn) this.completeStepBtn.style.display = "none";
        }
    }
    disableButtons() {
        if (this.backBtn) this.setToDisabled(this.backBtn);
        if (this.nextBtn) this.setToDisabled(this.nextBtn);
    }
    enableButtons() {
        if (this.backBtn) this.setToNonDisabled(this.backBtn);
        if (this.nextBtn) this.setToNonDisabled(this.nextBtn);
    }
    setErrorNavItem(n) {
        const targetNavItem = this.getNavItem(n);
        if (!targetNavItem) return;
        this.setErrorNavItemActions(targetNavItem);
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsStepperCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsStepperCollection) window.$hsStepperCollection = [];
        document.querySelectorAll("[data-hs-stepper]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsStepperCollection.find((elC)=>elC?.element?.el === el)) new $337d9a5ed351f458$var$HSStepper(el);
        });
    }
}
window.addEventListener("load", ()=>{
    $337d9a5ed351f458$var$HSStepper.autoInit();
// Uncomment for debug
// console.log('Stepper collection:', window.$hsStepperCollection);
});
if (typeof window !== "undefined") window.HSStepper = $337d9a5ed351f458$var$HSStepper;
var $337d9a5ed351f458$export$2e2bcd8739ae039 = $337d9a5ed351f458$var$HSStepper;


/*
 * HSStrongPassword
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 

class $36a0e440f8597468$var$HSStrongPassword extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options){
        super(el, options);
        this.isOpened = false;
        this.strength = 0;
        this.passedRules = new Set();
        const data = el.getAttribute("data-hs-strong-password");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.target = concatOptions?.target ? typeof concatOptions?.target === "string" ? document.querySelector(concatOptions.target) : concatOptions.target : null;
        this.hints = concatOptions?.hints ? typeof concatOptions?.hints === "string" ? document.querySelector(concatOptions.hints) : concatOptions.hints : null;
        this.stripClasses = concatOptions?.stripClasses || null;
        this.minLength = concatOptions?.minLength || 6;
        this.mode = concatOptions?.mode || "default";
        this.popoverSpace = concatOptions?.popoverSpace || 10;
        this.checksExclude = concatOptions?.checksExclude || [];
        this.availableChecks = [
            "lowercase",
            "uppercase",
            "numbers",
            "special-characters",
            "min-length"
        ].filter((el)=>!this.checksExclude.includes(el));
        this.specialCharactersSet = concatOptions?.specialCharactersSet || "!\"#$%&'()*+,-./:;<=>?@[\\\\\\]^_`{|}~";
        if (this.target) this.init();
    }
    init() {
        this.createCollection(window.$hsStrongPasswordCollection, this);
        if (this.availableChecks.length) this.build();
    }
    build() {
        this.buildStrips();
        if (this.hints) this.buildHints();
        this.setStrength(this.target.value);
        this.target.addEventListener("input", (evt)=>{
            this.setStrength(evt.target.value);
        });
    }
    buildStrips() {
        this.el.innerHTML = "";
        if (this.stripClasses) for(let i = 0; i < this.availableChecks.length; i++){
            const newStrip = (0, $478cf65b5d671095$export$c5c738da9ba7f9f)("<div></div>");
            (0, $478cf65b5d671095$export$a73398b198c9e798)(this.stripClasses, newStrip);
            this.el.append(newStrip);
        }
    }
    buildHints() {
        this.weakness = this.hints.querySelector("[data-hs-strong-password-hints-weakness-text]") || null;
        this.rules = Array.from(this.hints.querySelectorAll("[data-hs-strong-password-hints-rule-text]")) || null;
        this.rules.forEach((rule)=>{
            const ruleValue = rule.getAttribute("data-hs-strong-password-hints-rule-text");
            if (this.checksExclude?.includes(ruleValue)) rule.remove();
        });
        if (this.weakness) this.buildWeakness();
        if (this.rules) this.buildRules();
        if (this.mode === "popover") {
            this.target.addEventListener("focus", ()=>{
                this.isOpened = true;
                this.hints.classList.remove("hidden");
                this.hints.classList.add("block");
                this.recalculateDirection();
            });
            this.target.addEventListener("blur", ()=>{
                this.isOpened = false;
                this.hints.classList.remove("block", "bottom-full", "top-full");
                this.hints.classList.add("hidden");
                this.hints.style.marginTop = "";
                this.hints.style.marginBottom = "";
            });
        }
    }
    buildWeakness() {
        this.checkStrength(this.target.value);
        this.setWeaknessText();
        this.target.addEventListener("input", ()=>setTimeout(()=>this.setWeaknessText()));
    }
    buildRules() {
        this.setRulesText();
        this.target.addEventListener("input", ()=>setTimeout(()=>this.setRulesText()));
    }
    setWeaknessText() {
        const weaknessText = this.weakness.getAttribute("data-hs-strong-password-hints-weakness-text");
        const weaknessTextToJson = JSON.parse(weaknessText);
        this.weakness.textContent = weaknessTextToJson[this.strength];
    }
    setRulesText() {
        this.rules.forEach((rule)=>{
            const ruleValue = rule.getAttribute("data-hs-strong-password-hints-rule-text");
            this.checkIfPassed(rule, this.passedRules.has(ruleValue));
        });
    }
    togglePopover() {
        const popover = this.el.querySelector(".popover");
        if (popover) popover.classList.toggle("show");
    }
    checkStrength(val) {
        const passedRules = new Set();
        const regexps = {
            lowercase: /[a-z]+/,
            uppercase: /[A-Z]+/,
            numbers: /[0-9]+/,
            "special-characters": new RegExp(`[${this.specialCharactersSet}]`)
        };
        let strength = 0;
        if (this.availableChecks.includes("lowercase") && val.match(regexps["lowercase"])) {
            strength += 1;
            passedRules.add("lowercase");
        }
        if (this.availableChecks.includes("uppercase") && val.match(regexps["uppercase"])) {
            strength += 1;
            passedRules.add("uppercase");
        }
        if (this.availableChecks.includes("numbers") && val.match(regexps["numbers"])) {
            strength += 1;
            passedRules.add("numbers");
        }
        if (this.availableChecks.includes("special-characters") && val.match(regexps["special-characters"])) {
            strength += 1;
            passedRules.add("special-characters");
        }
        if (this.availableChecks.includes("min-length") && val.length >= this.minLength) {
            strength += 1;
            passedRules.add("min-length");
        }
        if (!val.length) strength = 0;
        if (strength === this.availableChecks.length) this.el.classList.add("accepted");
        else this.el.classList.remove("accepted");
        this.strength = strength;
        this.passedRules = passedRules;
        return {
            strength: this.strength,
            rules: this.passedRules
        };
    }
    checkIfPassed(el, isRulePassed = false) {
        const check = el.querySelector("[data-check]");
        const uncheck = el.querySelector("[data-uncheck]");
        if (isRulePassed) {
            el.classList.add("active");
            check.classList.remove("hidden");
            uncheck.classList.add("hidden");
        } else {
            el.classList.remove("active");
            check.classList.add("hidden");
            uncheck.classList.remove("hidden");
        }
    }
    setStrength(val) {
        const { strength: strength, rules: rules } = this.checkStrength(val);
        const payload = {
            strength: strength,
            rules: rules
        };
        this.hideStrips(strength);
        this.fireEvent("change", payload);
        (0, $478cf65b5d671095$export$635e15bbd66f01ea)("change.hs.strongPassword", this.el, payload);
    }
    hideStrips(qty) {
        Array.from(this.el.children).forEach((el, i)=>{
            if (i < qty) el.classList.add("passed");
            else el.classList.remove("passed");
        });
    }
    // Public methods
    recalculateDirection() {
        if ((0, $478cf65b5d671095$export$e3db11022a3681e4)(this.hints, this.target, "bottom", this.popoverSpace)) {
            this.hints.classList.remove("bottom-full");
            this.hints.classList.add("top-full");
            this.hints.style.marginBottom = "";
            this.hints.style.marginTop = `${this.popoverSpace}px`;
        } else {
            this.hints.classList.remove("top-full");
            this.hints.classList.add("bottom-full");
            this.hints.style.marginTop = "";
            this.hints.style.marginBottom = `${this.popoverSpace}px`;
        }
    }
    // Static methods
    static getInstance(target) {
        const elInCollection = window.$hsStrongPasswordCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsStrongPasswordCollection) window.$hsStrongPasswordCollection = [];
        document.querySelectorAll("[data-hs-strong-password]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsStrongPasswordCollection.find((elC)=>elC?.element?.el === el)) {
                const data = el.getAttribute("data-hs-strong-password");
                const options = data ? JSON.parse(data) : {};
                new $36a0e440f8597468$var$HSStrongPassword(el, options);
            }
        });
    }
}
window.addEventListener("load", ()=>{
    $36a0e440f8597468$var$HSStrongPassword.autoInit();
// Uncomment for debug
// console.log('Strong password collection:', window.$hsStrongPasswordCollection);
});
document.addEventListener("scroll", ()=>{
    if (!window.$hsStrongPasswordCollection) return false;
    const target = window.$hsStrongPasswordCollection.find((el)=>el.element.isOpened);
    if (target) target.element.recalculateDirection();
});
if (typeof window !== "undefined") window.HSStrongPassword = $36a0e440f8597468$var$HSStrongPassword;
var $36a0e440f8597468$export$2e2bcd8739ae039 = $36a0e440f8597468$var$HSStrongPassword;


/*
 * HSTabs
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 


class $6784483c0c3eb726$var$HSTabs extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options, events){
        super(el, options, events);
        this.toggles = this.el.querySelectorAll("[data-hs-tab]");
        this.extraToggleId = this.el.getAttribute("hs-data-tab-select");
        this.extraToggle = document.querySelector(this.extraToggleId);
        this.current = Array.from(this.toggles).find((el)=>el.classList.contains("active"));
        this.currentContentId = this.current.getAttribute("data-hs-tab");
        this.currentContent = document.querySelector(this.currentContentId);
        this.prev = null;
        this.prevContentId = null;
        this.prevContent = null;
        this.init();
    }
    init() {
        this.createCollection(window.$hsTabsCollection, this);
        this.toggles.forEach((el)=>{
            el.addEventListener("click", ()=>this.open(el));
        });
        if (this.extraToggle) this.extraToggle.addEventListener("change", (evt)=>this.change(evt));
    }
    open(el) {
        this.prev = this.current;
        this.prevContentId = this.currentContentId;
        this.prevContent = this.currentContent;
        this.current = el;
        this.currentContentId = this.current.getAttribute("data-hs-tab");
        this.currentContent = document.querySelector(this.currentContentId);
        this.prev.classList.remove("active");
        this.prevContent.classList.add("hidden");
        this.current.classList.add("active");
        this.currentContent.classList.remove("hidden");
        this.fireEvent("change", {
            el: el,
            prev: this.prevContentId,
            current: this.currentContentId
        });
        (0, $478cf65b5d671095$export$635e15bbd66f01ea)("change.hs.tab", el, {
            el: el,
            prev: this.prevContentId,
            current: this.currentContentId
        });
    }
    change(evt) {
        const toggle = document.querySelector(`[data-hs-tab="${evt.target.value}"]`);
        if (toggle) toggle.click();
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsTabsCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsTabsCollection) window.$hsTabsCollection = [];
        document.querySelectorAll('[role="tablist"]:not(select):not(.--prevent-on-load-init)').forEach((el)=>{
            if (!window.$hsTabsCollection.find((elC)=>elC?.element?.el === el)) new $6784483c0c3eb726$var$HSTabs(el);
        });
        if (window.$hsTabsCollection) document.addEventListener("keydown", (evt)=>$6784483c0c3eb726$var$HSTabs.accessibility(evt));
    }
    static open(target) {
        const elInCollection = window.$hsTabsCollection.find((el)=>Array.from(el.element.toggles).includes(typeof target === "string" ? document.querySelector(target) : target));
        const targetInCollection = Array.from(elInCollection.element.toggles).find((el)=>el === (typeof target === "string" ? document.querySelector(target) : target));
        if (targetInCollection && !targetInCollection.classList.contains("active")) elInCollection.element.open(targetInCollection);
    }
    // Accessibility methods
    static accessibility(evt) {
        const target = document.querySelector("[data-hs-tab]:focus");
        if (target && (0, $704e031c65277337$export$8c1058a58d2daf41).includes(evt.code) && !evt.metaKey) {
            const isVertical = target.closest('[role="tablist"]').getAttribute("data-hs-tabs-vertical");
            evt.preventDefault();
            switch(evt.code){
                case isVertical === "true" ? "ArrowUp" : "ArrowLeft":
                    this.onArrow();
                    break;
                case isVertical === "true" ? "ArrowDown" : "ArrowRight":
                    this.onArrow(false);
                    break;
                case "Home":
                    this.onStartEnd();
                    break;
                case "End":
                    this.onStartEnd(false);
                    break;
                default:
                    break;
            }
        }
    }
    static onArrow(isOpposite = true) {
        const target = document.querySelector("[data-hs-tab]:focus").closest('[role="tablist"]');
        const targetInCollection = window.$hsTabsCollection.find((el)=>el.element.el === target);
        if (targetInCollection) {
            const toggles = isOpposite ? Array.from(targetInCollection.element.toggles).reverse() : Array.from(targetInCollection.element.toggles);
            const focused = toggles.find((el)=>document.activeElement === el);
            let focusedInd = toggles.findIndex((el)=>el === focused);
            focusedInd = focusedInd + 1 < toggles.length ? focusedInd + 1 : 0;
            toggles[focusedInd].focus();
            toggles[focusedInd].click();
        }
    }
    static onStartEnd(isOpposite = true) {
        const target = document.querySelector("[data-hs-tab]:focus").closest('[role="tablist"]');
        const targetInCollection = window.$hsTabsCollection.find((el)=>el.element.el === target);
        if (targetInCollection) {
            const toggles = isOpposite ? Array.from(targetInCollection.element.toggles) : Array.from(targetInCollection.element.toggles).reverse();
            if (toggles.length) {
                toggles[0].focus();
                toggles[0].click();
            }
        }
    }
    // Backward compatibility
    static on(evt, target, cb) {
        const elInCollection = window.$hsTabsCollection.find((el)=>Array.from(el.element.toggles).includes(typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection) elInCollection.element.events[evt] = cb;
    }
}
window.addEventListener("load", ()=>{
    $6784483c0c3eb726$var$HSTabs.autoInit();
// Uncomment for debug
// console.log('Tabs collection:', window.$hsTabsCollection);
});
if (typeof window !== "undefined") window.HSTabs = $6784483c0c3eb726$var$HSTabs;
var $6784483c0c3eb726$export$2e2bcd8739ae039 = $6784483c0c3eb726$var$HSTabs;


/*
 * HSThemeSwitch
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 
class $6deeff70b35b9220$var$HSThemeSwitch extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-theme-switch");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.theme = concatOptions?.theme || localStorage.getItem("hs_theme") || "default";
        this.themeSet = [
            "light",
            "dark",
            "default"
        ];
        this.init();
    }
    init() {
        this.createCollection(window.$hsThemeSwitchCollection, this);
        if (this.theme !== "default") this.setAppearance();
    }
    setResetStyles() {
        const style = document.createElement("style");
        style.innerText = `*{transition: unset !important;}`;
        style.setAttribute("data-hs-appearance-onload-styles", "");
        document.head.appendChild(style);
        return style;
    }
    addSystemThemeObserver() {
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", ({ matches: matches })=>{
            if (matches) this.setAppearance("dark", false);
            else this.setAppearance("default", false);
        });
    }
    removeSystemThemeObserver() {
        window.matchMedia("(prefers-color-scheme: dark)").removeEventListener;
    }
    // Public methods
    setAppearance(theme = this.theme, isSaveToLocalStorage = true, isSetDispatchEvent = true) {
        const html = document.querySelector("html");
        const resetStyles = this.setResetStyles();
        if (isSaveToLocalStorage) localStorage.setItem("hs_theme", theme);
        if (theme === "auto") theme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "default";
        html.classList.remove("light", "dark", "default", "auto");
        html.classList.add(theme);
        setTimeout(()=>resetStyles.remove());
        if (isSetDispatchEvent) window.dispatchEvent(new CustomEvent("on-hs-appearance-change", {
            detail: theme
        }));
    }
    // Static methods
    static getInstance(target) {
        const elInCollection = window.$hsThemeSwitchCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsThemeSwitchCollection) window.$hsThemeSwitchCollection = [];
        const toggleObserveSystemTheme = (el)=>{
            if (localStorage.getItem("hs_theme") === "auto") el.addSystemThemeObserver();
            else el.removeSystemThemeObserver();
        };
        document.querySelectorAll("[data-hs-theme-switch]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsThemeSwitchCollection.find((elC)=>elC?.element?.el === el)) {
                const switchTheme = new $6deeff70b35b9220$var$HSThemeSwitch(el);
                switchTheme.el.checked = switchTheme.theme === "dark";
                toggleObserveSystemTheme(switchTheme);
                switchTheme.el.addEventListener("change", (evt)=>{
                    const theme = evt.target.checked ? "dark" : "default";
                    switchTheme.setAppearance(theme);
                    toggleObserveSystemTheme(switchTheme);
                });
            }
        });
        document.querySelectorAll("[data-hs-theme-click-value]:not(.--prevent-on-load-init)").forEach((el)=>{
            const theme = el.getAttribute("data-hs-theme-click-value");
            const switchTheme = new $6deeff70b35b9220$var$HSThemeSwitch(el);
            toggleObserveSystemTheme(switchTheme);
            switchTheme.el.addEventListener("click", ()=>{
                switchTheme.setAppearance(theme);
                toggleObserveSystemTheme(switchTheme);
            });
        });
    }
}
window.addEventListener("load", ()=>{
    $6deeff70b35b9220$var$HSThemeSwitch.autoInit();
// Uncomment for debug
// console.log('Theme switch collection:', window.$hsThemeSwitchCollection);
});
if (window.$hsThemeSwitchCollection) window.addEventListener("on-hs-appearance-change", (evt)=>{
    window.$hsThemeSwitchCollection.forEach((el)=>{
        el.element.el.checked = evt.detail === "dark";
    });
});
if (typeof window !== "undefined") window.HSThemeSwitch = $6deeff70b35b9220$var$HSThemeSwitch;
var $6deeff70b35b9220$export$2e2bcd8739ae039 = $6deeff70b35b9220$var$HSThemeSwitch;


/*
 * HSToggleCount
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 
class $240fbed97ca869e3$var$HSToggleCount extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-toggle-count");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        this.target = concatOptions?.target ? typeof concatOptions?.target === "string" ? document.querySelector(concatOptions.target) : concatOptions.target : null;
        this.min = concatOptions?.min || 0;
        this.max = concatOptions?.max || 0;
        this.duration = concatOptions?.duration || 700;
        this.isChecked = this.target.checked || false;
        if (this.target) this.init();
    }
    init() {
        this.createCollection(window.$hsToggleCountCollection, this);
        if (this.isChecked) this.el.innerText = String(this.max);
        this.target.addEventListener("change", ()=>{
            this.isChecked = !this.isChecked;
            this.toggle();
        });
    }
    toggle() {
        if (this.isChecked) this.countUp();
        else this.countDown();
    }
    animate(from, to) {
        let startTimestamp = 0;
        const step = (timestamp)=>{
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / this.duration, 1);
            this.el.innerText = String(Math.floor(progress * (to - from) + from));
            if (progress < 1) window.requestAnimationFrame(step);
        };
        window.requestAnimationFrame(step);
    }
    // Public methods
    countUp() {
        this.animate(this.min, this.max);
    }
    countDown() {
        this.animate(this.max, this.min);
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsToggleCountCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsToggleCountCollection) window.$hsToggleCountCollection = [];
        document.querySelectorAll("[data-hs-toggle-count]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsToggleCountCollection.find((elC)=>elC?.element?.el === el)) new $240fbed97ca869e3$var$HSToggleCount(el);
        });
    }
}
window.addEventListener("load", ()=>{
    $240fbed97ca869e3$var$HSToggleCount.autoInit();
// Uncomment for debug
// console.log('Toggle count collection:', window.$hsToggleCountCollection);
});
if (typeof window !== "undefined") window.HSToggleCount = $240fbed97ca869e3$var$HSToggleCount;
var $240fbed97ca869e3$export$2e2bcd8739ae039 = $240fbed97ca869e3$var$HSToggleCount;


/*
 * HSTogglePassword
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 

class $a5c5fbeaba71ef8c$var$HSTogglePassword extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options){
        super(el, options);
        const data = el.getAttribute("data-hs-toggle-password");
        const dataOptions = data ? JSON.parse(data) : {};
        const concatOptions = {
            ...dataOptions,
            ...options
        };
        const targets = [];
        if (concatOptions?.target && typeof concatOptions?.target === "string") {
            const ids = concatOptions?.target.split(",");
            ids.forEach((id)=>{
                targets.push(document.querySelector(id));
            });
        } else if (concatOptions?.target && typeof concatOptions?.target === "object") concatOptions.target.forEach((el)=>targets.push(document.querySelector(el)));
        else concatOptions.target.forEach((el)=>targets.push(el));
        this.target = targets;
        this.isShown = this.el.hasAttribute("type") ? this.el.checked : false;
        this.eventType = (0, $478cf65b5d671095$export$5da71380ac3cd382)(this.el) ? "change" : "click";
        this.isMultiple = this.target.length > 1 && !!this.el.closest("[data-hs-toggle-password-group]");
        if (this.target) this.init();
    }
    init() {
        this.createCollection(window.$hsTogglePasswordCollection, this);
        if (!this.isShown) this.hide();
        else this.show();
        this.el.addEventListener(this.eventType, ()=>{
            if (this.isShown) this.hide();
            else this.show();
            this.fireEvent("toggle", this.target);
            (0, $478cf65b5d671095$export$635e15bbd66f01ea)("toggle.hs.toggle-select", this.el, this.target);
        });
    }
    getMultipleToggles() {
        const group = this.el.closest("[data-hs-toggle-password-group]");
        const toggles = group.querySelectorAll("[data-hs-toggle-password]");
        const togglesInCollection = [];
        toggles.forEach((el)=>{
            togglesInCollection.push($a5c5fbeaba71ef8c$var$HSTogglePassword.getInstance(el));
        });
        return togglesInCollection;
    }
    // Public methods
    show() {
        if (this.isMultiple) {
            const toggles = this.getMultipleToggles();
            toggles.forEach((el)=>el ? el.isShown = true : false);
            this.el.closest("[data-hs-toggle-password-group]").classList.add("active");
        } else {
            this.isShown = true;
            this.el.classList.add("active");
        }
        this.target.forEach((el)=>{
            el.type = "text";
        });
    }
    hide() {
        if (this.isMultiple) {
            const toggles = this.getMultipleToggles();
            toggles.forEach((el)=>el ? el.isShown = false : false);
            this.el.closest("[data-hs-toggle-password-group]").classList.remove("active");
        } else {
            this.isShown = false;
            this.el.classList.remove("active");
        }
        this.target.forEach((el)=>{
            el.type = "password";
        });
    }
    // Static methods
    static getInstance(target, isInstance) {
        const elInCollection = window.$hsTogglePasswordCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element : null;
    }
    static autoInit() {
        if (!window.$hsTogglePasswordCollection) window.$hsTogglePasswordCollection = [];
        document.querySelectorAll("[data-hs-toggle-password]:not(.--prevent-on-load-init)").forEach((el)=>{
            if (!window.$hsTogglePasswordCollection.find((elC)=>elC?.element?.el === el)) new $a5c5fbeaba71ef8c$var$HSTogglePassword(el);
        });
    }
}
window.addEventListener("load", ()=>{
    $a5c5fbeaba71ef8c$var$HSTogglePassword.autoInit();
// Uncomment for debug
// console.log('Toggle password collection:', window.$hsTogglePasswordCollection);
});
if (typeof window !== "undefined") window.HSTogglePassword = $a5c5fbeaba71ef8c$var$HSTogglePassword;
var $a5c5fbeaba71ef8c$export$2e2bcd8739ae039 = $a5c5fbeaba71ef8c$var$HSTogglePassword;


/*
 * HSTooltip
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 



class $6da614c11ce1004c$var$HSTooltip extends (0, $0288c6577afded82$export$2e2bcd8739ae039) {
    constructor(el, options, events){
        super(el, options, events);
        if (this.el) {
            this.toggle = this.el.querySelector(".hs-tooltip-toggle") || this.el;
            this.content = this.el.querySelector(".hs-tooltip-content");
            this.eventMode = (0, $478cf65b5d671095$export$11a826c585352eb8)(this.el, "--trigger") || "hover";
            this.preventPopper = (0, $478cf65b5d671095$export$11a826c585352eb8)(this.el, "--prevent-popper", "false");
            this.placement = (0, $478cf65b5d671095$export$11a826c585352eb8)(this.el, "--placement");
            this.strategy = (0, $478cf65b5d671095$export$11a826c585352eb8)(this.el, "--strategy");
        }
        if (this.el && this.toggle && this.content) this.init();
    }
    init() {
        this.createCollection(window.$hsTooltipCollection, this);
        if (this.eventMode === "click") this.toggle.addEventListener("click", ()=>this.click());
        else if (this.eventMode === "focus") this.toggle.addEventListener("click", ()=>this.focus());
        else if (this.eventMode === "hover") {
            this.toggle.addEventListener("mouseenter", ()=>this.enter());
            this.toggle.addEventListener("mouseleave", ()=>this.leave());
        }
        if (this.preventPopper === "false") this.buildPopper();
    }
    enter() {
        this.show();
    }
    leave() {
        this.hide();
    }
    click() {
        if (this.el.classList.contains("show")) return false;
        this.show();
        const handle = ()=>{
            setTimeout(()=>{
                this.hide();
                this.toggle.removeEventListener("click", handle, true);
                this.toggle.removeEventListener("blur", handle, true);
            });
        };
        this.toggle.addEventListener("click", handle, true);
        this.toggle.addEventListener("blur", handle, true);
    }
    focus() {
        this.show();
        const handle = ()=>{
            this.hide();
            this.toggle.removeEventListener("blur", handle, true);
        };
        this.toggle.addEventListener("blur", handle, true);
    }
    buildPopper() {
        this.popperInstance = (0, $1bf0bf541303046d$export$8f7491d57c8f97a9)(this.toggle, this.content, {
            placement: (0, $704e031c65277337$export$1a1f61c9c4dd9df0)[this.placement] || "top",
            strategy: this.strategy || "fixed",
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            5
                        ]
                    }
                }
            ]
        });
    }
    // Public methods
    show() {
        this.content.classList.remove("hidden");
        if (this.preventPopper === "false") {
            this.popperInstance.setOptions((options)=>({
                    ...options,
                    modifiers: [
                        ...options.modifiers,
                        {
                            name: "eventListeners",
                            enabled: true
                        }
                    ]
                }));
            this.popperInstance.update();
        }
        setTimeout(()=>{
            this.el.classList.add("show");
            this.fireEvent("show", this.el);
            (0, $478cf65b5d671095$export$635e15bbd66f01ea)("show.hs.tooltip", this.el, this.el);
        });
    }
    hide() {
        this.el.classList.remove("show");
        if (this.preventPopper === "false") this.popperInstance.setOptions((options)=>({
                ...options,
                modifiers: [
                    ...options.modifiers,
                    {
                        name: "eventListeners",
                        enabled: false
                    }
                ]
            }));
        this.fireEvent("hide", this.el);
        (0, $478cf65b5d671095$export$635e15bbd66f01ea)("hide.hs.tooltip", this.el, this.el);
        (0, $478cf65b5d671095$export$24d4b3961cffb4db)(this.content, ()=>{
            if (this.el.classList.contains("show")) return false;
            this.content.classList.add("hidden");
        });
    }
    // Static methods
    static getInstance(target, isInstance = false) {
        const elInCollection = window.$hsTooltipCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        return elInCollection ? isInstance ? elInCollection : elInCollection.element.el : null;
    }
    static autoInit() {
        if (!window.$hsTooltipCollection) window.$hsTooltipCollection = [];
        document.querySelectorAll(".hs-tooltip").forEach((el)=>{
            if (!window.$hsTooltipCollection.find((elC)=>elC?.element?.el === el)) new $6da614c11ce1004c$var$HSTooltip(el);
        });
    }
    static show(target) {
        const elInCollection = window.$hsTooltipCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection) switch(elInCollection.element.eventMode){
            case "click":
                elInCollection.element.click();
                break;
            case "focus":
                elInCollection.element.focus();
                break;
            default:
                elInCollection.element.enter();
                break;
        }
    }
    static hide(target) {
        const elInCollection = window.$hsTooltipCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection) elInCollection.element.hide();
    }
    // Backward compatibility
    static on(evt, target, cb) {
        const elInCollection = window.$hsTooltipCollection.find((el)=>el.element.el === (typeof target === "string" ? document.querySelector(target) : target));
        if (elInCollection) elInCollection.element.events[evt] = cb;
    }
}
window.addEventListener("load", ()=>{
    $6da614c11ce1004c$var$HSTooltip.autoInit();
// Uncomment for debug
// console.log('Tooltip collection:', window.$hsTooltipCollection);
});
if (typeof window !== "undefined") window.HSTooltip = $6da614c11ce1004c$var$HSTooltip;
var $6da614c11ce1004c$export$2e2bcd8739ae039 = $6da614c11ce1004c$var$HSTooltip;


/*
 * HSStaticMethods
 * @version: 2.1.0
 * @author: HTMLStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 HTMLStream
 */ 


















const $6bd458bda1d4f575$export$c863840a8dc6e11d = [
    {
        key: "copy-markup",
        fn: (0, $0c306a747591bace$export$2e2bcd8739ae039)
    },
    {
        key: "accordion",
        fn: (0, $fdf3273b082fdf99$export$2e2bcd8739ae039)
    },
    {
        key: "carousel",
        fn: (0, $21e0b253669cf069$export$2e2bcd8739ae039)
    },
    {
        key: "collapse",
        fn: (0, $c33bd9274652961f$export$2e2bcd8739ae039)
    },
    {
        key: "combobox",
        fn: (0, $4dd20d6ee44ededb$export$2e2bcd8739ae039)
    },
    {
        key: "dropdown",
        fn: (0, $3165a178822236d6$export$2e2bcd8739ae039)
    },
    {
        key: "input-number",
        fn: (0, $278cd9d7635fbaf2$export$2e2bcd8739ae039)
    },
    {
        key: "overlay",
        fn: (0, $8f2f97605797e558$export$2e2bcd8739ae039)
    },
    {
        key: "pin-input",
        fn: (0, $4a788dc9d3bacdfa$export$2e2bcd8739ae039)
    },
    {
        key: "remove-element",
        fn: (0, $308f48fd3b91efe3$export$2e2bcd8739ae039)
    },
    {
        key: "scrollspy",
        fn: (0, $123fc6210ee090d1$export$2e2bcd8739ae039)
    },
    {
        key: "select",
        fn: (0, $45555ee5ed0eeb66$export$2e2bcd8739ae039)
    },
    {
        key: "stepper",
        fn: (0, $337d9a5ed351f458$export$2e2bcd8739ae039)
    },
    {
        key: "strong-password",
        fn: (0, $36a0e440f8597468$export$2e2bcd8739ae039)
    },
    {
        key: "tabs",
        fn: (0, $6784483c0c3eb726$export$2e2bcd8739ae039)
    },
    {
        key: "toggle-count",
        fn: (0, $240fbed97ca869e3$export$2e2bcd8739ae039)
    },
    {
        key: "toggle-password",
        fn: (0, $a5c5fbeaba71ef8c$export$2e2bcd8739ae039)
    },
    {
        key: "tooltip",
        fn: (0, $6da614c11ce1004c$export$2e2bcd8739ae039)
    }
];


const $d497f11d93434110$var$HSStaticMethods = {
    getClassProperty: $478cf65b5d671095$export$11a826c585352eb8,
    afterTransition: $478cf65b5d671095$export$24d4b3961cffb4db,
    autoInit (collection = "all") {
        if (collection === "all") (0, $6bd458bda1d4f575$export$c863840a8dc6e11d).forEach(({ fn: fn })=>{
            fn?.autoInit();
        });
        else (0, $6bd458bda1d4f575$export$c863840a8dc6e11d).forEach(({ key: key, fn: fn })=>{
            if (collection.includes(key)) fn?.autoInit();
        });
    }
};
if (typeof window !== "undefined") window.HSStaticMethods = $d497f11d93434110$var$HSStaticMethods;
var $d497f11d93434110$export$2e2bcd8739ae039 = $d497f11d93434110$var$HSStaticMethods;




/*!
 * Glide.js v3.6.0
 * (c) 2013-2023 Jędrzej Chałubek (https://github.com/jedrzejchalubek/)
 * Released under the MIT License.
 */ function $5137c3620ef83169$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5137c3620ef83169$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $5137c3620ef83169$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5137c3620ef83169$var$_typeof(obj);
}
function $5137c3620ef83169$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5137c3620ef83169$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5137c3620ef83169$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5137c3620ef83169$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5137c3620ef83169$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5137c3620ef83169$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $5137c3620ef83169$var$_setPrototypeOf(subClass, superClass);
}
function $5137c3620ef83169$var$_getPrototypeOf(o) {
    $5137c3620ef83169$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5137c3620ef83169$var$_getPrototypeOf(o);
}
function $5137c3620ef83169$var$_setPrototypeOf(o, p) {
    $5137c3620ef83169$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5137c3620ef83169$var$_setPrototypeOf(o, p);
}
function $5137c3620ef83169$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5137c3620ef83169$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5137c3620ef83169$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $5137c3620ef83169$var$_assertThisInitialized(self);
}
function $5137c3620ef83169$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5137c3620ef83169$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5137c3620ef83169$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5137c3620ef83169$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5137c3620ef83169$var$_possibleConstructorReturn(this, result);
    };
}
function $5137c3620ef83169$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $5137c3620ef83169$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $5137c3620ef83169$var$_get() {
    if (typeof Reflect !== "undefined" && Reflect.get) $5137c3620ef83169$var$_get = Reflect.get;
    else $5137c3620ef83169$var$_get = function _get(target, property, receiver) {
        var base = $5137c3620ef83169$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
        return desc.value;
    };
    return $5137c3620ef83169$var$_get.apply(this, arguments);
}
var $5137c3620ef83169$var$defaults = {
    /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */ type: "slider",
    /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */ startAt: 0,
    /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */ perView: 1,
    /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */ focusAt: 0,
    /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */ gap: 10,
    /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */ autoplay: false,
    /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */ hoverpause: true,
    /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */ keyboard: true,
    /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */ bound: false,
    /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */ swipeThreshold: 80,
    /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */ dragThreshold: 120,
    /**
   * A number of slides moved on single swipe.
   *
   * Available types:
   * `` - Moves slider by one slide per swipe
   * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
   *
   * @type {String}
   */ perSwipe: "",
    /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */ touchRatio: 0.5,
    /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */ touchAngle: 45,
    /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */ animationDuration: 400,
    /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */ rewind: true,
    /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */ rewindDuration: 800,
    /**
   * Easing function for the animation.
   *
   * @type {String}
   */ animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
    /**
   * Wait for the animation to finish until the next user input can be processed
   *
   * @type {boolean}
   */ waitForTransition: true,
    /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */ throttle: 10,
    /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */ direction: "ltr",
    /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */ peek: 0,
    /**
   * Defines how many clones of current viewport will be generated.
   *
   * @type {Number}
   */ cloningRatio: 1,
    /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */ breakpoints: {},
    /**
   * Enable lazy loading.
   *
   * @type {Boolean}
   */ lazy: false,
    /**
   * Defines the threshold in which lazy loading will begin.
   * For example: a threshold of 1.2 will load the images if the carousel/slider
   * is within 120% of the screen width and height
   *
   * @type {Number}
   */ lazyScrollThreshold: 1.2,
    /**
   * Defines the inital amount of slides to be loaded
   *
   * @type {Number}
   */ lazyInitialSlidesLoaded: 2,
    /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */ classes: {
        swipeable: "glide--swipeable",
        dragging: "glide--dragging",
        direction: {
            ltr: "glide--ltr",
            rtl: "glide--rtl"
        },
        type: {
            slider: "glide--slider",
            carousel: "glide--carousel"
        },
        slide: {
            clone: "glide__slide--clone",
            active: "glide__slide--active"
        },
        arrow: {
            disabled: "glide__arrow--disabled"
        },
        nav: {
            active: "glide__bullet--active"
        }
    }
};
/**
 * Outputs warning message to the bowser console.
 *
 * @param  {String} msg
 * @return {Void}
 */ function $5137c3620ef83169$var$warn(msg) {
    console.error("[Glide warn]: ".concat(msg));
}
/**
 * Converts value entered as number
 * or string to integer value.
 *
 * @param {String} value
 * @returns {Number}
 */ function $5137c3620ef83169$var$toInt(value) {
    return parseInt(value);
}
/**
 * Converts value entered as number
 * or string to flat value.
 *
 * @param {String} value
 * @returns {Number}
 */ function $5137c3620ef83169$var$toFloat(value) {
    return parseFloat(value);
}
/**
 * Indicates whether the specified value is a string.
 *
 * @param  {*}   value
 * @return {Boolean}
 */ function $5137c3620ef83169$var$isString(value) {
    return typeof value === "string";
}
/**
 * Indicates whether the specified value is an object.
 *
 * @param  {*} value
 * @return {Boolean}
 *
 * @see https://github.com/jashkenas/underscore
 */ function $5137c3620ef83169$var$isObject(value) {
    var type = $5137c3620ef83169$var$_typeof(value);
    return type === "function" || type === "object" && !!value; // eslint-disable-line no-mixed-operators
}
/**
 * Indicates whether the specified value is a function.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $5137c3620ef83169$var$isFunction(value) {
    return typeof value === "function";
}
/**
 * Indicates whether the specified value is undefined.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $5137c3620ef83169$var$isUndefined(value) {
    return typeof value === "undefined";
}
/**
 * Indicates whether the specified value is an array.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $5137c3620ef83169$var$isArray(value) {
    return value.constructor === Array;
}
/**
 * Creates and initializes specified collection of extensions.
 * Each extension receives access to instance of glide and rest of components.
 *
 * @param {Object} glide
 * @param {Object} extensions
 *
 * @returns {Object}
 */ function $5137c3620ef83169$var$mount(glide, extensions, events) {
    var components = {};
    for(var name in extensions)if ($5137c3620ef83169$var$isFunction(extensions[name])) components[name] = extensions[name](glide, components, events);
    else $5137c3620ef83169$var$warn("Extension must be a function");
    for(var _name in components)if ($5137c3620ef83169$var$isFunction(components[_name].mount)) components[_name].mount();
    return components;
}
/**
 * Defines getter and setter property on the specified object.
 *
 * @param  {Object} obj         Object where property has to be defined.
 * @param  {String} prop        Name of the defined property.
 * @param  {Object} definition  Get and set definitions for the property.
 * @return {Void}
 */ function $5137c3620ef83169$var$define(obj, prop, definition) {
    Object.defineProperty(obj, prop, definition);
}
/**
 * Sorts aphabetically object keys.
 *
 * @param  {Object} obj
 * @return {Object}
 */ function $5137c3620ef83169$var$sortKeys(obj) {
    return Object.keys(obj).sort().reduce(function(r, k) {
        r[k] = obj[k];
        return r[k], r;
    }, {});
}
/**
 * Merges passed settings object with default options.
 *
 * @param  {Object} defaults
 * @param  {Object} settings
 * @return {Object}
 */ function $5137c3620ef83169$var$mergeOptions(defaults, settings) {
    var options = Object.assign({}, defaults, settings); // `Object.assign` do not deeply merge objects, so we
    // have to do it manually for every nested object
    // in options. Although it does not look smart,
    // it's smaller and faster than some fancy
    // merging deep-merge algorithm script.
    if (settings.hasOwnProperty("classes")) {
        options.classes = Object.assign({}, defaults.classes, settings.classes);
        if (settings.classes.hasOwnProperty("direction")) options.classes.direction = Object.assign({}, defaults.classes.direction, settings.classes.direction);
        if (settings.classes.hasOwnProperty("type")) options.classes.type = Object.assign({}, defaults.classes.type, settings.classes.type);
        if (settings.classes.hasOwnProperty("slide")) options.classes.slide = Object.assign({}, defaults.classes.slide, settings.classes.slide);
        if (settings.classes.hasOwnProperty("arrow")) options.classes.arrow = Object.assign({}, defaults.classes.arrow, settings.classes.arrow);
        if (settings.classes.hasOwnProperty("nav")) options.classes.nav = Object.assign({}, defaults.classes.nav, settings.classes.nav);
    }
    if (settings.hasOwnProperty("breakpoints")) options.breakpoints = Object.assign({}, defaults.breakpoints, settings.breakpoints);
    return options;
}
var $5137c3620ef83169$var$EventsBus = /*#__PURE__*/ function() {
    /**
   * Construct a EventBus instance.
   *
   * @param {Object} events
   */ function EventsBus() {
        var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $5137c3620ef83169$var$_classCallCheck(this, EventsBus);
        this.events = events;
        this.hop = events.hasOwnProperty;
    }
    /**
   * Adds listener to the specifed event.
   *
   * @param {String|Array} event
   * @param {Function} handler
   */ $5137c3620ef83169$var$_createClass(EventsBus, [
        {
            key: "on",
            value: function on(event, handler) {
                if ($5137c3620ef83169$var$isArray(event)) {
                    for(var i = 0; i < event.length; i++)this.on(event[i], handler);
                    return;
                } // Create the event's object if not yet created
                if (!this.hop.call(this.events, event)) this.events[event] = [];
                 // Add the handler to queue
                var index = this.events[event].push(handler) - 1; // Provide handle back for removal of event
                return {
                    remove: function remove() {
                        delete this.events[event][index];
                    }
                };
            }
        },
        {
            key: "emit",
            value: function emit(event, context) {
                if ($5137c3620ef83169$var$isArray(event)) {
                    for(var i = 0; i < event.length; i++)this.emit(event[i], context);
                    return;
                } // If the event doesn't exist, or there's no handlers in queue, just leave
                if (!this.hop.call(this.events, event)) return;
                 // Cycle through events queue, fire!
                this.events[event].forEach(function(item) {
                    item(context || {});
                });
            }
        }
    ]);
    return EventsBus;
}();
var $5137c3620ef83169$var$Glide$1 = /*#__PURE__*/ function() {
    /**
   * Construct glide.
   *
   * @param  {String} selector
   * @param  {Object} options
   */ function Glide(selector) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $5137c3620ef83169$var$_classCallCheck(this, Glide);
        this._c = {};
        this._t = [];
        this._e = new $5137c3620ef83169$var$EventsBus();
        this.disabled = false;
        this.selector = selector;
        this.settings = $5137c3620ef83169$var$mergeOptions($5137c3620ef83169$var$defaults, options);
        this.index = this.settings.startAt;
    }
    /**
   * Initializes glide.
   *
   * @param {Object} extensions Collection of extensions to initialize.
   * @return {Glide}
   */ $5137c3620ef83169$var$_createClass(Glide, [
        {
            key: "mount",
            value: function mount$1() {
                var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this._e.emit("mount.before");
                if ($5137c3620ef83169$var$isObject(extensions)) this._c = $5137c3620ef83169$var$mount(this, extensions, this._e);
                else $5137c3620ef83169$var$warn("You need to provide a object on `mount()`");
                this._e.emit("mount.after");
                return this;
            }
        },
        {
            key: "mutate",
            value: function mutate() {
                var transformers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                if ($5137c3620ef83169$var$isArray(transformers)) this._t = transformers;
                else $5137c3620ef83169$var$warn("You need to provide a array on `mutate()`");
                return this;
            }
        },
        {
            key: "update",
            value: function update() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this.settings = $5137c3620ef83169$var$mergeOptions(this.settings, settings);
                if (settings.hasOwnProperty("startAt")) this.index = settings.startAt;
                this._e.emit("update");
                return this;
            }
        },
        {
            key: "go",
            value: function go(pattern) {
                this._c.Run.make(pattern);
                return this;
            }
        },
        {
            key: "move",
            value: function move(distance) {
                this._c.Transition.disable();
                this._c.Move.make(distance);
                return this;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this._e.emit("destroy");
                return this;
            }
        },
        {
            key: "play",
            value: function play() {
                var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                if (interval) this.settings.autoplay = interval;
                this._e.emit("play");
                return this;
            }
        },
        {
            key: "pause",
            value: function pause() {
                this._e.emit("pause");
                return this;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.disabled = true;
                return this;
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.disabled = false;
                return this;
            }
        },
        {
            key: "on",
            value: function on(event, handler) {
                this._e.on(event, handler);
                return this;
            }
        },
        {
            key: "isType",
            value: function isType(name) {
                return this.settings.type === name;
            }
        },
        {
            key: "settings",
            get: function get() {
                return this._o;
            },
            set: function set(o) {
                if ($5137c3620ef83169$var$isObject(o)) this._o = o;
                else $5137c3620ef83169$var$warn("Options must be an `object` instance.");
            }
        },
        {
            key: "index",
            get: function get() {
                return this._i;
            },
            set: function set(i) {
                this._i = $5137c3620ef83169$var$toInt(i);
            }
        },
        {
            key: "type",
            get: function get() {
                return this.settings.type;
            }
        },
        {
            key: "disabled",
            get: function get() {
                return this._d;
            },
            set: function set(status) {
                this._d = !!status;
            }
        }
    ]);
    return Glide;
}();
function $5137c3620ef83169$var$Run(Glide, Components, Events) {
    var Run = {
        /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */ mount: function mount() {
            this._o = false;
        },
        /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */ make: function make(move) {
            var _this = this;
            if (!Glide.disabled) {
                !Glide.settings.waitForTransition || Glide.disable();
                this.move = move;
                Events.emit("run.before", this.move);
                this.calculate();
                Events.emit("run", this.move);
                Components.Transition.after(function() {
                    if (_this.isStart()) Events.emit("run.start", _this.move);
                    if (_this.isEnd()) Events.emit("run.end", _this.move);
                    if (_this.isOffset()) {
                        _this._o = false;
                        Events.emit("run.offset", _this.move);
                    }
                    Events.emit("run.after", _this.move);
                    Glide.enable();
                });
            }
        },
        /**
     * Calculates current index based on defined move.
     *
     * @return {Number|Undefined}
     */ calculate: function calculate() {
            var move = this.move, length = this.length;
            var steps = move.steps, direction = move.direction; // By default assume that size of view is equal to one slide
            var viewSize = 1; // While direction is `=` we want jump to
            // a specified index described in steps.
            if (direction === "=") {
                // Check if bound is true, 
                // as we want to avoid whitespaces.
                if (Glide.settings.bound && $5137c3620ef83169$var$toInt(steps) > length) {
                    Glide.index = length;
                    return;
                }
                Glide.index = steps;
                return;
            } // When pattern is equal to `>>` we want
            // fast forward to the last slide.
            if (direction === ">" && steps === ">") {
                Glide.index = length;
                return;
            } // When pattern is equal to `<<` we want
            // fast forward to the first slide.
            if (direction === "<" && steps === "<") {
                Glide.index = 0;
                return;
            } // pagination movement
            if (direction === "|") viewSize = Glide.settings.perView || 1;
             // we are moving forward
            if (direction === ">" || direction === "|" && steps === ">") {
                var index = calculateForwardIndex(viewSize);
                if (index > length) this._o = true;
                Glide.index = normalizeForwardIndex(index, viewSize);
                return;
            } // we are moving backward
            if (direction === "<" || direction === "|" && steps === "<") {
                var _index = calculateBackwardIndex(viewSize);
                if (_index < 0) this._o = true;
                Glide.index = normalizeBackwardIndex(_index, viewSize);
                return;
            }
            $5137c3620ef83169$var$warn("Invalid direction pattern [".concat(direction).concat(steps, "] has been used"));
        },
        /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */ isStart: function isStart() {
            return Glide.index <= 0;
        },
        /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */ isEnd: function isEnd() {
            return Glide.index >= this.length;
        },
        /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */ isOffset: function isOffset() {
            var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            if (!direction) return this._o;
            if (!this._o) return false;
             // did we view to the right?
            if (direction === "|>") return this.move.direction === "|" && this.move.steps === ">";
             // did we view to the left?
            if (direction === "|<") return this.move.direction === "|" && this.move.steps === "<";
            return this.move.direction === direction;
        },
        /**
     * Checks if bound mode is active
     *
     * @return {Boolean}
     */ isBound: function isBound() {
            return Glide.isType("slider") && Glide.settings.focusAt !== "center" && Glide.settings.bound;
        }
    };
    /**
   * Returns index value to move forward/to the right
   *
   * @param viewSize
   * @returns {Number}
   */ function calculateForwardIndex(viewSize) {
        var index = Glide.index;
        if (Glide.isType("carousel")) return index + viewSize;
        return index + (viewSize - index % viewSize);
    }
    /**
   * Normalizes the given forward index based on glide settings, preventing it to exceed certain boundaries
   *
   * @param index
   * @param length
   * @param viewSize
   * @returns {Number}
   */ function normalizeForwardIndex(index, viewSize) {
        var length = Run.length;
        if (index <= length) return index;
        if (Glide.isType("carousel")) return index - (length + 1);
        if (Glide.settings.rewind) {
            // bound does funny things with the length, therefor we have to be certain
            // that we are on the last possible index value given by bound
            if (Run.isBound() && !Run.isEnd()) return length;
            return 0;
        }
        if (Run.isBound()) return length;
        return Math.floor(length / viewSize) * viewSize;
    }
    /**
   * Calculates index value to move backward/to the left
   *
   * @param viewSize
   * @returns {Number}
   */ function calculateBackwardIndex(viewSize) {
        var index = Glide.index;
        if (Glide.isType("carousel")) return index - viewSize;
         // ensure our back navigation results in the same index as a forward navigation
        // to experience a homogeneous paging
        var view = Math.ceil(index / viewSize);
        return (view - 1) * viewSize;
    }
    /**
   * Normalizes the given backward index based on glide settings, preventing it to exceed certain boundaries
   *
   * @param index
   * @param length
   * @param viewSize
   * @returns {*}
   */ function normalizeBackwardIndex(index, viewSize) {
        var length = Run.length;
        if (index >= 0) return index;
        if (Glide.isType("carousel")) return index + (length + 1);
        if (Glide.settings.rewind) {
            // bound does funny things with the length, therefor we have to be certain
            // that we are on first possible index value before we to rewind to the length given by bound
            if (Run.isBound() && Run.isStart()) return length;
            return Math.floor(length / viewSize) * viewSize;
        }
        return 0;
    }
    $5137c3620ef83169$var$define(Run, "move", {
        /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */ get: function get() {
            return this._m;
        },
        /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */ set: function set(value) {
            var step = value.substr(1);
            this._m = {
                direction: value.substr(0, 1),
                steps: step ? $5137c3620ef83169$var$toInt(step) ? $5137c3620ef83169$var$toInt(step) : step : 0
            };
        }
    });
    $5137c3620ef83169$var$define(Run, "length", {
        /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */ get: function get() {
            var settings = Glide.settings;
            var length = Components.Html.slides.length; // If the `bound` option is active, a maximum running distance should be
            // reduced by `perView` and `focusAt` settings. Running distance
            // should end before creating an empty space after instance.
            if (this.isBound()) return length - 1 - ($5137c3620ef83169$var$toInt(settings.perView) - 1) + $5137c3620ef83169$var$toInt(settings.focusAt);
            return length - 1;
        }
    });
    $5137c3620ef83169$var$define(Run, "offset", {
        /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */ get: function get() {
            return this._o;
        }
    });
    return Run;
}
/**
 * Returns a current time.
 *
 * @return {Number}
 */ function $5137c3620ef83169$var$now() {
    return new Date().getTime();
}
/**
 * Returns a function, that, when invoked, will only be triggered
 * at most once during a given window of time.
 *
 * @param {Function} func
 * @param {Number} wait
 * @param {Object=} options
 * @return {Function}
 *
 * @see https://github.com/jashkenas/underscore
 */ function $5137c3620ef83169$var$throttle(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};
    var later = function later() {
        previous = options.leading === false ? 0 : $5137c3620ef83169$var$now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function throttled() {
        var at = $5137c3620ef83169$var$now();
        if (!previous && options.leading === false) previous = at;
        var remaining = wait - (at - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = at;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}
var $5137c3620ef83169$var$MARGIN_TYPE = {
    ltr: [
        "marginLeft",
        "marginRight"
    ],
    rtl: [
        "marginRight",
        "marginLeft"
    ]
};
function $5137c3620ef83169$var$Gaps(Glide, Components, Events) {
    var Gaps = {
        /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */ apply: function apply(slides) {
            for(var i = 0, len = slides.length; i < len; i++){
                var style = slides[i].style;
                var direction = Components.Direction.value;
                if (i !== 0) style[$5137c3620ef83169$var$MARGIN_TYPE[direction][0]] = "".concat(this.value / 2, "px");
                else style[$5137c3620ef83169$var$MARGIN_TYPE[direction][0]] = "";
                if (i !== slides.length - 1) style[$5137c3620ef83169$var$MARGIN_TYPE[direction][1]] = "".concat(this.value / 2, "px");
                else style[$5137c3620ef83169$var$MARGIN_TYPE[direction][1]] = "";
            }
        },
        /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */ remove: function remove(slides) {
            for(var i = 0, len = slides.length; i < len; i++){
                var style = slides[i].style;
                style.marginLeft = "";
                style.marginRight = "";
            }
        }
    };
    $5137c3620ef83169$var$define(Gaps, "value", {
        /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */ get: function get() {
            return $5137c3620ef83169$var$toInt(Glide.settings.gap);
        }
    });
    $5137c3620ef83169$var$define(Gaps, "grow", {
        /**
     * Gets additional dimensions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */ get: function get() {
            return Gaps.value * Components.Sizes.length;
        }
    });
    $5137c3620ef83169$var$define(Gaps, "reductor", {
        /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */ get: function get() {
            var perView = Glide.settings.perView;
            return Gaps.value * (perView - 1) / perView;
        }
    });
    /**
   * Apply calculated gaps:
   * - after building, so slides (including clones) will receive proper margins
   * - on updating via API, to recalculate gaps with new options
   */ Events.on([
        "build.after",
        "update"
    ], $5137c3620ef83169$var$throttle(function() {
        Gaps.apply(Components.Html.wrapper.children);
    }, 30));
    /**
   * Remove gaps:
   * - on destroying to bring markup to its inital state
   */ Events.on("destroy", function() {
        Gaps.remove(Components.Html.wrapper.children);
    });
    return Gaps;
}
/**
 * Finds siblings nodes of the passed node.
 *
 * @param  {Element} node
 * @return {Array}
 */ function $5137c3620ef83169$var$siblings(node) {
    if (node && node.parentNode) {
        var n = node.parentNode.firstChild;
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== node) matched.push(n);
        return matched;
    }
    return [];
}
/**
 * Checks if passed node exist and is a valid element.
 *
 * @param  {Element} node
 * @return {Boolean}
 */ function $5137c3620ef83169$var$exist(node) {
    if (node && node instanceof window.HTMLElement) return true;
    return false;
}
/**
 * Coerces a NodeList to an Array.
 *
 * @param  {NodeList} nodeList
 * @return {Array}
 */ function $5137c3620ef83169$var$toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
}
var $5137c3620ef83169$var$TRACK_SELECTOR = '[data-glide-el="track"]';
function $5137c3620ef83169$var$Html(Glide, Components, Events) {
    var Html = {
        /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */ mount: function mount() {
            this.root = Glide.selector;
            this.track = this.root.querySelector($5137c3620ef83169$var$TRACK_SELECTOR);
            this.collectSlides();
        },
        /**
     * Collect slides
     */ collectSlides: function collectSlides() {
            this.slides = $5137c3620ef83169$var$toArray(this.wrapper.children).filter(function(slide) {
                return !slide.classList.contains(Glide.settings.classes.slide.clone);
            });
        }
    };
    $5137c3620ef83169$var$define(Html, "root", {
        /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */ get: function get() {
            return Html._r;
        },
        /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */ set: function set(r) {
            if ($5137c3620ef83169$var$isString(r)) r = document.querySelector(r);
            if ($5137c3620ef83169$var$exist(r)) Html._r = r;
            else $5137c3620ef83169$var$warn("Root element must be a existing Html node");
        }
    });
    $5137c3620ef83169$var$define(Html, "track", {
        /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */ get: function get() {
            return Html._t;
        },
        /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */ set: function set(t) {
            if ($5137c3620ef83169$var$exist(t)) Html._t = t;
            else $5137c3620ef83169$var$warn("Could not find track element. Please use ".concat($5137c3620ef83169$var$TRACK_SELECTOR, " attribute."));
        }
    });
    $5137c3620ef83169$var$define(Html, "wrapper", {
        /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */ get: function get() {
            return Html.track.children[0];
        }
    });
    /**
   * Add/remove/reorder dynamic slides
   */ Events.on("update", function() {
        Html.collectSlides();
    });
    return Html;
}
function $5137c3620ef83169$var$Peek(Glide, Components, Events) {
    var Peek = {
        /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.value = Glide.settings.peek;
        }
    };
    $5137c3620ef83169$var$define(Peek, "value", {
        /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */ get: function get() {
            return Peek._v;
        },
        /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */ set: function set(value) {
            if ($5137c3620ef83169$var$isObject(value)) {
                value.before = $5137c3620ef83169$var$toInt(value.before);
                value.after = $5137c3620ef83169$var$toInt(value.after);
            } else value = $5137c3620ef83169$var$toInt(value);
            Peek._v = value;
        }
    });
    $5137c3620ef83169$var$define(Peek, "reductor", {
        /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */ get: function get() {
            var value = Peek.value;
            var perView = Glide.settings.perView;
            if ($5137c3620ef83169$var$isObject(value)) return value.before / perView + value.after / perView;
            return value * 2 / perView;
        }
    });
    /**
   * Recalculate peeking sizes on:
   * - when resizing window to update to proper percents
   */ Events.on([
        "resize",
        "update"
    ], function() {
        Peek.mount();
    });
    return Peek;
}
function $5137c3620ef83169$var$Move(Glide, Components, Events) {
    var Move = {
        /**
     * Constructs move component.
     *
     * @returns {Void}
     */ mount: function mount() {
            this._o = 0;
        },
        /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */ make: function make() {
            var _this = this;
            var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            this.offset = offset;
            Events.emit("move", {
                movement: this.value
            });
            Components.Transition.after(function() {
                Events.emit("move.after", {
                    movement: _this.value
                });
            });
        }
    };
    $5137c3620ef83169$var$define(Move, "offset", {
        /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */ get: function get() {
            return Move._o;
        },
        /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */ set: function set(value) {
            Move._o = !$5137c3620ef83169$var$isUndefined(value) ? $5137c3620ef83169$var$toInt(value) : 0;
        }
    });
    $5137c3620ef83169$var$define(Move, "translate", {
        /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */ get: function get() {
            return Components.Sizes.slideWidth * Glide.index;
        }
    });
    $5137c3620ef83169$var$define(Move, "value", {
        /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */ get: function get() {
            var offset = this.offset;
            var translate = this.translate;
            if (Components.Direction.is("rtl")) return translate + offset;
            return translate - offset;
        }
    });
    /**
   * Make movement to proper slide on:
   * - before build, so glide will start at `startAt` index
   * - on each standard run to move to newly calculated index
   */ Events.on([
        "build.before",
        "run"
    ], function() {
        Move.make();
    });
    return Move;
}
function $5137c3620ef83169$var$Sizes(Glide, Components, Events) {
    var Sizes = {
        /**
     * Setups dimensions of slides.
     *
     * @return {Void}
     */ setupSlides: function setupSlides() {
            var width = "".concat(this.slideWidth, "px");
            var slides = Components.Html.slides;
            for(var i = 0; i < slides.length; i++)slides[i].style.width = width;
        },
        /**
     * Setups dimensions of slides wrapper.
     *
     * @return {Void}
     */ setupWrapper: function setupWrapper() {
            Components.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
        },
        /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */ remove: function remove() {
            var slides = Components.Html.slides;
            for(var i = 0; i < slides.length; i++)slides[i].style.width = "";
            Components.Html.wrapper.style.width = "";
        }
    };
    $5137c3620ef83169$var$define(Sizes, "length", {
        /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */ get: function get() {
            return Components.Html.slides.length;
        }
    });
    $5137c3620ef83169$var$define(Sizes, "width", {
        /**
     * Gets width value of the slider (visible area).
     *
     * @return {Number}
     */ get: function get() {
            return Components.Html.track.offsetWidth;
        }
    });
    $5137c3620ef83169$var$define(Sizes, "wrapperSize", {
        /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */ get: function get() {
            return Sizes.slideWidth * Sizes.length + Components.Gaps.grow + Components.Clones.grow;
        }
    });
    $5137c3620ef83169$var$define(Sizes, "slideWidth", {
        /**
     * Gets width value of a single slide.
     *
     * @return {Number}
     */ get: function get() {
            return Sizes.width / Glide.settings.perView - Components.Peek.reductor - Components.Gaps.reductor;
        }
    });
    /**
   * Apply calculated glide's dimensions:
   * - before building, so other dimensions (e.g. translate) will be calculated propertly
   * - when resizing window to recalculate sildes dimensions
   * - on updating via API, to calculate dimensions based on new options
   */ Events.on([
        "build.before",
        "resize",
        "update"
    ], function() {
        Sizes.setupSlides();
        Sizes.setupWrapper();
    });
    /**
   * Remove calculated glide's dimensions:
   * - on destoting to bring markup to its inital state
   */ Events.on("destroy", function() {
        Sizes.remove();
    });
    return Sizes;
}
function $5137c3620ef83169$var$Build(Glide, Components, Events) {
    var Build = {
        /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */ mount: function mount() {
            Events.emit("build.before");
            this.typeClass();
            this.activeClass();
            Events.emit("build.after");
        },
        /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */ typeClass: function typeClass() {
            Components.Html.root.classList.add(Glide.settings.classes.type[Glide.settings.type]);
        },
        /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */ activeClass: function activeClass() {
            var classes = Glide.settings.classes;
            var slide = Components.Html.slides[Glide.index];
            if (slide) {
                slide.classList.add(classes.slide.active);
                $5137c3620ef83169$var$siblings(slide).forEach(function(sibling) {
                    sibling.classList.remove(classes.slide.active);
                });
            }
        },
        /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */ removeClasses: function removeClasses() {
            var _Glide$settings$class = Glide.settings.classes, type = _Glide$settings$class.type, slide = _Glide$settings$class.slide;
            Components.Html.root.classList.remove(type[Glide.settings.type]);
            Components.Html.slides.forEach(function(sibling) {
                sibling.classList.remove(slide.active);
            });
        }
    };
    /**
   * Clear building classes:
   * - on destroying to bring HTML to its initial state
   * - on updating to remove classes before remounting component
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Build.removeClasses();
    });
    /**
   * Remount component:
   * - on resizing of the window to calculate new dimensions
   * - on updating settings via API
   */ Events.on([
        "resize",
        "update"
    ], function() {
        Build.mount();
    });
    /**
   * Swap active class of current slide:
   * - after each move to the new index
   */ Events.on("move.after", function() {
        Build.activeClass();
    });
    return Build;
}
function $5137c3620ef83169$var$Clones(Glide, Components, Events) {
    var Clones = {
        /**
     * Create pattern map and collect slides to be cloned.
     */ mount: function mount() {
            this.items = [];
            if (Glide.isType("carousel")) this.items = this.collect();
        },
        /**
     * Collect clones with pattern.
     *
     * @return {[]}
     */ collect: function collect() {
            var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var slides = Components.Html.slides;
            var _Glide$settings = Glide.settings, perView = _Glide$settings.perView, classes = _Glide$settings.classes, cloningRatio = _Glide$settings.cloningRatio;
            if (slides.length !== 0) {
                var peekIncrementer = +!!Glide.settings.peek;
                var cloneCount = perView + peekIncrementer + Math.round(perView / 2);
                var append = slides.slice(0, cloneCount).reverse();
                var prepend = slides.slice(cloneCount * -1);
                for(var r = 0; r < Math.max(cloningRatio, Math.floor(perView / slides.length)); r++){
                    for(var i = 0; i < append.length; i++){
                        var clone = append[i].cloneNode(true);
                        clone.classList.add(classes.slide.clone);
                        items.push(clone);
                    }
                    for(var _i = 0; _i < prepend.length; _i++){
                        var _clone = prepend[_i].cloneNode(true);
                        _clone.classList.add(classes.slide.clone);
                        items.unshift(_clone);
                    }
                }
            }
            return items;
        },
        /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */ append: function append() {
            var items = this.items;
            var _Components$Html = Components.Html, wrapper = _Components$Html.wrapper, slides = _Components$Html.slides;
            var half = Math.floor(items.length / 2);
            var prepend = items.slice(0, half).reverse();
            var append = items.slice(half * -1).reverse();
            var width = "".concat(Components.Sizes.slideWidth, "px");
            for(var i = 0; i < append.length; i++)wrapper.appendChild(append[i]);
            for(var _i2 = 0; _i2 < prepend.length; _i2++)wrapper.insertBefore(prepend[_i2], slides[0]);
            for(var _i3 = 0; _i3 < items.length; _i3++)items[_i3].style.width = width;
        },
        /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */ remove: function remove() {
            var items = this.items;
            for(var i = 0; i < items.length; i++)Components.Html.wrapper.removeChild(items[i]);
        }
    };
    $5137c3620ef83169$var$define(Clones, "grow", {
        /**
     * Gets additional dimensions value caused by clones.
     *
     * @return {Number}
     */ get: function get() {
            return (Components.Sizes.slideWidth + Components.Gaps.value) * Clones.items.length;
        }
    });
    /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */ Events.on("update", function() {
        Clones.remove();
        Clones.mount();
        Clones.append();
    });
    /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */ Events.on("build.before", function() {
        if (Glide.isType("carousel")) Clones.append();
    });
    /**
   * Remove clones HTMLElements:
   * - on destroying, to bring HTML to its initial state
   */ Events.on("destroy", function() {
        Clones.remove();
    });
    return Clones;
}
var $5137c3620ef83169$var$EventsBinder = /*#__PURE__*/ function() {
    /**
   * Construct a EventsBinder instance.
   */ function EventsBinder() {
        var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $5137c3620ef83169$var$_classCallCheck(this, EventsBinder);
        this.listeners = listeners;
    }
    /**
   * Adds events listeners to arrows HTML elements.
   *
   * @param  {String|Array} events
   * @param  {Element|Window|Document} el
   * @param  {Function} closure
   * @param  {Boolean|Object} capture
   * @return {Void}
   */ $5137c3620ef83169$var$_createClass(EventsBinder, [
        {
            key: "on",
            value: function on(events, el, closure) {
                var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                if ($5137c3620ef83169$var$isString(events)) events = [
                    events
                ];
                for(var i = 0; i < events.length; i++){
                    this.listeners[events[i]] = closure;
                    el.addEventListener(events[i], this.listeners[events[i]], capture);
                }
            }
        },
        {
            key: "off",
            value: function off(events, el) {
                var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                if ($5137c3620ef83169$var$isString(events)) events = [
                    events
                ];
                for(var i = 0; i < events.length; i++)el.removeEventListener(events[i], this.listeners[events[i]], capture);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                delete this.listeners;
            }
        }
    ]);
    return EventsBinder;
}();
function $5137c3620ef83169$var$Resize(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    var Resize = {
        /**
     * Initializes window bindings.
     */ mount: function mount() {
            this.bind();
        },
        /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("resize", window, $5137c3620ef83169$var$throttle(function() {
                Events.emit("resize");
            }, Glide.settings.throttle));
        },
        /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("resize", window);
        }
    };
    /**
   * Remove bindings from window:
   * - on destroying, to remove added EventListener
   */ Events.on("destroy", function() {
        Resize.unbind();
        Binder.destroy();
    });
    return Resize;
}
var $5137c3620ef83169$var$VALID_DIRECTIONS = [
    "ltr",
    "rtl"
];
var $5137c3620ef83169$var$FLIPED_MOVEMENTS = {
    ">": "<",
    "<": ">",
    "=": "="
};
function $5137c3620ef83169$var$Direction(Glide, Components, Events) {
    var Direction = {
        /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.value = Glide.settings.direction;
        },
        /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */ resolve: function resolve(pattern) {
            var token = pattern.slice(0, 1);
            if (this.is("rtl")) return pattern.split(token).join($5137c3620ef83169$var$FLIPED_MOVEMENTS[token]);
            return pattern;
        },
        /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */ is: function is(direction) {
            return this.value === direction;
        },
        /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */ addClass: function addClass() {
            Components.Html.root.classList.add(Glide.settings.classes.direction[this.value]);
        },
        /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */ removeClass: function removeClass() {
            Components.Html.root.classList.remove(Glide.settings.classes.direction[this.value]);
        }
    };
    $5137c3620ef83169$var$define(Direction, "value", {
        /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */ get: function get() {
            return Direction._v;
        },
        /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */ set: function set(value) {
            if ($5137c3620ef83169$var$VALID_DIRECTIONS.indexOf(value) > -1) Direction._v = value;
            else $5137c3620ef83169$var$warn("Direction value must be `ltr` or `rtl`");
        }
    });
    /**
   * Clear direction class:
   * - on destroy to bring HTML to its initial state
   * - on update to remove class before reappling bellow
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Direction.removeClass();
    });
    /**
   * Remount component:
   * - on update to reflect changes in direction value
   */ Events.on("update", function() {
        Direction.mount();
    });
    /**
   * Apply direction class:
   * - before building to apply class for the first time
   * - on updating to reapply direction class that may changed
   */ Events.on([
        "build.before",
        "update"
    ], function() {
        Direction.addClass();
    });
    return Direction;
}
/**
 * Reflects value of glide movement.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $5137c3620ef83169$var$Rtl(Glide, Components) {
    return {
        /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            if (Components.Direction.is("rtl")) return -translate;
            return translate;
        }
    };
}
/**
 * Updates glide movement with a `gap` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $5137c3620ef83169$var$Gap(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            var multiplier = Math.floor(translate / Components.Sizes.slideWidth);
            return translate + Components.Gaps.value * multiplier;
        }
    };
}
/**
 * Updates glide movement with width of additional clones width.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $5137c3620ef83169$var$Grow(Glide, Components) {
    return {
        /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            return translate + Components.Clones.grow / 2;
        }
    };
}
/**
 * Updates glide movement with a `peek` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $5137c3620ef83169$var$Peeking(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            if (Glide.settings.focusAt >= 0) {
                var peek = Components.Peek.value;
                if ($5137c3620ef83169$var$isObject(peek)) return translate - peek.before;
                return translate - peek;
            }
            return translate;
        }
    };
}
/**
 * Updates glide movement with a `focusAt` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $5137c3620ef83169$var$Focusing(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            var gap = Components.Gaps.value;
            var width = Components.Sizes.width;
            var focusAt = Glide.settings.focusAt;
            var slideWidth = Components.Sizes.slideWidth;
            if (focusAt === "center") return translate - (width / 2 - slideWidth / 2);
            return translate - slideWidth * focusAt - gap * focusAt;
        }
    };
}
/**
 * Applies diffrent transformers on translate value.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $5137c3620ef83169$var$mutator(Glide, Components, Events) {
    /**
   * Merge instance transformers with collection of default transformers.
   * It's important that the Rtl component be last on the list,
   * so it reflects all previous transformations.
   *
   * @type {Array}
   */ var TRANSFORMERS = [
        $5137c3620ef83169$var$Gap,
        $5137c3620ef83169$var$Grow,
        $5137c3620ef83169$var$Peeking,
        $5137c3620ef83169$var$Focusing
    ].concat(Glide._t, [
        $5137c3620ef83169$var$Rtl
    ]);
    return {
        /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */ mutate: function mutate(translate) {
            for(var i = 0; i < TRANSFORMERS.length; i++){
                var transformer = TRANSFORMERS[i];
                if ($5137c3620ef83169$var$isFunction(transformer) && $5137c3620ef83169$var$isFunction(transformer().modify)) translate = transformer(Glide, Components, Events).modify(translate);
                else $5137c3620ef83169$var$warn("Transformer should be a function that returns an object with `modify()` method");
            }
            return translate;
        }
    };
}
function $5137c3620ef83169$var$Translate(Glide, Components, Events) {
    var Translate = {
        /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */ set: function set(value) {
            var transform = $5137c3620ef83169$var$mutator(Glide, Components).mutate(value);
            var translate3d = "translate3d(".concat(-1 * transform, "px, 0px, 0px)");
            Components.Html.wrapper.style.mozTransform = translate3d; // needed for supported Firefox 10-15
            Components.Html.wrapper.style.webkitTransform = translate3d; // needed for supported Chrome 10-35, Safari 5.1-8, and Opera 15-22
            Components.Html.wrapper.style.transform = translate3d;
        },
        /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */ remove: function remove() {
            Components.Html.wrapper.style.transform = "";
        },
        /**
     * @return {number}
     */ getStartIndex: function getStartIndex() {
            var length = Components.Sizes.length;
            var index = Glide.index;
            var perView = Glide.settings.perView;
            if (Components.Run.isOffset(">") || Components.Run.isOffset("|>")) return length + (index - perView);
             // "modulo length" converts an index that equals length to zero
            return (index + perView) % length;
        },
        /**
     * @return {number}
     */ getTravelDistance: function getTravelDistance() {
            var travelDistance = Components.Sizes.slideWidth * Glide.settings.perView;
            if (Components.Run.isOffset(">") || Components.Run.isOffset("|>")) // reverse travel distance so that we don't have to change subtract operations
            return travelDistance * -1;
            return travelDistance;
        }
    };
    /**
   * Set new translate value:
   * - on move to reflect index change
   * - on updating via API to reflect possible changes in options
   */ Events.on("move", function(context) {
        if (!Glide.isType("carousel") || !Components.Run.isOffset()) return Translate.set(context.movement);
        Components.Transition.after(function() {
            Events.emit("translate.jump");
            Translate.set(Components.Sizes.slideWidth * Glide.index);
        });
        var startWidth = Components.Sizes.slideWidth * Components.Translate.getStartIndex();
        return Translate.set(startWidth - Components.Translate.getTravelDistance());
    });
    /**
   * Remove translate:
   * - on destroying to bring markup to its inital state
   */ Events.on("destroy", function() {
        Translate.remove();
    });
    return Translate;
}
function $5137c3620ef83169$var$Transition(Glide, Components, Events) {
    /**
   * Holds inactivity status of transition.
   * When true transition is not applied.
   *
   * @type {Boolean}
   */ var disabled = false;
    var Transition = {
        /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */ compose: function compose(property) {
            var settings = Glide.settings;
            if (!disabled) return "".concat(property, " ").concat(this.duration, "ms ").concat(settings.animationTimingFunc);
            return "".concat(property, " 0ms ").concat(settings.animationTimingFunc);
        },
        /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */ set: function set() {
            var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "transform";
            Components.Html.wrapper.style.transition = this.compose(property);
        },
        /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */ remove: function remove() {
            Components.Html.wrapper.style.transition = "";
        },
        /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */ after: function after(callback) {
            setTimeout(function() {
                callback();
            }, this.duration);
        },
        /**
     * Enable transition.
     *
     * @return {Void}
     */ enable: function enable() {
            disabled = false;
            this.set();
        },
        /**
     * Disable transition.
     *
     * @return {Void}
     */ disable: function disable() {
            disabled = true;
            this.set();
        }
    };
    $5137c3620ef83169$var$define(Transition, "duration", {
        /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */ get: function get() {
            var settings = Glide.settings;
            if (Glide.isType("slider") && Components.Run.offset) return settings.rewindDuration;
            return settings.animationDuration;
        }
    });
    /**
   * Set transition `style` value:
   * - on each moving, because it may be cleared by offset move
   */ Events.on("move", function() {
        Transition.set();
    });
    /**
   * Disable transition:
   * - before initial build to avoid transitioning from `0` to `startAt` index
   * - while resizing window and recalculating dimensions
   * - on jumping from offset transition at start and end edges in `carousel` type
   */ Events.on([
        "build.before",
        "resize",
        "translate.jump"
    ], function() {
        Transition.disable();
    });
    /**
   * Enable transition:
   * - on each running, because it may be disabled by offset move
   */ Events.on("run", function() {
        Transition.enable();
    });
    /**
   * Remove transition:
   * - on destroying to bring markup to its inital state
   */ Events.on("destroy", function() {
        Transition.remove();
    });
    return Transition;
}
/**
 * Test via a getter in the options object to see
 * if the passive property is accessed.
 *
 * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
 */ var $5137c3620ef83169$var$supportsPassive = false;
try {
    var $5137c3620ef83169$var$opts = Object.defineProperty({}, "passive", {
        get: function get() {
            $5137c3620ef83169$var$supportsPassive = true;
        }
    });
    window.addEventListener("testPassive", null, $5137c3620ef83169$var$opts);
    window.removeEventListener("testPassive", null, $5137c3620ef83169$var$opts);
} catch (e) {}
var $5137c3620ef83169$var$supportsPassive$1 = $5137c3620ef83169$var$supportsPassive;
var $5137c3620ef83169$var$START_EVENTS = [
    "touchstart",
    "mousedown"
];
var $5137c3620ef83169$var$MOVE_EVENTS = [
    "touchmove",
    "mousemove"
];
var $5137c3620ef83169$var$END_EVENTS = [
    "touchend",
    "touchcancel",
    "mouseup",
    "mouseleave"
];
var $5137c3620ef83169$var$MOUSE_EVENTS = [
    "mousedown",
    "mousemove",
    "mouseup",
    "mouseleave"
];
function $5137c3620ef83169$var$Swipe(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    var swipeSin = 0;
    var swipeStartX = 0;
    var swipeStartY = 0;
    var disabled = false;
    var capture = $5137c3620ef83169$var$supportsPassive$1 ? {
        passive: true
    } : false;
    var Swipe = {
        /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.bindSwipeStart();
        },
        /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */ start: function start(event) {
            if (!disabled && !Glide.disabled) {
                this.disable();
                var swipe = this.touches(event);
                swipeSin = null;
                swipeStartX = $5137c3620ef83169$var$toInt(swipe.pageX);
                swipeStartY = $5137c3620ef83169$var$toInt(swipe.pageY);
                this.bindSwipeMove();
                this.bindSwipeEnd();
                Events.emit("swipe.start");
            }
        },
        /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */ move: function move(event) {
            if (!Glide.disabled) {
                var _Glide$settings = Glide.settings, touchAngle = _Glide$settings.touchAngle, touchRatio = _Glide$settings.touchRatio, classes = _Glide$settings.classes;
                var swipe = this.touches(event);
                var subExSx = $5137c3620ef83169$var$toInt(swipe.pageX) - swipeStartX;
                var subEySy = $5137c3620ef83169$var$toInt(swipe.pageY) - swipeStartY;
                var powEX = Math.abs(subExSx << 2);
                var powEY = Math.abs(subEySy << 2);
                var swipeHypotenuse = Math.sqrt(powEX + powEY);
                var swipeCathetus = Math.sqrt(powEY);
                swipeSin = Math.asin(swipeCathetus / swipeHypotenuse);
                if (swipeSin * 180 / Math.PI < touchAngle) {
                    event.stopPropagation();
                    Components.Move.make(subExSx * $5137c3620ef83169$var$toFloat(touchRatio));
                    Components.Html.root.classList.add(classes.dragging);
                    Events.emit("swipe.move");
                } else return false;
            }
        },
        /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */ end: function end(event) {
            if (!Glide.disabled) {
                var _Glide$settings2 = Glide.settings, perSwipe = _Glide$settings2.perSwipe, touchAngle = _Glide$settings2.touchAngle, classes = _Glide$settings2.classes;
                var swipe = this.touches(event);
                var threshold = this.threshold(event);
                var swipeDistance = swipe.pageX - swipeStartX;
                var swipeDeg = swipeSin * 180 / Math.PI;
                this.enable();
                if (swipeDistance > threshold && swipeDeg < touchAngle) Components.Run.make(Components.Direction.resolve("".concat(perSwipe, "<")));
                else if (swipeDistance < -threshold && swipeDeg < touchAngle) Components.Run.make(Components.Direction.resolve("".concat(perSwipe, ">")));
                else // While swipe don't reach distance apply previous transform.
                Components.Move.make();
                Components.Html.root.classList.remove(classes.dragging);
                this.unbindSwipeMove();
                this.unbindSwipeEnd();
                Events.emit("swipe.end");
            }
        },
        /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */ bindSwipeStart: function bindSwipeStart() {
            var _this = this;
            var _Glide$settings3 = Glide.settings, swipeThreshold = _Glide$settings3.swipeThreshold, dragThreshold = _Glide$settings3.dragThreshold;
            if (swipeThreshold) Binder.on($5137c3620ef83169$var$START_EVENTS[0], Components.Html.wrapper, function(event) {
                _this.start(event);
            }, capture);
            if (dragThreshold) Binder.on($5137c3620ef83169$var$START_EVENTS[1], Components.Html.wrapper, function(event) {
                _this.start(event);
            }, capture);
        },
        /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */ unbindSwipeStart: function unbindSwipeStart() {
            Binder.off($5137c3620ef83169$var$START_EVENTS[0], Components.Html.wrapper, capture);
            Binder.off($5137c3620ef83169$var$START_EVENTS[1], Components.Html.wrapper, capture);
        },
        /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */ bindSwipeMove: function bindSwipeMove() {
            var _this2 = this;
            Binder.on($5137c3620ef83169$var$MOVE_EVENTS, Components.Html.wrapper, $5137c3620ef83169$var$throttle(function(event) {
                _this2.move(event);
            }, Glide.settings.throttle), capture);
        },
        /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */ unbindSwipeMove: function unbindSwipeMove() {
            Binder.off($5137c3620ef83169$var$MOVE_EVENTS, Components.Html.wrapper, capture);
        },
        /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */ bindSwipeEnd: function bindSwipeEnd() {
            var _this3 = this;
            Binder.on($5137c3620ef83169$var$END_EVENTS, Components.Html.wrapper, function(event) {
                _this3.end(event);
            });
        },
        /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */ unbindSwipeEnd: function unbindSwipeEnd() {
            Binder.off($5137c3620ef83169$var$END_EVENTS, Components.Html.wrapper);
        },
        /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */ touches: function touches(event) {
            if ($5137c3620ef83169$var$MOUSE_EVENTS.indexOf(event.type) > -1) return event;
            return event.touches[0] || event.changedTouches[0];
        },
        /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */ threshold: function threshold(event) {
            var settings = Glide.settings;
            if ($5137c3620ef83169$var$MOUSE_EVENTS.indexOf(event.type) > -1) return settings.dragThreshold;
            return settings.swipeThreshold;
        },
        /**
     * Enables swipe event.
     *
     * @return {self}
     */ enable: function enable() {
            disabled = false;
            Components.Transition.enable();
            return this;
        },
        /**
     * Disables swipe event.
     *
     * @return {self}
     */ disable: function disable() {
            disabled = true;
            Components.Transition.disable();
            return this;
        }
    };
    /**
   * Add component class:
   * - after initial building
   */ Events.on("build.after", function() {
        Components.Html.root.classList.add(Glide.settings.classes.swipeable);
    });
    /**
   * Remove swiping bindings:
   * - on destroying, to remove added EventListeners
   */ Events.on("destroy", function() {
        Swipe.unbindSwipeStart();
        Swipe.unbindSwipeMove();
        Swipe.unbindSwipeEnd();
        Binder.destroy();
    });
    return Swipe;
}
function $5137c3620ef83169$var$Images(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    var Images = {
        /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */ mount: function mount() {
            this.bind();
        },
        /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("dragstart", Components.Html.wrapper, this.dragstart);
        },
        /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("dragstart", Components.Html.wrapper);
        },
        /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */ dragstart: function dragstart(event) {
            event.preventDefault();
        }
    };
    /**
   * Remove bindings from images:
   * - on destroying, to remove added EventListeners
   */ Events.on("destroy", function() {
        Images.unbind();
        Binder.destroy();
    });
    return Images;
}
function $5137c3620ef83169$var$Lazy(Glide, Components, Events) {
    /**
   * Holds reference to settings.
   *
   * @type {Object}
   */ var settings = Glide.settings;
    var inView = false;
    var Lazy = {
        mount: function mount() {
            /**
       * Collection of slide elements
       *
       * @private
       * @type {HTMLCollection}
       */ if (settings.lazy) {
                this._wrapper = Components.Html.root;
                this._slideElements = this._wrapper.querySelectorAll(".glide__slide");
            }
        },
        withinView: function withinView() {
            var rect = this._wrapper.getBoundingClientRect();
            if (rect.bottom > 0 && rect.right > 0 && rect.top <= (window.innerHeight * settings.lazyScrollThreshold || document.documentElement.clientHeight) * settings.lazyScrollThreshold && rect.left <= (window.innerWidth * settings.lazyScrollThreshold || document.documentElement.clientWidth * settings.lazyScrollThreshold)) this.lazyLoad();
        },
        lazyLoad: function lazyLoad() {
            var length;
            var additionSlides = settings.lazyInitialSlidesLoaded - 1;
            inView = true;
            if (Glide.index + additionSlides < this._slideElements.length) length = Glide.index + additionSlides;
            else length = Glide.index;
            for(var i = 0; i <= length; i++){
                var img = this._slideElements[i].getElementsByTagName("img")[0];
                if (img && img.classList.contains("glide__lazy")) {
                    if (!this._slideElements[i].classList.contains("glide__lazy__loaded")) this.loadImage(img);
                }
            }
        },
        loadImage: function loadImage(image) {
            if (image.dataset.src) {
                image.src = image.dataset.src;
                image.classList.add("glide__lazy__loaded");
                image.classList.remove("glide__lazy");
                image.removeAttribute("data-src");
            }
        }
    };
    Events.on([
        "mount.after"
    ], function() {
        if (settings.lazy) Lazy.withinView();
    });
    Events.on([
        "move.after"
    ], $5137c3620ef83169$var$throttle(function() {
        if (settings.lazy && inView) Lazy.lazyLoad();
        else if (settings.lazy) Lazy.withinView();
    }, 100));
    document.addEventListener("scroll", $5137c3620ef83169$var$throttle(function() {
        if (settings.lazy && !inView) Lazy.withinView();
    }, 100));
    return Lazy;
}
function $5137c3620ef83169$var$Anchors(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    /**
   * Holds detaching status of anchors.
   * Prevents detaching of already detached anchors.
   *
   * @private
   * @type {Boolean}
   */ var detached = false;
    /**
   * Holds preventing status of anchors.
   * If `true` redirection after click will be disabled.
   *
   * @private
   * @type {Boolean}
   */ var prevented = false;
    var Anchors = {
        /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */ mount: function mount() {
            /**
       * Holds collection of anchors elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._a = Components.Html.wrapper.querySelectorAll("a");
            this.bind();
        },
        /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("click", Components.Html.wrapper, this.click);
        },
        /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("click", Components.Html.wrapper);
        },
        /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */ click: function click(event) {
            if (prevented) {
                event.stopPropagation();
                event.preventDefault();
            }
        },
        /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */ detach: function detach() {
            prevented = true;
            if (!detached) {
                for(var i = 0; i < this.items.length; i++)this.items[i].draggable = false;
                detached = true;
            }
            return this;
        },
        /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */ attach: function attach() {
            prevented = false;
            if (detached) {
                for(var i = 0; i < this.items.length; i++)this.items[i].draggable = true;
                detached = false;
            }
            return this;
        }
    };
    $5137c3620ef83169$var$define(Anchors, "items", {
        /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */ get: function get() {
            return Anchors._a;
        }
    });
    /**
   * Detach anchors inside slides:
   * - on swiping, so they won't redirect to its `href` attributes
   */ Events.on("swipe.move", function() {
        Anchors.detach();
    });
    /**
   * Attach anchors inside slides:
   * - after swiping and transitions ends, so they can redirect after click again
   */ Events.on("swipe.end", function() {
        Components.Transition.after(function() {
            Anchors.attach();
        });
    });
    /**
   * Unbind anchors inside slides:
   * - on destroying, to bring anchors to its initial state
   */ Events.on("destroy", function() {
        Anchors.attach();
        Anchors.unbind();
        Binder.destroy();
    });
    return Anchors;
}
var $5137c3620ef83169$var$NAV_SELECTOR = '[data-glide-el="controls[nav]"]';
var $5137c3620ef83169$var$CONTROLS_SELECTOR = '[data-glide-el^="controls"]';
var $5137c3620ef83169$var$PREVIOUS_CONTROLS_SELECTOR = "".concat($5137c3620ef83169$var$CONTROLS_SELECTOR, ' [data-glide-dir*="<"]');
var $5137c3620ef83169$var$NEXT_CONTROLS_SELECTOR = "".concat($5137c3620ef83169$var$CONTROLS_SELECTOR, ' [data-glide-dir*=">"]');
function $5137c3620ef83169$var$Controls(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    var capture = $5137c3620ef83169$var$supportsPassive$1 ? {
        passive: true
    } : false;
    var Controls = {
        /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */ mount: function mount() {
            /**
       * Collection of navigation HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._n = Components.Html.root.querySelectorAll($5137c3620ef83169$var$NAV_SELECTOR);
            /**
       * Collection of controls HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._c = Components.Html.root.querySelectorAll($5137c3620ef83169$var$CONTROLS_SELECTOR);
            /**
       * Collection of arrow control HTML elements.
       *
       * @private
       * @type {Object}
       */ this._arrowControls = {
                previous: Components.Html.root.querySelectorAll($5137c3620ef83169$var$PREVIOUS_CONTROLS_SELECTOR),
                next: Components.Html.root.querySelectorAll($5137c3620ef83169$var$NEXT_CONTROLS_SELECTOR)
            };
            this.addBindings();
        },
        /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */ setActive: function setActive() {
            for(var i = 0; i < this._n.length; i++)this.addClass(this._n[i].children);
        },
        /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */ removeActive: function removeActive() {
            for(var i = 0; i < this._n.length; i++)this.removeClass(this._n[i].children);
        },
        /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */ addClass: function addClass(controls) {
            var settings = Glide.settings;
            var item = controls[Glide.index];
            if (!item) return;
            if (item) {
                item.classList.add(settings.classes.nav.active);
                $5137c3620ef83169$var$siblings(item).forEach(function(sibling) {
                    sibling.classList.remove(settings.classes.nav.active);
                });
            }
        },
        /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */ removeClass: function removeClass(controls) {
            var item = controls[Glide.index];
            if (item) item.classList.remove(Glide.settings.classes.nav.active);
        },
        /**
     * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
     */ setArrowState: function setArrowState() {
            if (Glide.settings.rewind) return;
            var next = Controls._arrowControls.next;
            var previous = Controls._arrowControls.previous;
            this.resetArrowState(next, previous);
            if (Glide.index === 0) this.disableArrow(previous);
            if (Glide.index === Components.Run.length) this.disableArrow(next);
        },
        /**
     * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
     *
     * @param {NodeList[]} lists
     */ resetArrowState: function resetArrowState() {
            var settings = Glide.settings;
            for(var _len = arguments.length, lists = new Array(_len), _key = 0; _key < _len; _key++)lists[_key] = arguments[_key];
            lists.forEach(function(list) {
                $5137c3620ef83169$var$toArray(list).forEach(function(element) {
                    element.classList.remove(settings.classes.arrow.disabled);
                });
            });
        },
        /**
     * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
     *
     * @param {NodeList[]} lists
     */ disableArrow: function disableArrow() {
            var settings = Glide.settings;
            for(var _len2 = arguments.length, lists = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)lists[_key2] = arguments[_key2];
            lists.forEach(function(list) {
                $5137c3620ef83169$var$toArray(list).forEach(function(element) {
                    element.classList.add(settings.classes.arrow.disabled);
                });
            });
        },
        /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */ addBindings: function addBindings() {
            for(var i = 0; i < this._c.length; i++)this.bind(this._c[i].children);
        },
        /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */ removeBindings: function removeBindings() {
            for(var i = 0; i < this._c.length; i++)this.unbind(this._c[i].children);
        },
        /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */ bind: function bind(elements) {
            for(var i = 0; i < elements.length; i++){
                Binder.on("click", elements[i], this.click);
                Binder.on("touchstart", elements[i], this.click, capture);
            }
        },
        /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */ unbind: function unbind(elements) {
            for(var i = 0; i < elements.length; i++)Binder.off([
                "click",
                "touchstart"
            ], elements[i]);
        },
        /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in direction given via the
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {void}
     */ click: function click(event) {
            if (!$5137c3620ef83169$var$supportsPassive$1 && event.type === "touchstart") event.preventDefault();
            var direction = event.currentTarget.getAttribute("data-glide-dir");
            Components.Run.make(Components.Direction.resolve(direction));
        }
    };
    $5137c3620ef83169$var$define(Controls, "items", {
        /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */ get: function get() {
            return Controls._c;
        }
    });
    /**
   * Swap active class of current navigation item:
   * - after mounting to set it to initial index
   * - after each move to the new index
   */ Events.on([
        "mount.after",
        "move.after"
    ], function() {
        Controls.setActive();
    });
    /**
   * Add or remove disabled class of arrow elements
   */ Events.on([
        "mount.after",
        "run"
    ], function() {
        Controls.setArrowState();
    });
    /**
   * Remove bindings and HTML Classes:
   * - on destroying, to bring markup to its initial state
   */ Events.on("destroy", function() {
        Controls.removeBindings();
        Controls.removeActive();
        Binder.destroy();
    });
    return Controls;
}
function $5137c3620ef83169$var$Keyboard(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    var Keyboard = {
        /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */ mount: function mount() {
            if (Glide.settings.keyboard) this.bind();
        },
        /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("keyup", document, this.press);
        },
        /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("keyup", document);
        },
        /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */ press: function press(event) {
            var perSwipe = Glide.settings.perSwipe;
            if (event.code === "ArrowRight") Components.Run.make(Components.Direction.resolve("".concat(perSwipe, ">")));
            if (event.code === "ArrowLeft") Components.Run.make(Components.Direction.resolve("".concat(perSwipe, "<")));
        }
    };
    /**
   * Remove bindings from keyboard:
   * - on destroying to remove added events
   * - on updating to remove events before remounting
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Keyboard.unbind();
    });
    /**
   * Remount component
   * - on updating to reflect potential changes in settings
   */ Events.on("update", function() {
        Keyboard.mount();
    });
    /**
   * Destroy binder:
   * - on destroying to remove listeners
   */ Events.on("destroy", function() {
        Binder.destroy();
    });
    return Keyboard;
}
function $5137c3620ef83169$var$Autoplay(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    var Autoplay = {
        /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */ mount: function mount() {
            this.enable();
            this.start();
            if (Glide.settings.hoverpause) this.bind();
        },
        /**
     * Enables autoplaying
     *
     * @returns {Void}
     */ enable: function enable() {
            this._e = true;
        },
        /**
     * Disables autoplaying.
     *
     * @returns {Void}
     */ disable: function disable() {
            this._e = false;
        },
        /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */ start: function start() {
            var _this = this;
            if (!this._e) return;
            this.enable();
            if (Glide.settings.autoplay) {
                if ($5137c3620ef83169$var$isUndefined(this._i)) this._i = setInterval(function() {
                    _this.stop();
                    Components.Run.make(">");
                    _this.start();
                    Events.emit("autoplay");
                }, this.time);
            }
        },
        /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */ stop: function stop() {
            this._i = clearInterval(this._i);
        },
        /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */ bind: function bind() {
            var _this2 = this;
            Binder.on("mouseover", Components.Html.root, function() {
                if (_this2._e) _this2.stop();
            });
            Binder.on("mouseout", Components.Html.root, function() {
                if (_this2._e) _this2.start();
            });
        },
        /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */ unbind: function unbind() {
            Binder.off([
                "mouseover",
                "mouseout"
            ], Components.Html.root);
        }
    };
    $5137c3620ef83169$var$define(Autoplay, "time", {
        /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */ get: function get() {
            var autoplay = Components.Html.slides[Glide.index].getAttribute("data-glide-autoplay");
            if (autoplay) return $5137c3620ef83169$var$toInt(autoplay);
            return $5137c3620ef83169$var$toInt(Glide.settings.autoplay);
        }
    });
    /**
   * Stop autoplaying and unbind events:
   * - on destroying, to clear defined interval
   * - on updating via API to reset interval that may changed
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Autoplay.unbind();
    });
    /**
   * Stop autoplaying:
   * - before each run, to restart autoplaying
   * - on pausing via API
   * - on destroying, to clear defined interval
   * - while starting a swipe
   * - on updating via API to reset interval that may changed
   */ Events.on([
        "run.before",
        "swipe.start",
        "update"
    ], function() {
        Autoplay.stop();
    });
    Events.on([
        "pause",
        "destroy"
    ], function() {
        Autoplay.disable();
        Autoplay.stop();
    });
    /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */ Events.on([
        "run.after",
        "swipe.end"
    ], function() {
        Autoplay.start();
    });
    /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */ Events.on([
        "play"
    ], function() {
        Autoplay.enable();
        Autoplay.start();
    });
    /**
   * Remount autoplaying:
   * - on updating via API to reset interval that may changed
   */ Events.on("update", function() {
        Autoplay.mount();
    });
    /**
   * Destroy a binder:
   * - on destroying glide instance to clearup listeners
   */ Events.on("destroy", function() {
        Binder.destroy();
    });
    return Autoplay;
}
/**
 * Sorts keys of breakpoint object so they will be ordered from lower to bigger.
 *
 * @param {Object} points
 * @returns {Object}
 */ function $5137c3620ef83169$var$sortBreakpoints(points) {
    if ($5137c3620ef83169$var$isObject(points)) return $5137c3620ef83169$var$sortKeys(points);
    else $5137c3620ef83169$var$warn("Breakpoints option must be an object");
    return {};
}
function $5137c3620ef83169$var$Breakpoints(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $5137c3620ef83169$var$EventsBinder();
    /**
   * Holds reference to settings.
   *
   * @type {Object}
   */ var settings = Glide.settings;
    /**
   * Holds reference to breakpoints object in settings. Sorts breakpoints
   * from smaller to larger. It is required in order to proper
   * matching currently active breakpoint settings.
   *
   * @type {Object}
   */ var points = $5137c3620ef83169$var$sortBreakpoints(settings.breakpoints);
    /**
   * Cache initial settings before overwritting.
   *
   * @type {Object}
   */ var defaults = Object.assign({}, settings);
    var Breakpoints = {
        /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */ match: function match(points) {
            if (typeof window.matchMedia !== "undefined") {
                for(var point in points)if (points.hasOwnProperty(point)) {
                    if (window.matchMedia("(max-width: ".concat(point, "px)")).matches) return points[point];
                }
            }
            return defaults;
        }
    };
    /**
   * Overwrite instance settings with currently matching breakpoint settings.
   * This happens right after component initialization.
   */ Object.assign(settings, Breakpoints.match(points));
    /**
   * Update glide with settings of matched brekpoint:
   * - window resize to update slider
   */ Binder.on("resize", window, $5137c3620ef83169$var$throttle(function() {
        Glide.settings = $5137c3620ef83169$var$mergeOptions(settings, Breakpoints.match(points));
    }, Glide.settings.throttle));
    /**
   * Resort and update default settings:
   * - on reinit via API, so breakpoint matching will be performed with options
   */ Events.on("update", function() {
        points = $5137c3620ef83169$var$sortBreakpoints(points);
        defaults = Object.assign({}, settings);
    });
    /**
   * Unbind resize listener:
   * - on destroying, to bring markup to its initial state
   */ Events.on("destroy", function() {
        Binder.off("resize", window);
    });
    return Breakpoints;
}
var $5137c3620ef83169$var$COMPONENTS = {
    // Required
    Html: $5137c3620ef83169$var$Html,
    Translate: $5137c3620ef83169$var$Translate,
    Transition: $5137c3620ef83169$var$Transition,
    Direction: $5137c3620ef83169$var$Direction,
    Peek: $5137c3620ef83169$var$Peek,
    Sizes: $5137c3620ef83169$var$Sizes,
    Gaps: $5137c3620ef83169$var$Gaps,
    Move: $5137c3620ef83169$var$Move,
    Clones: $5137c3620ef83169$var$Clones,
    Resize: $5137c3620ef83169$var$Resize,
    Build: $5137c3620ef83169$var$Build,
    Run: $5137c3620ef83169$var$Run,
    // Optional
    Swipe: $5137c3620ef83169$var$Swipe,
    Images: $5137c3620ef83169$var$Images,
    Anchors: $5137c3620ef83169$var$Anchors,
    Controls: $5137c3620ef83169$var$Controls,
    Keyboard: $5137c3620ef83169$var$Keyboard,
    Autoplay: $5137c3620ef83169$var$Autoplay,
    Breakpoints: $5137c3620ef83169$var$Breakpoints,
    Lazy: $5137c3620ef83169$var$Lazy
};
var $5137c3620ef83169$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Core) {
    $5137c3620ef83169$var$_inherits(Glide, _Core);
    var _super = $5137c3620ef83169$var$_createSuper(Glide);
    function Glide() {
        $5137c3620ef83169$var$_classCallCheck(this, Glide);
        return _super.apply(this, arguments);
    }
    $5137c3620ef83169$var$_createClass(Glide, [
        {
            key: "mount",
            value: function mount() {
                var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return $5137c3620ef83169$var$_get($5137c3620ef83169$var$_getPrototypeOf(Glide.prototype), "mount", this).call(this, Object.assign({}, $5137c3620ef83169$var$COMPONENTS, extensions));
            }
        }
    ]);
    return Glide;
}($5137c3620ef83169$var$Glide$1);


// GLIDE
if (document.querySelector(".glide")) {
    const config = {
        type: "carousel",
        perView: 3,
        focusAt: "center",
        gap: 24,
        autoplay: 3000,
        hoverpause: true,
        breakpoints: {
            1200: {
                perView: 3
            },
            992: {
                perView: 3
            },
            768: {
                perView: 2
            },
            576: {
                perView: 1.5
            }
        }
    };
    new (0, $5137c3620ef83169$export$2e2bcd8739ae039)(".glide", config).mount();
}
if (document.querySelector(".glide_testimonials")) {
    const config = {
        type: "carousel",
        perView: 3,
        focusAt: "center",
        gap: 24,
        autoplay: 3000,
        hoverpause: true,
        breakpoints: {
            1200: {
                perView: 3
            },
            992: {
                perView: 3
            },
            768: {
                perView: 2
            },
            576: {
                perView: 1.5
            }
        }
    };
    new (0, $5137c3620ef83169$export$2e2bcd8739ae039)(".glide_testimonials", config).mount();
}
// JS Translation
const $05556e7da27e597b$var$nextBtn = document.querySelectorAll(".ld-content-action");
if ($05556e7da27e597b$var$nextBtn) $05556e7da27e597b$var$nextBtn.forEach((btn)=>{
    const nextBtnText = btn.querySelectorAll(".ld-text");
    const backBtn = btn.querySelectorAll(".ld-course-step-back");
    nextBtnText.forEach((text)=>{
        if (text.textContent === "Next Zagadnienie") text.textContent = "Nast\u0119pne";
        if (text.textContent === "Previous Zagadnienie") text.textContent = "Poprzednie";
    });
    backBtn.forEach((text)=>{
        if (text.textContent === "Back to Szkolenie") text.textContent = "Powr\xf3t";
    });
    // const markCompleteBtn = document.querySelectorAll(
    //     ".learndash_mark_complete_button"
    // )
    // markCompleteBtn.forEach(btn => {
    //     btn.textContent = "Ukończone"
    // })
    // const markIncompleteBtn = document.querySelectorAll(
    //     ".learndash_mark_incomplete_button"
    // )
    // markIncompleteBtn.forEach(btn => {
    //     btn.textContent = "Nieukończone"
    // })
    const statusBtn = document.querySelectorAll(".ld-status-progress");
    statusBtn.forEach((btn)=>{
        if (btn.textContent === "In Progress") btn.textContent = "W trakcie";
    });
    const completeBtn = document.querySelectorAll(".ld-status-complete");
    completeBtn.forEach((btn)=>{
        if (btn.textContent === "Complete") btn.textContent = "Uko\u0144czono";
    });
});
const $05556e7da27e597b$var$progressBar = document.querySelector(".ld-progress-wrap");
if ($05556e7da27e597b$var$progressBar) {
    const statusText = $05556e7da27e597b$var$progressBar.querySelector(".ld-progress-percentage");
    const status = statusText.textContent.split(" ");
    status[1] = "Uko\u0144czono";
    statusText.textContent = status.join(" ");
    const progresSteps = $05556e7da27e597b$var$progressBar.querySelector(".ld-progress-steps");
    const steps = progresSteps.textContent.split(" ");
    steps[1] = "Krok\xf3w";
    progresSteps.textContent = steps.join(" ");
}
const $05556e7da27e597b$var$mainprogressBar = document.querySelector(".ld-progress-stats");
if ($05556e7da27e597b$var$mainprogressBar) {
    const progressText = $05556e7da27e597b$var$mainprogressBar.querySelector(".ld-progress-percentage");
    const progress = progressText.textContent.split(" ");
    progress[1] = "Uko\u0144czono";
    progressText.textContent = progress.join(" ");
    const progressSteps = $05556e7da27e597b$var$mainprogressBar.querySelector(".ld-progress-steps");
    const steps = progressSteps.textContent.split(" ");
    steps[0] = "Ostatnia";
    steps[1] = "aktywno\u015B\u0107:";
    steps[2] = "";
    progressSteps.textContent = steps.join(" ");
}

})();
//# sourceMappingURL=index.js.map
